const ASSETS = window.PAHADAN_ASSETS;

    // ============================================================================
    // COMPLETE 11-SKU PRODUCT MASTER (IMPLEMENTED FROM Pahadans_Farm_New_MRPs_and_Bundles.xlsx)
    // ============================================================================
    const PRODUCTS = [
      {
        sku: "PF-GHEE-1000",
        officialSku: "TPFGHEE01000",
        title: "Himachali Cow Desi Bilona Ghee — 1000ml (1L)",
        shortTitle: "Bilona Ghee 1000ml (1L)",
        category: "Ghee",
        isTrial: false,
        size: "1L / 1000 ml (Family Glass Jar)",
        dimensions: "Height: 18 cm × Diameter: 11 cm · Net Weight: 1L (905g*)",
        netQty: 1000,
        unit: "ml",
        mrp: 1999,
        price: 1749,
        inStock: true,
        stockNote: "Fresh Drahal Batch · Ready for Dispatch",
        badge: "Flagship 1L Bestseller",
        imageKey: "GHEE_1_HERO",
        gallery: [
          { key: "GHEE_1_HERO", caption: "1L Glass Jar — 100% Pure Cow Desi Bilona Ghee (Hand-Churned by Dadi & Tai)" },
          { key: "GHEE_2_BENEFITS", caption: "Sunlit Mountain Courtyard — Farm Fresh Himachali Cow Desi Bilona Ghee" },
          { key: "GHEE_3_DIM", caption: "Jar Dimensions — Height: 18 cm × Diameter: 10–11 cm · Net Volume: 1L (905g*)" },
          { key: "GHEE_4_COMPARISON", caption: "Hand-Crafted Purity from Himalayan Mountain Farms — Dadi Ji & Pahadi Cow" },
          { key: "GHEE_5_PROCESS", caption: "Traditional Care, Direct from Himalayan Village Farms" },
          { key: "GHEE_6_MOTTO", caption: "Brand Motto — 'Health is Compulsory, Not a Choice'" },
          { key: "GHEE_7_REVIEWS", caption: "Loved by Hundreds of Conscious Families — Verified Buyer Reviews" }
        ],
        origin: "Village Drahal, Joginder Nagar, Distt. Mandi (H.P. 175015)",
        summary: "100% Pure Cow Desi Bilona Ghee handcrafted from free-grazing Pahadi cow A2 milk—boiled on slow firewood, set into curd in clay pots, and hand-churned with a wooden bilona.",
        ingredients: "100% Cultured Free-Grazing Himachali Cow Milk Fat (Curd-Churned Wooden Bilona Method). Zero additives, zero preservatives, zero artificial colors.",
        allergenNote: "Contains Milk / Dairy Fat. Lactose & casein trace-free due to traditional curd fermentation and slow clarification.",
        claims: ["100% Pure & Lab Tested", "Traditional Wooden Bilona", "No Middlemen, Honest Pricing"],
        storage: "Store in a cool, dry cupboard away from direct sunlight. Always use a clean, dry spoon. No refrigeration required.",
        shelfLife: "Best Before 12 Months from Manufacturing",
        pairings: "Drizzle hot over phulkas, makki ki roti, dal-chawal, khichdi, or use for high-smoke-point Ayurvedic tadka.",
        crossSellSku: "PF-ACH-PG500",
        batchCode: "DRH-2610-GH",
        nutritionPer100: {
          servingSize: "10ml (100 Servings per 1L Jar)",
          rows: [
            ["Energy", "897 kcal", "4.5%"],
            ["Total Fat (Milk Fat)", "99.7 g", "14.8%"],
            ["Saturated Fat (Short & Medium Chain)", "62.4 g", "—"],
            ["Butyric Acid & CLA", "Naturally Rich", "—"],
            ["Carbohydrate / Total Sugar", "0 g", "0%"],
            ["Protein", "0 g", "0%"],
            ["Trans Fat (Industrial)", "0 g", "0%"],
            ["Vitamins A, D, E & K", "Naturally Present", "—"]
          ]
        },
        categoryMeta: {
          method: "4-Step Traditional Dahi-Bilona Process on Slow Firewood",
          texture: "Rich Granular (Daanedaar) · Golden Amber Aroma",
          milkSource: "Free-grazing Pahadi cows in Village Drahal, Mandi, H.P.",
          labHighlights: "RM Value > 29 · FSSAI Lic. #23326011006238 · GST 5% Included in MRP ₹1,999"
        }
      },
      {
        sku: "PF-GHEE-500",
        officialSku: "TPFGHEE0500",
        title: "Himachali Cow Desi Bilona Ghee — 500ml",
        shortTitle: "Bilona Ghee 500ml",
        category: "Ghee",
        isTrial: false,
        size: "500 ml (Standard Glass Jar)",
        dimensions: "Height: 14 cm × Diameter: 9 cm · Net Weight: 500ml",
        netQty: 500,
        unit: "ml",
        mrp: 1099,
        price: 949,
        inStock: true,
        stockNote: "In Stock · Featured in Pahadi Thali Box & Wellness Duo",
        badge: "Most Reordered Size",
        imageKey: "GHEE_2_BENEFITS",
        gallery: [
          { key: "GHEE_2_BENEFITS", caption: "Himachali Cow Desi Bilona Ghee — Hand-Churned by Dadi & Tai" },
          { key: "GHEE_1_HERO", caption: "100% Pure Cow Desi Bilona Ghee Jar & Wooden Bilona" },
          { key: "GHEE_5_PROCESS", caption: "Traditional Care, Direct from Himalayan Village Farms" },
          { key: "GHEE_4_COMPARISON", caption: "Hand-Crafted Purity from Himalayan Mountain Farms" },
          { key: "GHEE_7_REVIEWS", caption: "What Indian Families Are Saying" },
          { key: "GHEE_6_MOTTO", caption: "Health is Compulsory, Not a Choice" }
        ],
        origin: "Village Drahal, Joginder Nagar, Distt. Mandi (H.P. 175015)",
        summary: "Our everyday 500ml glass jar of curd-churned Himachali Cow Desi Bilona Ghee, crafted in small batches under Dadi Ji’s supervision.",
        ingredients: "100% Cultured Himachali Cow Milk Fat (Curd-Churned Bilona Method).",
        allergenNote: "Contains Milk Fat.",
        claims: ["100% Pure & Lab Tested", "Traditional Bilona Method", "Empowering Women Farmers"],
        storage: "Keep tightly closed in a dry cupboard. Use a dry spoon every time.",
        shelfLife: "Best Before 12 Months from Manufacturing",
        pairings: "Ideal monthly size for 2–3 member households; pairs naturally with Barot Special Pink Garlic Pickle.",
        crossSellSku: "PF-ACH-PG200T",
        batchCode: "DRH-2610-GH",
        nutritionPer100: {
          servingSize: "10ml (50 Servings per 500ml Jar)",
          rows: [
            ["Energy", "897 kcal", "4.5%"],
            ["Total Fat (Milk Fat)", "99.7 g", "14.8%"],
            ["Saturated Fat", "62.4 g", "—"],
            ["Carbohydrate / Total Sugar", "0 g", "0%"],
            ["Trans Fat", "0 g", "0%"]
          ]
        },
        categoryMeta: {
          method: "4-Step Traditional Dahi-Bilona Process",
          texture: "Rich Granular (Daanedaar) · Nutty Aroma",
          milkSource: "Free-grazing Himachali cows from Drahal neighbor families",
          labHighlights: "RM Value > 29 · Moisture < 0.3% · FSSAI #23326011006238"
        }
      },
      {
        sku: "PF-GHEE-250T",
        officialSku: "TPFGHEE0250",
        title: "Himachali Cow Desi Ghee (Trial Pack, 250ml)",
        shortTitle: "Bilona Ghee 250ml Trial",
        category: "Ghee",
        isTrial: true,
        size: "250 ml (Starter Glass Jar)",
        dimensions: "Height: 10.5 cm × Diameter: 7.5 cm · Net Weight: 250ml",
        netQty: 250,
        unit: "ml",
        mrp: 649,
        price: 549,
        inStock: true,
        stockNote: "In Stock · Ideal First Taste of Bilona Ghee",
        badge: "₹549 Starter Trial Pack",
        imageKey: "GHEE_5_PROCESS",
        gallery: [
          { key: "GHEE_5_PROCESS", caption: "4-Step Traditional Bilona Process" },
          { key: "GHEE_1_HERO", caption: "100% Pure Cow Desi Bilona Ghee" },
          { key: "GHEE_2_BENEFITS", caption: "Sunlit Mountain Courtyard Ghee Jar" },
          { key: "GHEE_7_REVIEWS", caption: "Verified Indian Family Reviews" }
        ],
        origin: "Village Drahal, Joginder Nagar (H.P. 175015)",
        summary: "A spoonful of the hills for first-time tasters. Experience true curd-churned Himachali Bilona aroma in a 250ml glass jar—or step up to the 500ml jar in the Ghee & Honey Wellness Duo (₹1,299 with Free Shipping).",
        ingredients: "100% Cultured Himachali Cow Milk Fat (Curd-Churned Bilona Method).",
        allergenNote: "Contains Milk Fat.",
        claims: ["100% Pure & Lab Tested", "Starter Tasting Jar", "Traditional Bilona"],
        storage: "Store in a cool, dry place. Use a clean, dry spoon.",
        shelfLife: "Best Before 12 Months from Manufacturing",
        pairings: "Starter tasting jar — pair with 250g Wild Forest Honey or a 200g Starter Achaar.",
        crossSellSku: "PF-HON-WF250",
        batchCode: "DRH-2610-GH",
        nutritionPer100: {
          servingSize: "10ml (25 Servings per 250ml Jar)",
          rows: [
            ["Energy", "897 kcal", "4.5%"],
            ["Total Fat (Milk Fat)", "99.7 g", "14.8%"],
            ["Carbohydrate / Sugar", "0 g", "0%"]
          ]
        },
        categoryMeta: {
          method: "4-Step Traditional Dahi-Bilona Process",
          texture: "Rich Granular (Daanedaar)",
          milkSource: "Free-grazing Himachali cows",
          labHighlights: "Free Pan-India Shipping on orders of ₹499+"
        }
      },
      {
        sku: "PF-ACH-PG500",
        officialSku: "TPFBGPICKLE0500",
        title: "Barot Special Pink Garlic Homemade Pickle — 500g",
        shortTitle: "Barot Pink Garlic Pickle 500g",
        category: "Aachar",
        isTrial: false,
        size: "500 g (Family Glass Jar)",
        dimensions: "Height: 12.5 cm × Diameter: 8.5 cm · Net Weight: 500g",
        netQty: 500,
        unit: "g",
        mrp: 699,
        price: 599,
        inStock: true,
        stockNote: "In Stock · ~39 kg Batch Ledger Available",
        badge: "Rare Barot Valley Harvest",
        imageKey: "GP200_1_HERO",
        gallery: [
          { key: "GP200_1_HERO", caption: "Barot Special Pink Garlic — Handcrafted with Barot Pink Garlic & Whole Spices" },
          { key: "GP200_2_SERVING", caption: "Bringing the Warmth of Himalayan Homes to Yours — Barot Special Pink Garlic" },
          { key: "GP200_3_BATCHES", caption: "Handmade in Small Batches • Slow Sun-Cured on Himalayan Terraces" },
          { key: "GP200_6_DIM", caption: "Compact & Family Glass Jars · Sealed for Freshness" },
          { key: "GP200_7_MOTTO", caption: "Health is Compulsory, Not a Choice — Rare Barot Pink Garlic" }
        ],
        origin: "Barot Valley & Village Drahal, Distt. Mandi (H.P. 175015)",
        summary: "Pungent, single-origin Himalayan pink garlic cloves sourced from Barot Valley, marinated in cold-pressed mustard oil, jaggery, and 11 whole roasted spices, and slow sun-cured on Himalayan terraces.",
        ingredients: "Garlic, Mustard Oil, Jaggery, Vinegar, Salt, Yellow Mustard Seeds (Rai), Fennel Seeds (Saunf), Fenugreek Seeds (Methi), Nigella Seeds (Kalonji), Black Sesame Seeds (Til), Red Chilli, Deggi Mirch, Turmeric Powder, Carom Seeds (Ajwain) and Asafoetida (Hing).",
        allergenNote: "Contains Mustard, Sesame (Til) and Asafoetida (Hing).",
        claims: ["No Premixes Added", "No Preservatives", "No Artificial Colors"],
        storage: "Shake well before serving. Keep in a cool, dry place and always use a clean, dry spoon.",
        shelfLife: "Best Before 24 Months from Manufacturing",
        pairings: "Unbeatable alongside makki ki roti & sarson ka saag, stuffed parathas, hot dal-chawal, or siddu.",
        crossSellSku: "PF-GHEE-1000",
        batchCode: "BAR-2610-PG",
        nutritionPer100: {
          servingSize: "10g (50 Servings per Pack)",
          rows: [
            ["Energy", "250 kcal", "1.25%"],
            ["Protein", "4 g", "—"],
            ["Carbohydrate", "12 g", "—"],
            ["Total Sugars", "5 g", "—"],
            ["Dietary Fibre", "3 g", "—"],
            ["Total Fat", "22 g", "3.28%"],
            ["Saturated Fat", "3 g", "1.36%"],
            ["Trans Fat", "0 g", "—"],
            ["Cholesterol", "0 mg", "0%"],
            ["Sodium", "1800 mg", "9.00%"]
          ]
        },
        categoryMeta: {
          spiceLevel: "Medium-Bold Warmth & Savoury Tang (3.5 / 5)",
          oilProfile: "100% Cold-Pressed Mustard Oil (Kachi Ghani)",
          curingMethod: "Slow sun-cured on Himalayan terraces by Drahal women farmers",
          keyIngredient: "Rare High-Altitude Barot Valley Pink Garlic + 11 Whole Spices"
        }
      },
      {
        sku: "PF-ACH-PG200T",
        officialSku: "TPFBGPICKLE0200",
        title: "Barot Special Pink Garlic Homemade Pickle — 200g (Trial Pack)",
        shortTitle: "Barot Pink Garlic Pickle 200g",
        category: "Aachar",
        isTrial: true,
        size: "200 g (Sealed Glass Jar)",
        dimensions: "Height: 8.5 cm × Diameter: 7 cm · Net Weight: 200g",
        netQty: 200,
        unit: "g",
        mrp: 379,
        price: 319,
        inStock: true,
        stockNote: "In Stock · Featured in Mini Achaar Duo (₹499)",
        badge: "₹319 Starter Jar",
        imageKey: "GP200_1_HERO",
        gallery: [
          { key: "GP200_1_HERO", caption: "Hero Jar — Barot Special Pink Garlic 200g with Kraft Tag & Fresh Pink Garlic Bulbs" },
          { key: "GP200_2_SERVING", caption: "Culinary Serving — 'Bringing the warmth of Himalayan homes to yours'" },
          { key: "GP200_3_BATCHES", caption: "Artisan Craft — 'Handmade in Small Batches • Slow Sun-Cured on Himalayan Terraces'" },
          { key: "GP200_6_DIM", caption: "Exact Jar Dimensions — Height: 8.5 cm × Diameter: 7 cm · Net Weight: 200g" },
          { key: "GP200_7_MOTTO", caption: "Brand Motto — 'Health is Compulsory, Not a Choice'" }
        ],
        origin: "Barot Valley & Village Drahal, Distt. Mandi (H.P. 175015)",
        summary: "Experience our rare Barot Valley Pink Garlic Pickle in a 200g starter glass jar (8.5 cm × 7 cm). Handcrafted in small batches by Himachal women farmers with cold-pressed mustard oil and no premixes added.",
        ingredients: "Garlic, Mustard Oil, Jaggery, Vinegar, Salt, Yellow Mustard Seeds (Rai), Fennel Seeds (Saunf), Fenugreek Seeds (Methi), Nigella Seeds (Kalonji), Black Sesame Seeds (Til), Red Chilli, Deggi Mirch, Turmeric Powder, Carom Seeds (Ajwain) and Asafoetida (Hing).",
        allergenNote: "Contains Mustard, Sesame (Til) and Asafoetida (Hing).",
        claims: ["No Premixes Added", "No Preservatives", "No Artificial Colors"],
        storage: "Store in a cool, dry place. Always use a clean, dry spoon.",
        shelfLife: "Best Before 24 Months from Manufacturing",
        pairings: "Spoon over hot makki ki roti, parathas, or pair it with 200g Mango in the Mini Achaar Duo (₹499).",
        crossSellSku: "PF-GHEE-500",
        batchCode: "BAR-2610-PG",
        nutritionPer100: {
          servingSize: "10g (Serving Per Pack: 20)",
          rows: [
            ["Energy", "250 kcal", "1.25%"],
            ["Protein", "4 g", "—"],
            ["Carbohydrate", "12 g", "—"],
            ["Total Sugars", "5 g", "—"],
            ["Dietary Fibre", "3 g", "—"],
            ["Total Fat", "22 g", "3.28%"],
            ["Saturated Fat", "3 g", "1.36%"],
            ["Trans Fat", "0 g", "—"],
            ["Cholesterol", "0 mg", "0%"],
            ["Sodium", "1800 mg", "9.00%"]
          ]
        },
        categoryMeta: {
          spiceLevel: "Medium-Bold Warmth (3.5 / 5)",
          oilProfile: "100% Cold-Pressed Mustard Oil",
          curingMethod: "Slow sun-cured on Himalayan terraces",
          keyIngredient: "Rare Barot Valley Pink Garlic (8.5cm × 7cm Jar)"
        }
      },
      {
        sku: "PF-ACH-AM500",
        officialSku: "TPFFAPICKLE0500",
        title: "Himalayan Forest Amla Pickle — 500g",
        shortTitle: "Forest Amla Pickle 500g",
        category: "Aachar",
        isTrial: false,
        size: "500 g (Sealed Glass Jar)",
        dimensions: "Height: 12.5 cm × Diameter: 8.5 cm · Net Weight: 500g",
        netQty: 500,
        unit: "g",
        mrp: 599,
        price: 499,
        inStock: true,
        stockNote: "Limited Batch (~35 × 500g jars in current 17.7 kg ledger)",
        badge: "100% Himalayan Forest Amla · 0% Pesticides",
        imageKey: "AM500_1_HERO",
        gallery: [
          { key: "AM500_1_HERO", caption: "Hero Jar — Himalayan Forest Amla Pickle 500g (Pahadan Made Fresh Pickle)" },
          { key: "AM500_3_LABEL", caption: "Back Label Nutrition & Ingredients — 243 kcal / 100g · No Premixes Added" },
          { key: "AM500_4_DIM", caption: "Jar Dimensions — Height: 12.5 cm × Diameter: 8.5 cm · Net Weight: 500g" },
          { key: "AM500_5_MOTTO", caption: "Brand Motto — 'Health is Compulsory, Not a Choice' (100% Himalayan Forest Amla)" }
        ],
        origin: "Wild Himachal Forests & Village Drahal, Distt. Mandi (H.P. 175015)",
        summary: "Picked from wild Himalayan forests untouched by chemicals or pollution. Handcrafted by Pahadan women with cold-pressed mustard oil, methi, saunf, kalonji, and no premixes added.",
        ingredients: "Wild Amla, Mustard Oil, Iodised Salt, Fenugreek Seeds, Fennel Seeds, Mustard Seeds, Turmeric, Red Chilli Powder, Nigella Seeds (Kalonji), Natural Spices.",
        allergenNote: "Contains mustard. Processed in a facility that may also handle other spices.",
        claims: ["No Premixes Added", "No Preservatives", "No Artificial Colors"],
        storage: "Always use a clean, dry spoon. Keep the jar tightly closed after every use. Store in a cool, dry place away from direct sunlight. Stir occasionally so the spices coat every piece evenly.",
        shelfLife: "Best Before 24 Months from Manufacturing",
        pairings: "Daily Vitamin-C & digestive companion alongside dal-chawal, rotis, or breakfast parathas.",
        crossSellSku: "PF-HON-WF650",
        batchCode: "DRH-2610-AM",
        nutritionPer100: {
          servingSize: "10g (Serving Per Pack: 50)",
          rows: [
            ["Energy", "243 kcal", "—"],
            ["Protein", "2.6 g", "—"],
            ["Carbohydrate", "16.6 g", "—"],
            ["Total Sugar", "3.2 g", "—"],
            ["Total Fat", "18.5 g", "—"],
            ["Saturated Fat", "2.1 g", "—"],
            ["Trans Fat", "0 g", "0%"],
            ["Sodium", "638 mg", "—"]
          ]
        },
        categoryMeta: {
          spiceLevel: "Mild-Medium Tangy & Herbal (2.5 / 5)",
          oilProfile: "Cold-Pressed Mustard Oil (Balanced Low-Oil Recipe)",
          curingMethod: "Slow sun-cured to soften wild forest amla naturally",
          keyIngredient: "100% Himalayan Forest Amla (0% Pesticides · 12.5cm × 8.5cm Jar)"
        }
      },
      {
        sku: "PF-ACH-AM200T",
        officialSku: "TPFFAPICKLE0200",
        title: "Himalayan Forest Amla Pickle — 200g (Trial Pack)",
        shortTitle: "Forest Amla Pickle 200g Trial",
        category: "Aachar",
        isTrial: true,
        size: "200 g (Trial Glass Jar)",
        dimensions: "Height: 8.5 cm × Diameter: 7 cm · Net Weight: 200g",
        netQty: 200,
        unit: "g",
        mrp: 329,
        price: 275,
        inStock: true,
        stockNote: "In Stock · ₹275 Starter Trial Jar",
        badge: "₹275 Starter Trial Jar",
        imageKey: "AM500_4_DIM",
        gallery: [
          { key: "AM500_4_DIM", caption: "Himalayan Forest Amla Pickle — Pahadan Made Fresh Pickle" },
          { key: "AM500_1_HERO", caption: "Himalayan Forest Amla Studio Jar & Fresh Gooseberries" },
          { key: "AM500_3_LABEL", caption: "Back Label Nutrition & Ingredients (243 kcal / 100g · No Premixes Added)" },
          { key: "AM500_5_MOTTO", caption: "100% Himalayan Forest Amla · 0% Pesticides · Empowering Women Farmers" }
        ],
        origin: "Wild Himachal Forests & Village Drahal (H.P. 175015)",
        summary: "Try our wild forest amla pickle in a convenient 200g tasting jar. Handpicked mountain gooseberries sun-cured with balanced spices and zero chemical pesticides.",
        ingredients: "Wild Amla, Mustard Oil, Iodised Salt, Fenugreek Seeds, Fennel Seeds, Mustard Seeds, Turmeric, Red Chilli Powder, Nigella Seeds (Kalonji), Natural Spices.",
        allergenNote: "Contains mustard.",
        claims: ["No Premixes Added", "No Preservatives", "No Artificial Colors"],
        storage: "Use a clean, dry spoon. Keep lid tightly closed in a cool, dry place.",
        shelfLife: "Best Before 24 Months from Manufacturing",
        pairings: "Try it as a starter jar, or get the full 500g jar inside the Pahadan Gift Hamper (₹3,399).",
        crossSellSku: "PF-ACH-AM500",
        batchCode: "DRH-2610-AM",
        nutritionPer100: {
          servingSize: "10g (20 Servings per 200g Pack)",
          rows: [
            ["Energy", "243 kcal", "—"],
            ["Protein", "2.6 g", "—"],
            ["Carbohydrate", "16.6 g", "—"],
            ["Total Sugar", "3.2 g", "—"],
            ["Total Fat", "18.5 g", "—"],
            ["Saturated Fat", "2.1 g", "—"],
            ["Trans Fat", "0 g", "0%"],
            ["Sodium", "638 mg", "—"]
          ]
        },
        categoryMeta: {
          spiceLevel: "Mild-Medium Tangy (2.5 / 5)",
          oilProfile: "Cold-Pressed Mustard Oil",
          curingMethod: "Slow sun-cured by Pahadi women",
          keyIngredient: "Himalayan Forest Amlas from Himachal Pradesh"
        }
      },
      {
        sku: "PF-ACH-KM500",
        officialSku: "TPFDMPICKLE0500",
        title: "Desi Kaccha Mango Homemade Pickle — 500g",
        shortTitle: "Desi Kaccha Mango Pickle 500g",
        category: "Aachar",
        isTrial: false,
        size: "500 g (Sealed Glass Jar)",
        dimensions: "Height: 12.5 cm × Diameter: 8.5 cm · Net Weight: 500g",
        netQty: 500,
        unit: "g",
        mrp: 599,
        price: 499,
        inStock: true,
        stockNote: "In Stock · ~43 kg Batch Ledger Available",
        badge: "Dadi Ji's Heirloom Recipe",
        imageKey: "MANGO_AACHAR",
        gallery: [
          { key: "MANGO_AACHAR", caption: "Desi Kaccha Mango Homemade Pickle — Sun-Cured with Whole Spices" },
          { key: "PARATHA_THALI", caption: "Traditional Serving — Warm Paratha with Homemade Achaar & Bilona Ghee" },
          { key: "GP200_3_BATCHES", caption: "Handcrafted in Small Batches by Drahal Village Women" }
        ],
        origin: "Village Drahal, Joginder Nagar (H.P. 175015)",
        summary: "Handpicked raw desi mangoes sun-cured in small batches with cold-pressed mustard oil, Himalayan rock salt, and whole crushed spices—no premixes added.",
        ingredients: "Raw Desi Mango Chunks, Cold-Pressed Mustard Oil, Himalayan Rock Salt, Fennel Seeds (Saunf), Methi Dana, Kalonji, Turmeric, Kashmiri & Pahadi Mirch.",
        allergenNote: "Contains Mustard.",
        claims: ["No Premixes Added", "No Preservatives", "No Artificial Colors"],
        storage: "Keep away from moisture. Use a dry spoon and ensure oil covers the mango pieces.",
        shelfLife: "Best Before 24 Months from Manufacturing",
        pairings: "Classic everyday companion for rotis, mathri, poori-sabzi, and khichdi. Star of the Pahadi Thali Box (₹1,699).",
        crossSellSku: "PF-GHEE-500",
        batchCode: "DRH-2609-KM",
        nutritionPer100: {
          servingSize: "10g (50 Servings per 500g Jar)",
          rows: [
            ["Energy", "238 kcal", "—"],
            ["Protein", "2.4 g", "—"],
            ["Carbohydrate", "15.2 g", "—"],
            ["Total Fat", "18.8 g", "—"],
            ["Trans Fat", "0 g", "0%"]
          ]
        },
        categoryMeta: {
          spiceLevel: "Balanced Tangy & Savoury (3 / 5)",
          oilProfile: "Cold-Pressed Mustard Oil · Zero Refined Oil",
          curingMethod: "Sun-cured in small batches without synthetic acidifiers",
          keyIngredient: "Hand-cut tart Desi Kaccha Mangoes + Whole Crushed Spices"
        }
      },
      {
        sku: "PF-ACH-KM200T",
        officialSku: "TPFDMPICKLE0200",
        title: "Desi Kaccha Mango Homemade Pickle — 200g (Trial Pack)",
        shortTitle: "Desi Kaccha Mango Pickle 200g",
        category: "Aachar",
        isTrial: true,
        size: "200 g (Trial Glass Jar)",
        dimensions: "Height: 8.5 cm × Diameter: 7 cm · Net Weight: 200g",
        netQty: 200,
        unit: "g",
        mrp: 309,
        price: 259,
        inStock: true,
        stockNote: "New SKU · Featured in Mini Achaar Duo (₹499)",
        badge: "New ₹259 Trial Pack",
        imageKey: "MANGO_AACHAR",
        gallery: [
          { key: "MANGO_AACHAR", caption: "Desi Kaccha Mango Homemade Pickle — 200g Trial Glass Jar" },
          { key: "PARATHA_THALI", caption: "Served Alongside Warm Parathas & Bilona Ghee" },
          { key: "GP200_6_DIM", caption: "200g Starter Jar Dimensions — Height: 8.5 cm × Diameter: 7 cm" }
        ],
        origin: "Village Drahal, Joginder Nagar (H.P. 175015)",
        summary: "Dadi Ji’s heirloom tart Desi Kaccha Mango Pickle in a 200g tasting jar. Sun-cured with cold-pressed mustard oil and coarsely crushed whole spices—or pair it with 200g Barot Pink Garlic in the Mini Achaar Duo for ₹499!",
        ingredients: "Raw Desi Mango Chunks, Cold-Pressed Mustard Oil, Himalayan Rock Salt, Fennel Seeds (Saunf), Methi Dana, Kalonji, Turmeric, Kashmiri & Pahadi Mirch.",
        allergenNote: "Contains Mustard.",
        claims: ["No Premixes Added", "No Preservatives", "No Artificial Colors"],
        storage: "Always use a clean, dry spoon and keep tightly closed.",
        shelfLife: "Best Before 24 Months from Manufacturing",
        pairings: "Pair with 200g Barot Pink Garlic in our ₹499 Mini Achaar Duo (Ships Free!).",
        crossSellSku: "PF-ACH-KM500",
        batchCode: "DRH-2609-KM",
        nutritionPer100: {
          servingSize: "10g (20 Servings per 200g Jar)",
          rows: [
            ["Energy", "238 kcal", "—"],
            ["Protein", "2.4 g", "—"],
            ["Carbohydrate", "15.2 g", "—"],
            ["Total Fat", "18.8 g", "—"],
            ["Trans Fat", "0 g", "0%"]
          ]
        },
        categoryMeta: {
          spiceLevel: "Balanced Tangy & Savoury (3 / 5)",
          oilProfile: "Cold-Pressed Mustard Oil",
          curingMethod: "Slow sun-cured in Village Drahal courtyard",
          keyIngredient: "Tart Desi Kaccha Mangoes (200g Trial Pack)"
        }
      },
      {
        sku: "PF-HON-WF650",
        officialSku: "TPFHONEY0650",
        title: "Himalayan Wildflower Forest Honey — 650g",
        shortTitle: "Wildflower Honey 650g",
        category: "Honey",
        isTrial: false,
        size: "650 g (Family Glass Jar)",
        dimensions: "Height: 13.5 cm × Diameter: 8.5 cm · Net Weight: 650g",
        netQty: 650,
        unit: "g",
        mrp: 699,
        price: 549,
        inStock: true,
        stockNote: "In Stock · ~58 kg Batch Ledger Available",
        badge: "21% Off · 100% Raw & Unheated",
        imageKey: "HONEY_JAR",
        gallery: [
          { key: "HONEY_JAR", caption: "Himalayan Wildflower Forest Honey — 650g Family Glass Jar" },
          { key: "REAL_HONEY_PHOTO", caption: "Unprocessed Himalayan Wildflower Honey Jar — Best Before 24 Months" },
          { key: "SLATE_BOARD", caption: "Raw Multi-Floral Harvest · Unpasteurized & Pollen-Rich" },
          { key: "GHEE_6_MOTTO", caption: "Health is Compulsory, Not a Choice — No Middlemen, Honest Pricing" }
        ],
        origin: "Partner Apiaries & Aravalli Honey Industries Sourcing Network, Packed at V.P.O. Drahal (H.P. 175015)",
        summary: "Collected from bees foraging freely on wild multi-floral blooms. Minimally strained, unpasteurized, and packed with natural floral aroma and enzymes.",
        ingredients: "100% Pure, Unrefined Multi-Floral Wildflower Forest Honey. Zero added C3/C4 sugar syrups, zero antibiotics.",
        allergenNote: "Natural raw bee product (contains wildflower pollen traces). Do not feed to infants under 12 months.",
        claims: ["100% Raw & Unheated", "Zero Added Sugar Syrup", "Lab Tested Purity"],
        storage: "Store at room temperature. Do not refrigerate. Natural crystallization in winter is a sign of raw purity—place jar in warm water to liquefy gently.",
        shelfLife: "Best Before 24 Months from Manufacturing",
        pairings: "Morning warm water ritual, herbal teas, drizzling on toast, or paired with 500ml Ghee in the Wellness Duo (₹1,299).",
        crossSellSku: "PF-GHEE-500",
        batchCode: "DRH-2609-HN",
        nutritionPer100: {
          servingSize: "15g (43 Servings per 650g Jar)",
          rows: [
            ["Energy", "319 kcal", "—"],
            ["Carbohydrate (Natural Floral Fructose/Glucose)", "79.5 g", "—"],
            ["Added Sucrose / C4 Sugar Syrup", "0 g", "0%"],
            ["Protein & Natural Pollen Enzymes", "0.4 g", "—"],
            ["Total Fat", "0 g", "0%"]
          ]
        },
        categoryMeta: {
          floralSource: "Multi-floral Wildflowers (Partner Apiaries / Aravalli Honey Ind. Batch Oct 2026)",
          processing: "Raw, Unheated (<40°C) & Unpasteurized · Fine-Mesh Strained Only",
          crystallizationNote: "Naturally crystallizes in cool weather & forms a delicate white pollen foam on top",
          labHighlights: "HMF < 20 mg/kg · Moisture < 18% · FSSAI #23326011006238"
        }
      },
      {
        sku: "PF-HON-WF250",
        officialSku: "TPFHONEY0250",
        title: "Wild Forest Honey — 250g (Trial Pack)",
        shortTitle: "Wild Forest Honey 250g",
        category: "Honey",
        isTrial: true,
        size: "250 g (Tasting Glass Jar)",
        dimensions: "Height: 9.5 cm × Diameter: 7 cm · Net Weight: 250g",
        netQty: 250,
        unit: "g",
        mrp: 349,
        price: 299,
        inStock: true,
        stockNote: "In Stock · Featured in Starter Box: Honey & Achaar (₹599)",
        badge: "₹299 Tasting Jar",
        imageKey: "SLATE_BOARD",
        gallery: [
          { key: "SLATE_BOARD", caption: "Wild Forest Honey — 250g Tasting Glass Jar" },
          { key: "HONEY_JAR", caption: "100% Raw, Unrefined Multi-Floral Nectar" }
        ],
        origin: "Partner Apiaries & Aravalli Honey Industries Sourcing Network, Packed at V.P.O. Drahal (H.P. 175015)",
        summary: "Our 250g tasting jar of raw, unrefined Wild Forest Honey. Deep golden colour and full-bodied floral notes—featured in the Starter Box: Honey & Achaar (₹599).",
        ingredients: "100% Pure Wild Forest Honey.",
        allergenNote: "Do not feed raw honey to infants under 12 months.",
        claims: ["100% Raw & Unheated", "Zero Sugar Syrup"],
        storage: "Store at room temperature; never refrigerate.",
        shelfLife: "Best Before 24 Months from Manufacturing",
        pairings: "Ideal starter size or bundled in the Starter Box: Honey & Achaar (250g Honey + 500g Mango Achaar for ₹599).",
        crossSellSku: "PF-HON-WF650",
        batchCode: "DRH-2609-HN",
        nutritionPer100: {
          servingSize: "15g (16 Servings per 250g Jar)",
          rows: [
            ["Energy", "319 kcal", "—"],
            ["Carbohydrate", "79.5 g", "—"],
            ["Added Sugar", "0 g", "0%"],
            ["Total Fat", "0 g", "0%"]
          ]
        },
        categoryMeta: {
          floralSource: "Multi-floral Wildflowers",
          processing: "Raw & Unheated",
          crystallizationNote: "Natural crystallization & pollen foam indicate zero thermal processing",
          labHighlights: "HMF < 20 mg/kg · Zero Added Sugar"
        }
      }
    ];


    // ============================================================================
    // SHOPIFY BRIDGE (stage 2): keep the demo's own prices and MRPs (the new pricing);
    // take only live stock status and each jar's real variant ID from the store.
    // ============================================================================
    const PAHADAN_SHOP = window.PAHADAN_SHOP || { variants: {}, cartLines: [] };
    PRODUCTS.forEach(p => {
      const live = PAHADAN_SHOP.variants[p.officialSku];
      if (!live) return;
      p.variantId = live.variantId;
      p.handle = live.handle; // Shopify: real product web address
      p.inStock = live.available;
      p.storeUrl = live.url;
      // Product photos come from Products in the Shopify admin (same order as there).
      // The demo's built-in photos stay as the fallback when a product has no photos.
      if (Array.isArray(live.images) && live.images.length) {
        p.gallery = live.images.map((img, idx) => {
          const key = "SHOP_" + p.sku + "_" + (idx + 1);
          ASSETS[key] = img.src;
          return { key, caption: img.alt || p.title };
        });
        p.imageKey = p.gallery[0].key;
      }
    });
    function pahadanSkuForVariant(variantId) {
      const p = PRODUCTS.find(x => x.variantId === variantId);
      return p ? p.sku : null;
    }
    // Shopify: custom 3-Jar Boxes in the bag (kept for this browser session so a page change doesn't lose the saving).
    let pahadanCustomBoxes = (() => {
      try { return JSON.parse(sessionStorage.getItem("pahadanCustomBoxes") || "[]"); } catch (e) { return []; }
    })();
    function pahadanSaveCustomBoxes() {
      try { sessionStorage.setItem("pahadanCustomBoxes", JSON.stringify(pahadanCustomBoxes)); } catch (e) {}
    }
    let _pahadanSyncTimer = null;
    let _pahadanSyncPromise = Promise.resolve();
    // Shopify: keeps the real cart identical to the bag. Updates run one after another (never in parallel),
    // and each one reads the bag at the moment it runs, so an older update can't overwrite a newer one.
    // When the bag shows the Diwali gift (free Honey 250g), a separate gift line is added to the real cart.
    function pahadanSyncCartNow() {
      // Resolves true when the real cart matches the bag, false if saving failed (the queue keeps working either way).
      const run = _pahadanSyncPromise.then(() => pahadanSyncCartOnce()).then(() => true, () => false);
      _pahadanSyncPromise = run;
      return run;
    }
    async function pahadanSyncCartOnce() {
      const root = (PAHADAN_SHOP.rootUrl || "/").replace(/\/$/, "");
      const json = { "Content-Type": "application/json", "Accept": "application/json" };
      const giftProduct = PRODUCTS.find(x => x.officialSku === PAHADAN_GIFT.officialSku);
      const giftVariantId = giftProduct ? giftProduct.variantId : null;
      const giftWanted = !!(window._pahadanGiftQualified && giftVariantId && giftProduct.inStock);

      const managed = new Set();
      PRODUCTS.forEach(p => { if (p.variantId) managed.add(p.variantId); });
      BUNDLES.forEach(b => { if (b.variantId) managed.add(b.variantId); });
      // Combos in the bag go to the real cart as the combo product (when it is on the Online Store and in stock);
      // their jars are taken out of the separate jar lines so nothing is charged twice.
      const jarCounts = {};
      cart.forEach(i => { jarCounts[i.sku] = (jarCounts[i.sku] || 0) + i.qty; });
      const wanted = {};
      computeActiveCartBundles().activeBundles.forEach(b => {
        if (!b.variantId || b.inStock === false) return;
        wanted[b.variantId] = (wanted[b.variantId] || 0) + 1;
        b.items.forEach(s => { jarCounts[s] -= 1; });
      });
      Object.keys(jarCounts).forEach(s => {
        const p = getProduct(s);
        if (p && p.variantId && jarCounts[s] > 0) wanted[p.variantId] = (wanted[p.variantId] || 0) + jarCounts[s];
      });

      const res = await fetch(root + "/cart.js", { headers: { "Accept": "application/json" } });
      if (!res.ok) throw new Error("cart read failed");
      const real = await res.json();
      const updates = {};
      const placed = {};
      let giftPlaced = false;
      (real.items || []).forEach(item => {
        const isGift = item.properties && item.properties._pahadan_gift;
        if (isGift) {
          const keep = giftWanted && !giftPlaced;
          if (keep) giftPlaced = true;
          const q = keep ? 1 : 0;
          if (item.quantity !== q) updates[item.key] = q;
          return;
        }
        if (!managed.has(item.variant_id)) return;
        const q = placed[item.variant_id] ? 0 : (wanted[item.variant_id] || 0);
        placed[item.variant_id] = true;
        if (item.quantity !== q) updates[item.key] = q;
      });
      if (Object.keys(updates).length) {
        const upd = await fetch(PAHADAN_SHOP.cartUpdateUrl + ".js", { method: "POST", headers: json, body: JSON.stringify({ updates }) });
        if (!upd.ok) throw new Error("cart update failed");
      }
      const adds = [];
      Object.keys(wanted).forEach(v => {
        if (!placed[v] && wanted[v] > 0) adds.push({ id: Number(v), quantity: wanted[v] });
      });
      if (giftWanted && !giftPlaced) {
        adds.push({ id: giftVariantId, quantity: 1, properties: { "Free gift": "Diwali gift · Orders ₹2,000+", "_pahadan_gift": "1" } });
      }
      if (adds.length) {
        const add = await fetch((PAHADAN_SHOP.cartAddUrl || root + "/cart/add") + ".js", { method: "POST", headers: json, body: JSON.stringify({ items: adds }) });
        if (!add.ok) throw new Error("cart add failed");
      }
    }
    function pahadanScheduleCartSync() {
      if (_pahadanSyncTimer) clearTimeout(_pahadanSyncTimer);
      _pahadanSyncTimer = setTimeout(() => { _pahadanSyncTimer = null; pahadanSyncCartNow(); }, 250);
    }
    // Shopify: forms hand off to the Pahadan WhatsApp (+91 92172 24336).
    function pahadanOpenWhatsApp(text) {
      const waUrl = "https://wa.me/919217224336?text=" + encodeURIComponent(text);
      const waWin = window.open(waUrl, "_blank");
      if (waWin) waWin.opener = null; // same protection as noopener
      else window.location.href = waUrl; // pop-up blocked: open WhatsApp in this tab instead
    }
    function pahadanNotifyRestock(title, btn) {
      const input = btn && btn.previousElementSibling;
      const num = input ? input.value.trim() : "";
      closeModal();
      showToast('Opening WhatsApp: press Send to confirm your restock alert for ' + title);
      pahadanOpenWhatsApp(`Please notify me when ${title} is back in stock.${num ? "\nMy WhatsApp: " + num : ""}`);
    }
    // After the Shopify newsletter form posts, show the demo's own confirmation in the footer.
    document.addEventListener("DOMContentLoaded", () => {
      const state = document.getElementById("pahadan-newsletter-state");
      const msg = document.getElementById("footer-sub-msg");
      if (!state || !msg) return;
      if (state.dataset.posted === "true") {
        msg.textContent = "✓ Subscribed to Drahal Fresh Batch Alerts.";
        msg.classList.remove("hidden");
      } else if (state.dataset.error === "true") {
        msg.textContent = "Please enter a valid email or WhatsApp number.";
        msg.classList.remove("hidden");
      }
    });
    function pahadanGoToCheckout() {
      if (_pahadanSyncTimer) { clearTimeout(_pahadanSyncTimer); _pahadanSyncTimer = null; }
      pahadanSyncCartNow().then((ok) => {
        // Shopify: never send the shopper to checkout with a cart that doesn't match the bag.
        if (!ok) {
          showToast("We couldn't update your bag (an item may be out of stock). Please check your bag and try again.");
          return;
        }
        const root = (PAHADAN_SHOP.rootUrl || "/").replace(/\/$/, "");
        window.location.href = appliedCoupon
          ? root + "/discount/" + encodeURIComponent(appliedCoupon) + "?redirect=" + encodeURIComponent(root + "/checkout")
          : root + "/checkout";
      });
    }
    // ============================================================================
    // 7 OFFICIAL COMBOS (FROM Pahadans_Farm_Pricing_and_Bundles_Master_Brief v3)
    // All 7 Combos Ship FREE Pan-India! Diwali gift (1–10 Nov 2026): FREE Honey 250g on orders ≥ ₹2,000.
    // ============================================================================
    // Shopify: the Diwali gift runs only inside its dated window, the same dates as the store's automatic discount,
    // so the website switches it on and off by itself.
    const PAHADAN_GIFT = {
      start: Date.parse("2026-11-01T00:00:00+05:30"),
      end: Date.parse("2026-11-10T23:59:59+05:30"),
      minOrder: 2000,
      officialSku: "TPFHONEY0250",
      worth: 299
    };
    function pahadanGiftLive() {
      const now = Date.now();
      return now >= PAHADAN_GIFT.start && now <= PAHADAN_GIFT.end;
    }
    // Shopify: WELCOME100 is the store's only code: ₹100 off a first order of ₹599 or more.
    const PAHADAN_WELCOME = { code: "WELCOME100", amount: 100, minOrder: 599 };
    // Shopify: the store's Standard shipping (India): ₹49, free on orders of ₹499 or more. Change here if the rate changes.
    const PAHADAN_SHIP = { fee: 49, freeFrom: 499 };
    // Shopify: dated announcement items (marked data-pahadan-gift-only) show only while the Diwali gift is live.
    document.addEventListener("DOMContentLoaded", () => {
      if (!pahadanGiftLive()) return;
      document.querySelectorAll("[data-pahadan-gift-only]").forEach(el => { el.style.display = "inline-flex"; });
    });
    const BUNDLES = [
      {
        id: "BND-01-MINIDUO",
        num: 1,
        title: "Mini Achaar Duo (200g x 2)",
        hookLine: "Two small jars of the hills — perfect for a first taste",
        subtitle: "First taste of our homemade achaar under ₹500",
        items: ["PF-ACH-KM200T", "PF-ACH-PG200T"],
        itemsText: "200g Desi Kaccha Mango Homemade Pickle + 200g Barot Special Pink Garlic Homemade Pickle",
        mrpTotal: 688,
        sellingTotal: 578,
        bundlePrice: 499,
        savesAmount: 79,
        savesPct: 13.7,
        tag: "Under ₹500",
        freeShip: true,
        freeGiftUnlocked: false
      },
      {
        id: "BND-02-STARTER",
        num: 2,
        title: "Starter Box: Honey & Achaar",
        hookLine: "Your first taste of the Himalayan kitchen",
        subtitle: "First order, small gift — wild forest honey & homemade mango achaar",
        items: ["PF-HON-WF250", "PF-ACH-KM500"],
        itemsText: "250g Wild Forest Honey + 500g Desi Kaccha Mango Homemade Pickle",
        mrpTotal: 948,
        sellingTotal: 798,
        bundlePrice: 599,
        savesAmount: 199,
        savesPct: 24.9,
        tag: "Starter pick",
        freeShip: true,
        freeGiftUnlocked: false
      },
      {
        id: "BND-03-MANGO3",
        num: 3,
        title: "Mango Pickle Family Pack (500g x 3)",
        hookLine: "1.5 kg of homemade mango achaar for the whole family",
        subtitle: "Stocking up — families who finish a jar every month",
        items: ["PF-ACH-KM500", "PF-ACH-KM500", "PF-ACH-KM500"],
        itemsText: "3 × 500g Desi Kaccha Mango Homemade Pickle (1.5 kg)",
        mrpTotal: 1797,
        sellingTotal: 1497,
        bundlePrice: 1099,
        savesAmount: 398,
        savesPct: 26.6,
        tag: "Save 27%",
        freeShip: true,
        freeGiftUnlocked: false
      },
      {
        id: "BND-04-WELLNESS",
        num: 4,
        title: "Ghee & Honey Wellness Duo",
        hookLine: "Subah ki shuruaat: Himalayan cow ghee + wild forest honey",
        subtitle: "A simple daily ritual and a thoughtful gift",
        items: ["PF-GHEE-500", "PF-HON-WF650"],
        itemsText: "500ml Himachali Cow Desi Bilona Ghee + 650g Himalayan Wildflower Forest Honey",
        mrpTotal: 1798,
        sellingTotal: 1498,
        bundlePrice: 1299,
        savesAmount: 199,
        savesPct: 13.3,
        tag: "",
        freeShip: true,
        freeGiftUnlocked: false
      },
      {
        id: "BND-05-THALI",
        num: 5,
        title: "Pahadi Thali Box",
        hookLine: "Poori thali, ek box mein — ghee with mango & garlic achaar",
        subtitle: "MOST LOVED — the complete Pahadi meal box",
        items: ["PF-GHEE-500", "PF-ACH-KM500", "PF-ACH-PG500"],
        itemsText: "500ml Himachali Cow Desi Bilona Ghee + 500g Desi Kaccha Mango Pickle + 500g Barot Special Pink Garlic Pickle",
        mrpTotal: 2397,
        sellingTotal: 2047,
        bundlePrice: 1699,
        savesAmount: 348,
        savesPct: 17.0,
        tag: "MOST LOVED",
        freeShip: true,
        freeGiftUnlocked: false
      },
      {
        id: "BND-06-PANTRY",
        num: 6,
        title: "Mountain Pantry",
        hookLine: "A month of the Himalayan kitchen — ghee, honey & mango achaar",
        subtitle: "BEST VALUE — regular buyers' monthly kitchen stock",
        items: ["PF-GHEE-1000", "PF-HON-WF650", "PF-ACH-KM500"],
        itemsText: "1000ml (1L) Himachali Cow Desi Bilona Ghee + 650g Wildflower Honey + 500g Desi Kaccha Mango Pickle",
        mrpTotal: 3297,
        sellingTotal: 2797,
        bundlePrice: 2399,
        savesAmount: 398,
        savesPct: 14.2,
        tag: "BEST VALUE",
        freeShip: true,
        freeGiftUnlocked: false
      },
      {
        id: "BND-07-HAMPER",
        num: 7,
        title: "Pahadan Gift Hamper",
        hookLine: "Our fullest gift — ghee, honey & three achaars in a gift-ready box",
        subtitle: "Festivals, weddings, housewarmings & thank-yous (with greeting card)",
        items: ["PF-GHEE-1000", "PF-HON-WF650", "PF-ACH-AM500", "PF-ACH-KM500", "PF-ACH-PG500"],
        itemsText: "1L Bilona Ghee + 650g Wild Honey + 500g Amla + 500g Mango + 500g Barot Garlic + Gift Box & Greeting Card",
        mrpTotal: 4595,
        sellingTotal: 3895,
        bundlePrice: 3399,
        savesAmount: 496,
        savesPct: 12.7,
        tag: "GIFT HAMPER",
        freeShip: true,
        freeGiftUnlocked: false
      }
    ];
    // Shopify: when "use store prices" is on in the layout, jar prices and MRPs come from Products,
    // and each bundle's normal total and saving are recalculated from them (bundle prices stay as set).
    if (PAHADAN_SHOP.useStorePrices) {
      PRODUCTS.forEach(p => {
        const live = PAHADAN_SHOP.variants[p.officialSku];
        if (live && live.price) { p.price = live.price; p.mrp = live.mrp || live.price; }
      });
      BUNDLES.forEach(b => {
        b.sellingTotal = b.items.reduce((acc, s) => acc + getProduct(s).price, 0);
        b.mrpTotal = b.items.reduce((acc, s) => acc + getProduct(s).mrp, 0);
        b.savesAmount = Math.max(0, b.sellingTotal - b.bundlePrice);
        b.savesPct = b.sellingTotal ? Math.round((b.savesAmount / b.sellingTotal) * 1000) / 10 : 0;
      });
    }
    // Shopify: each combo is a real Shopify Bundles product (its SKU is the combo ID, e.g. BND-06-PANTRY).
    // When that product is on the Online Store, the bag sends the combo itself to checkout, so checkout
    // charges the combo price and stock comes from the jars inside it. While a combo product is still a draft
    // (not on the Online Store) it has no live entry, and the bag keeps sending the separate jars as before.
    BUNDLES.forEach(b => {
      const live = PAHADAN_SHOP.variants[b.id];
      if (!live || !live.variantId) return;
      b.variantId = live.variantId;
      b.inStock = live.available;
      b.storeUrl = live.url;
      if (live.price) {
        b.bundlePrice = live.price;
        b.savesAmount = Math.max(0, b.sellingTotal - b.bundlePrice);
        b.savesPct = b.sellingTotal ? Math.round((b.savesAmount / b.sellingTotal) * 1000) / 10 : 0;
      }
    });
    // Shopify: Gift Hamper ₹100 off, 1–10 Nov IST (the store's dated automatic discount "Gift Hamper ₹100 off (1–10 Nov)").
    // During those dates the bag charges ₹3,299 and every "₹3,399" / "₹496" saving on the page reads ₹3,299 / ₹596,
    // so the site matches checkout. Outside those dates nothing changes.
    const PAHADAN_HAMPER_OFFER = { id: "BND-07-HAMPER", amount: 100, start: Date.parse("2026-11-01T00:00:00+05:30"), end: Date.parse("2026-11-10T23:59:59+05:30") };
    function pahadanHamperOfferLive() {
      const now = Date.now();
      return now >= PAHADAN_HAMPER_OFFER.start && now <= PAHADAN_HAMPER_OFFER.end;
    }
    if (pahadanHamperOfferLive()) {
      const hamper = BUNDLES.find(b => b.id === PAHADAN_HAMPER_OFFER.id);
      if (hamper) {
        const regular = hamper.bundlePrice;
        const offer = regular - PAHADAN_HAMPER_OFFER.amount;
        const fmt = n => "₹" + n.toLocaleString("en-IN");
        const oldSave = fmt(hamper.sellingTotal - regular);
        const newSave = fmt(hamper.sellingTotal - offer);
        hamper.bundlePrice = offer;
        hamper.savesAmount = Math.max(0, hamper.sellingTotal - offer);
        hamper.savesPct = hamper.sellingTotal ? Math.round((hamper.savesAmount / hamper.sellingTotal) * 1000) / 10 : 0;
        const swaps = [[fmt(regular), fmt(offer)], [oldSave, newSave]];
        const fixText = (node) => {
          let t = node.nodeValue;
          if (!t || t.indexOf("₹") === -1) return;
          let changed = t;
          swaps.forEach(([a, b]) => { changed = changed.split(a).join(b); });
          if (changed !== t) node.nodeValue = changed;
        };
        const fixTree = (root) => {
          if (root.nodeType === 3) { fixText(root); return; }
          const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
          let n;
          while ((n = walker.nextNode())) fixText(n);
        };
        document.addEventListener("DOMContentLoaded", () => {
          fixTree(document.body);
          new MutationObserver(list => {
            list.forEach(m => {
              if (m.type === "characterData") fixText(m.target);
              m.addedNodes && m.addedNodes.forEach(fixTree);
            });
          }).observe(document.body, { childList: true, subtree: true, characterData: true });
        });
      }
    }
    function pahadanBundleForVariant(variantId) {
      return BUNDLES.find(b => b.variantId === variantId) || null;
    }

    // Batch Lab Reports Data
    const BATCH_REPORTS = {
      "DRH-2610-GH": {
        code: "DRH-2610-GH",
        product: "Himachali Cow Desi Bilona Ghee (250ml, 500ml & 1000ml)",
        origin: "Village Drahal, Joginder Nagar, Distt. Mandi, H.P. 175015",
        method: "4-Step Traditional Bilona: Boiling A2 Milk → Clay Pot Curd → Wooden Bilona Churned → Slow Firewood Cooked",
        status: "PASSED — FARE Labs Report O&F20250611-006-036 (16 Jun 2025) · Conforms to FSSR 2011",
        metrics: [
          ["Reichert-Meissl (RM) Value", "26.89", "≥ 24.0 (FSSR 2011 limit)", "PASS"],
          ["Moisture Content", "0.36%", "≤ 0.50% (Prevents rancidity & extends shelf life)", "PASS"],
          ["Free Fatty Acids (as Oleic Acid)", "0.77%", "≤ 2.0% (FSSR 2011 limit)", "PASS"],
          ["Baudouin Test (Sesame/Vanaspati)", "Negative", "Negative (Zero hydrogenated vegetable oil)", "PASS"],
          ["Label MRP & GST Compliance", "MRP ₹649 / ₹1,099 / ₹1,999", "Includes 5% GST · Matches Printed Pack MRP", "PASS"]
        ]
      },
      "BAR-2610-PG": {
        code: "BAR-2610-PG",
        product: "Barot Special Pink Garlic Homemade Pickle (200g & 500g)",
        origin: "Barot Valley & Village Drahal Women's Network, Distt. Mandi, H.P. 175015",
        method: "Slow Sun-Cured on Himalayan Terraces with Cold-Pressed Mustard Oil & Jaggery",
        status: "PASSED — Back-Label Nutrition & Zero-Preservative Verified",
        metrics: [
          ["Energy / Protein / Fat (per 100g)", "250 kcal / 4g / 22g", "Verified on product back label (Trans Fat 0g, Cholesterol 0mg)", "PASS"],
          ["Synthetic Preservatives (Benzoate/Sorbate)", "Not Detected", "No Premixes Added · No Preservatives · No Artificial Colors", "PASS"],
          ["Mustard Oil Argemone Test", "Negative", "100% pure cold-pressed kachi ghani mustard oil", "PASS"],
          ["Label MRP & Claim Alignment", "MRP ₹379 (200g) / ₹699 (500g)", "Matches sourcing records & printed label MRP", "PASS"]
        ]
      },
      "DRH-2610-AM": {
        code: "DRH-2610-AM",
        product: "Himalayan Forest Amla Pickle (200g & 500g)",
        origin: "Wild Himachal Forests & Village Drahal, Distt. Mandi, H.P. 175015",
        method: "Himalayan Forest Amlas (0% Pesticides) Sun-Cured with Cold-Pressed Mustard Oil",
        status: "PASSED — Wild Forest Forage & Zero-Pesticide Verified",
        metrics: [
          ["Energy / Protein / Fat (per 100g)", "243 kcal / 2.6g / 18.5g", "Verified on product back label (Trans Fat 0g, Sodium 638mg)", "PASS"],
          ["Chemical Pesticides & Fertilizers", "0% (Not Detected)", "Picked from wild Himalayan forests untouched by chemicals", "PASS"],
          ["Added Refined Sugar / Colors", "0% (None)", "No Premixes Added · No Preservatives · No Artificial Colors", "PASS"],
          ["Label MRP & Shelf Life", "MRP ₹329 (200g) / ₹599 (500g)", "Best Before 24 Months from Manufacturing", "PASS"]
        ]
      },
      "DRH-2609-HN": {
        code: "DRH-2609-HN",
        product: "Himalayan Wildflower Forest Honey (250g & 650g)",
        origin: "Partner Apiaries & Aravalli Honey Industries Sourcing Network, Packed at V.P.O. Drahal",
        method: "Raw, Unheated (<40°C), Coarse Strained Only (Pollen Intact)",
        status: "PASSED — Complies with FSSAI Special Grade Raw Honey Parameters",
        metrics: [
          ["Hydroxymethylfurfural (HMF)", "18.4 mg/kg", "≤ 40.0 mg/kg (Proves honey was never overheated)", "PASS"],
          ["Moisture Content", "17.8%", "≤ 20.0% (Mature comb harvest)", "PASS"],
          ["Fructose to Glucose Ratio (F/G)", "1.24", "≥ 1.00 (Natural floral nectar balance)", "PASS"],
          ["C4 / Rice Syrup Marker (SMR/TMR)", "Not Detected", "Absent · MRP ₹349 (250g) / ₹699 (650g)", "PASS"]
        ]
      }
    };

    let activeFaqCat = "all";
    const FAQS = [
      {
        cat: "Product",
        q: "What makes your Himachali Bilona Ghee different from regular commercial ghee?",
        a: "Most commercial ghee is made by centrifugally separating cream (malai) from bulk milk. At The Pahadan's Farm, our ghee is slow-crafted using traditional methods from pure cow milk sourced from indigenous Himachali mountain cows and 56 families: (1) Boiling pure mountain cow milk on slow firewood, (2) Setting it into curd (dahi) overnight in earthen pots, (3) Hand-churning with a wooden bilona to extract makkhan, and (4) Slow-heating into aromatic, granular ghee."
      },
      {
        cat: "Product",
        q: "Are your products FSSAI certified, lab tested, and free from preservatives or premixes?",
        a: "Yes. We are registered under FSSAI License No. 23326011006238 and our batches are NABL lab-tested for purity. Our Bilona Ghee contains zero vanaspati, adulterants, or added hormones. Our homemade pickles (Barot Special Pink Garlic, Himalayan Forest Amla, and Desi Kaccha Mango) are sun-cured with cold-pressed mustard oil and whole spices with NO premixes added, no synthetic preservatives, and no artificial colors."
      },
      {
        cat: "Product",
        q: "What is the exact shelf life of your Ghee, Honey, and Homemade Pickles?",
        a: "When stored in a cool, dry cupboard away from moisture and direct sunlight using a clean, dry spoon every time: (1) Himachali Cow Desi Bilona Ghee has a shelf life of 12 Months from manufacturing, (2) Homemade Pahadi Pickles have a shelf life of 24 Months from manufacturing, and (3) Raw Himalayan Wildflower Forest Honey has a shelf life of 24 Months from manufacturing."
      },
      {
        cat: "Product",
        q: "Is your ghee suitable for children, the elderly, and daily cooking?",
        a: "Yes! Because our Bilona Ghee is 100% pure, natural, and preservative-free, it is ideal for everyday cooking, rotis, dal-tadka, and dietary routines for both children and the elderly. (If you have a severe clinical dairy allergy or extreme lactose sensitivity, please consult your physician before use.)"
      },
      {
        cat: "Product",
        q: "Can I store Bilona Ghee, Pickles, and Wild Honey without refrigeration?",
        a: "Yes. None of our products require refrigeration. Store them at room temperature in a cool, dry cupboard away from direct sunlight, and always use a clean, dry spoon so moisture never enters the glass jar."
      },
      {
        cat: "Ordering",
        q: "What payment methods do you accept? Do you offer Cash on Delivery (COD)?",
        a: "We accept all secure online prepaid payment methods including UPI (Google Pay, PhonePe, Paytm, BHIM), Debit Cards, Credit Cards, Net Banking, and Wallets via encrypted payment gateways. Please note that we do not provide Cash on Delivery (COD) options."
      },
      {
        cat: "Ordering",
        q: "Can I modify or cancel my order after placing it?",
        a: "Yes, order modifications or cancellations can be requested before dispatch (within 1 to 48 hours of placing the order) by emailing pahadansfarm@gmail.com or messaging our support team on WhatsApp (+91 92172 24336) with your Order ID."
      },
      {
        cat: "Ordering",
        q: "Will I receive an order confirmation and can I get a GST invoice?",
        a: "Yes, as soon as your prepaid payment is completed, you will receive an immediate order and payment confirmation via email and/or SMS. Every printed pack carries GST-inclusive MRP, and you can request a formal GST invoice at checkout or by contacting support with your Order ID."
      },
      {
        cat: "Ordering",
        q: "My payment failed, but the amount was deducted from my bank. What should I do?",
        a: "In case of a failed transaction where the amount is debited, the payment gateway automatically refunds the amount to your original source account within 5–7 business days. If it is not credited within 7 working days, please email pahadansfarm@gmail.com with your transaction reference."
      },
      {
        cat: "Shipping",
        q: "Where are your orders shipped from and do you deliver across India?",
        a: "While our products are handcrafted in Himachal Pradesh, all online orders are packed in protective glass-safe sleeves and sent via our courier partners. We deliver pan-India via reliable national courier partners."
      },
      {
        cat: "Shipping",
        q: "How long does order processing and delivery take?",
        a: "All orders are processed within 1–3 business days before dispatch. Once dispatched, estimated delivery takes 3–5 business days across India depending on your PIN code. You will receive a real-time tracking link via email/SMS upon dispatch."
      },
      {
        cat: "Shipping",
        q: "What are your shipping charges, and is there a first-order offer?",
        a: "All 7 curated combos ship 100% FREE across India. Every order of ₹499 or more ships FREE; orders below ₹499 pay a flat ₹49 shipping. New customers get ₹100 off their first order of ₹599 or more with code WELCOME100."
      },
      {
        cat: "Shipping",
        q: "What happens if I am not available at the time of delivery?",
        a: "Our courier partner will attempt delivery again on the next business day and contact you via phone/SMS. If the parcel remains uncollected after multiple attempts, it returns to us and our support team can assist you in rescheduling."
      },
      {
        cat: "Refunds",
        q: "What is your return, replacement, and refund policy?",
        a: "Due to the perishable, food-grade, and artisanal nature of our ghee, pickles, and honey, we do not accept general returns once delivered. However, if your order arrives damaged, leaking, or with an incorrect item, we provide a 100% free replacement or full refund."
      },
      {
        cat: "Refunds",
        q: "What should I do if a glass jar arrives damaged or leaking?",
        a: "Please notify us within 48 hours of delivery by emailing pahadansfarm@gmail.com (or WhatsApp +91 92172 24336) with your Order ID and clear photos/video of the damaged jar and outer box. Once verified, approved replacements or refunds to your original payment method are processed within 7–10 business days."
      },
      {
        cat: "Refunds",
        q: "Do you offer gift hampers for festivals and family occasions?",
        a: "Yes! Our Pahadan Gift Hamper (₹3,399, ships free) includes 1L Bilona Ghee, 650g Wildflower Honey, and all three 500g Homemade Pickles (Amla, Mango, Barot Pink Garlic) in a gift-ready box with a greeting card—made for festivals, weddings, housewarmings and thank-yous."
      }
    ];

    const POLICIES = {
      refund: `
        <h3 class="font-bold text-[#1E2D24] text-sm">Refund &amp; Return Policy</h3>
        <p>At <strong>The Pahadan's Farm</strong>, every jar of Bilona Ghee, sun-cured pickle, and raw honey is handcrafted with care and inspected before dispatch.</p>
        <p><strong>1. General Return Policy:</strong> Due to the perishable and artisanal nature of food products, returns are not accepted once an order has been delivered, except in cases of transit damage, leakage, or wrong item delivery.</p>
        <p><strong>2. Eligibility for Replacement or Refund:</strong> You are eligible for a free replacement or full refund if: (a) the glass jar arrives broken, damaged, or leaking during courier transit, (b) you receive an incorrect product or missing item, or (c) an item ordered goes out of stock or is charged twice.</p>
        <p><strong>3. 48-Hour Reporting Window:</strong> To raise a claim, please email <strong>pahadansfarm@gmail.com</strong> (or message WhatsApp <strong>+91 92172 24336</strong>) within <strong>48 hours of delivery</strong> with your Order Number and clear photos/unboxing video of the damaged item and packaging.</p>
        <p><strong>4. Exclusions:</strong> Requests raised after 48 hours of marked delivery, subjective taste preferences, improper storage after opening, or minor courier delays caused by weather/regional disruptions are not eligible for return.</p>
        <p><strong>5. Refund &amp; Replacement Timeline:</strong> Once approved, replacement shipments are dispatched or monetary refunds are initiated back to your original prepaid payment method within <strong>7–10 business days</strong>.</p>
      `,
      shipping: `
        <h3 class="font-bold text-[#1E2D24] text-sm">Shipping &amp; Delivery Policy</h3>
        <p>At <strong>The Pahadan's Farm</strong>, we take pride in delivering a piece of the Himalayas to your doorstep with care, transparency, and reliability.</p>
        <p><strong>1. Packaging &amp; Order Processing:</strong> While our products are crafted in Himachal Pradesh, all orders are packed in multi-layer protective corrugated sleeves and prepared for dispatch. Orders are processed within <strong>1–3 business days</strong>, and you receive an email/SMS confirmation once packed.</p>
        <p><strong>2. Estimated Delivery Time:</strong> Orders are delivered within <strong>3–5 business days across India</strong>, depending on your location. Deliveries to remote/hilly regions or during severe weather and festival peaks may experience minor delays.</p>
        <p><strong>3. Shipping Charges &amp; Free Shipping Rules:</strong> All <strong>7 Curated Combos ship 100% FREE</strong> pan-India. Every order ships <strong>FREE at ₹499 and above</strong> (flat ₹49 shipping below ₹499).</p>
        <p><strong>4. Delivery Partners &amp; Tracking:</strong> We ship via trusted national courier partners. A real-time tracking link is shared via email and SMS as soon as your parcel is dispatched.</p>
        <p><strong>5. Order Cancellation:</strong> You may cancel an order before dispatch (within 48 hours of ordering) by contacting <strong>pahadansfarm@gmail.com</strong>.</p>
      `,
      terms: `
        <h3 class="font-bold text-[#1E2D24] text-sm">Terms &amp; Conditions (Legal Policy)</h3>
        <p>Welcome to <strong>The Pahadan's Farm</strong> (operated by <strong>Pahadan Farm Private Limited</strong> · FSSAI Lic. No. <strong>23326011006238</strong> · CIN: <strong>U46302HP2025PTC011834</strong>).</p>
        <p><strong>1. Eligibility:</strong> By using this website and placing an order, you confirm that you are at least 18 years old or accessing the site under the supervision of a parent or legal guardian.</p>
        <p><strong>2. Product Information &amp; Artisanal Variations:</strong> All our products are handcrafted using natural ingredients by rural women farmers in Himachal Pradesh. Slight variations in colour, granularity, or aroma from batch to batch are natural characteristics of authentic, preservative-free Bilona Ghee, sun-cured pickles, and raw honey.</p>
        <p><strong>3. Pricing &amp; Prepaid Payment:</strong> All prices and MRPs listed on the website are in Indian Rupees (INR) and are inclusive of applicable GST. Full prepaid payment (via UPI, Cards, NetBanking, or Wallets) is required at checkout; we do not offer Cash on Delivery (COD).</p>
        <p><strong>4. Intellectual Property:</strong> All logos, product photography, illustrations, brand copy, and designs on this website are the intellectual property of The Pahadan's Farm and may not be reproduced without written permission.</p>
        <p><strong>5. Limitation of Liability &amp; Governing Law:</strong> Our maximum liability for any product claim shall not exceed the purchase price of the product ordered. These Terms &amp; Conditions are governed by the laws of India.</p>
      `,
      privacy: `
        <h3 class="font-bold text-[#1E2D24] text-sm">Privacy Policy</h3>
        <p>At <strong>The Pahadan's Farm</strong>, we respect your privacy and are committed to protecting your personal data.</p>
        <p><strong>1. Information We Collect:</strong> When you browse or place an order, we collect your name, delivery address, PIN code, email address, phone/WhatsApp number, and encrypted transaction reference required to fulfill your order.</p>
        <p><strong>2. How We Use Your Information:</strong> Your data is used strictly to process and deliver your order, send real-time courier tracking updates, provide customer support, and (only if you opt in) share new batch alerts or festive offers.</p>
        <p><strong>3. Sharing of Information &amp; Data Security:</strong> We never sell or rent your personal data to third parties. Information is shared only with trusted logistics partners and RBI-compliant encrypted payment gateways necessary to complete your delivery. We do not store your credit/debit card numbers or UPI PINs on our servers.</p>
        <p><strong>4. Cookies &amp; Your Rights:</strong> Our website uses essential session storage to maintain your shopping cart. You may request access, correction, or deletion of your personal contact details at any time by writing to <strong>pahadansfarm@gmail.com</strong> or calling <strong>+91 92172 24336</strong>.</p>
      `
    };

    // VERIFIED GOOGLE BUSINESS PROFILE & CUSTOMER REVIEWS (Place ID: ChIJf7XccuLDBDkRZ2vH9AqSisc · 5.0★ / 42 Reviews)
    const GOOGLE_REVIEWS = [
      {
        id: "gr-1",
        author: "Verified Google Reviewer (Delhi NCR)",
        badge: "Google Review · Sep 2026",
        rating: 5,
        category: "Ghee",
        tags: ["Ghee", "Purity"],
        productRef: "PF-GHEE-1000",
        productLabel: "1L Himachali Cow Desi Bilona Ghee",
        quote: "This ghee honestly tastes just like the one we get in my village — the smell and taste are so good and fresh, one of the best ghee in Delhi I’ve tried so far 😍"
      },
      {
        id: "gr-2",
        author: "Verified Google Reviewer",
        badge: "Google Review · May 2026",
        rating: 5,
        category: "Ghee",
        tags: ["Ghee", "Purity"],
        productRef: "PF-GHEE-1000",
        productLabel: "Himachali Cow Desi Bilona Ghee",
        quote: "If you miss real homemade ghee, this is as close as it gets without churning it yourself."
      },
      {
        id: "gr-3",
        author: "Verified Google Reviewer",
        badge: "Google Review · May 2026",
        rating: 5,
        category: "Honey",
        tags: ["Ghee", "Honey", "Aachar"],
        productRef: "PF-HON-WF650",
        productLabel: "Bilona Ghee, Wildflower Honey & Forest Amla",
        quote: "The ghee is rich and flavorful, the honey tastes pure and natural, and the amla products are fresh and healthy."
      },
      {
        id: "gr-4",
        author: "Poonam K.",
        badge: "Verified Buyer · Photo Review",
        rating: 5,
        category: "Ghee",
        tags: ["Ghee", "Purity"],
        productRef: "PF-GHEE-1000",
        productLabel: "1L Farm Fresh Himachali Cow Ghee",
        quote: "Product from Himachal Pradesh never ever disappoints. Pure aroma and traditional taste just like home."
      },
      {
        id: "gr-5",
        author: "Chandrakant T.",
        badge: "Verified Buyer · Photo Review",
        rating: 5,
        category: "Ghee",
        tags: ["Ghee", "Purity"],
        productRef: "PF-GHEE-1000",
        productLabel: "1L Farm Fresh Himachali Cow Ghee",
        quote: "Surely sticking with Pahadan’s Farm for long — they are truly worth many appreciations."
      },
      {
        id: "gr-6",
        author: "Verified Google Reviewer",
        badge: "Google Review · May 2026",
        rating: 5,
        category: "Honey",
        tags: ["Ghee", "Honey"],
        productRef: "PF-HON-WF650",
        productLabel: "Desi Ghee & Wildflower Forest Honey",
        quote: "Desi ghee and honey quality is excellent."
      },
      {
        id: "gr-7",
        author: "Verified Google Reviewer",
        badge: "Google Review · Jun 2026",
        rating: 5,
        category: "Ghee",
        tags: ["Ghee"],
        productRef: "PF-GHEE-500",
        productLabel: "Himachali Cow Desi Bilona Ghee 500ml",
        quote: "Amazing experience with Pahadan ghee — delicious and healthy."
      },
      {
        id: "gr-8",
        author: "Verified Google Reviewer",
        badge: "Google Review · May 2026",
        rating: 5,
        category: "Ghee",
        tags: ["Ghee"],
        productRef: "PF-GHEE-500",
        productLabel: "Farm Fresh Himachali Cow Ghee",
        quote: "Absolutely loved the quality of this farm fresh ghee!"
      },
      {
        id: "gr-9",
        author: "Verified Google Reviewer",
        badge: "Google Review · May 2026",
        rating: 5,
        category: "Aachar",
        tags: ["Aachar"],
        productRef: "PF-ACH-PG200T",
        productLabel: "Barot Special Pink Garlic & Forest Amla Pickles",
        quote: "Tried the pickles from Pahadan’s Farm recently and they were really good."
      },
      {
        id: "gr-10",
        author: "Verified Google Reviewer",
        badge: "Google Review · May 2026",
        rating: 5,
        category: "Purity",
        tags: ["Purity", "Aachar"],
        productRef: "PF-ACH-AM500",
        productLabel: "Natural Mountain Pantry Staples",
        quote: "The Pahadan's Farm provides excellent, natural products."
      }
    ];

    // ============================================================================
    // INTELLIGENT PRODUCT RECOMMENDATION & UPSELL MATRIX (ALL 11 SKUs)
    // ============================================================================
    const RECOMMENDATION_MATRIX = {
      "PF-GHEE-1000": {
        upgradeSku: null,
        valueCallout: "Best Per-100ml Value (₹175/100ml · Saves ₹149 vs two 500ml jars)",
        primaryCrossSell: "PF-ACH-PG500",
        secondaryCrossSell: "PF-HON-WF650",
        postPurchaseSku: "PF-ACH-AM200T",
        pairingReason: "Or bundle 1L Ghee + 650g Honey + 500g Mango in our Mountain Pantry combo for ₹2,399 (Saves ₹398 + Ships Free)!"
      },
      "PF-GHEE-500": {
        upgradeSku: "PF-GHEE-1000",
        upgradePitch: "Upgrade to 1000ml (1L) Family Jar (+₹800) — save ₹149 per Litre & unlock Free Pan-India Shipping!",
        valueCallout: "Standard Monthly Size (₹190/100ml)",
        primaryCrossSell: "PF-HON-WF650",
        secondaryCrossSell: "PF-ACH-AM500",
        postPurchaseSku: "PF-ACH-AM200T",
        pairingReason: "Pair 500ml Ghee with 650g Honey in the Ghee & Honey Wellness Duo (₹1,299) or with Mango & Garlic in the Pahadi Thali Box (₹1,699)!"
      },
      "PF-GHEE-250T": {
        upgradeSku: "PF-GHEE-500",
        upgradePitch: "Upgrade to 500ml Standard Jar (+₹400) — get 2× more Bilona Ghee & save ₹30/100ml!",
        valueCallout: "Starter Trial Pack (₹220/100ml)",
        primaryCrossSell: "PF-HON-WF250",
        secondaryCrossSell: "PF-ACH-AM200T",
        postPurchaseSku: "PF-ACH-AM200T",
        pairingReason: "Loved the trial jar? Step up to 500ml Ghee + 650g Honey in the Ghee & Honey Wellness Duo for ₹1,299 (Save ₹199 + Free Shipping)!"
      },
      "PF-ACH-PG500": {
        upgradeSku: null,
        valueCallout: "Best Per-100g Value (₹120/100g · Saves ₹200 vs 200g rate)",
        primaryCrossSell: "PF-ACH-AM500",
        secondaryCrossSell: "PF-ACH-KM500",
        postPurchaseSku: "PF-HON-WF250",
        pairingReason: "Get 500g Barot Pink Garlic + 500g Mango + 500ml Bilona Ghee in the Pahadi Thali Box for ₹1,699 (Save ₹348 + Free Shipping)!"
      },
      "PF-ACH-PG200T": {
        upgradeSku: "PF-ACH-PG500",
        upgradePitch: "Upgrade to 500g Family Jar (+₹280) — get 2.5× more Barot Pink Garlic & save ₹40/100g!",
        valueCallout: "Starter Tasting Jar (₹160/100g)",
        primaryCrossSell: "PF-ACH-AM200T",
        secondaryCrossSell: "PF-ACH-KM200T",
        postPurchaseSku: "PF-HON-WF250",
        pairingReason: "Can't pick one? Take 200g Pink Garlic + 200g Mango in the Mini Achaar Duo for ₹499 (Save ₹79 + Free Ship)!"
      },
      "PF-ACH-AM500": {
        upgradeSku: null,
        valueCallout: "Best Per-100g Value (₹100/100g · Saves ₹188 vs 200g rate)",
        primaryCrossSell: "PF-GHEE-500",
        secondaryCrossSell: "PF-ACH-KM500",
        postPurchaseSku: "PF-HON-WF250",
        pairingReason: "Featured in our Pahadan Gift Hamper (1L Ghee + 650g Honey + 3 × 500g Achaars for ₹3,399 · Save ₹496 + Free Ship)!"
      },
      "PF-ACH-AM200T": {
        upgradeSku: "PF-ACH-AM500",
        upgradePitch: "Upgrade to 500g Family Jar (+₹224) — get 2.5× more Himalayan Forest Amla & save ₹38/100g!",
        valueCallout: "Starter Trial Jar (₹138/100g)",
        primaryCrossSell: "PF-ACH-KM200T",
        secondaryCrossSell: "PF-ACH-PG200T",
        postPurchaseSku: "PF-ACH-PG200T",
        pairingReason: "Pair it with 200g Kaccha Mango and 200g Barot Pink Garlic starter jars—or step up to the 500g Family Jar!"
      },
      "PF-ACH-KM500": {
        upgradeSku: null,
        valueCallout: "Best Per-100g Value (₹100/100g · Saves ₹148 vs 200g rate)",
        primaryCrossSell: "PF-GHEE-500",
        secondaryCrossSell: "PF-ACH-AM500",
        postPurchaseSku: "PF-ACH-AM200T",
        pairingReason: "Get 3 × 500g in the Mango Pickle Family Pack for ₹1,099 (Save ₹398 + Free Ship), or pair with Ghee & Garlic in the Pahadi Thali Box (₹1,699)!"
      },
      "PF-ACH-KM200T": {
        upgradeSku: "PF-ACH-KM500",
        upgradePitch: "Upgrade to 500g Family Jar (+₹240) — get 2.5× more Desi Kaccha Mango Pickle & save ₹30/100g!",
        valueCallout: "New 200g Trial Pack (₹130/100g)",
        primaryCrossSell: "PF-ACH-AM200T",
        secondaryCrossSell: "PF-ACH-PG200T",
        postPurchaseSku: "PF-HON-WF250",
        pairingReason: "Combine 200g Mango + 200g Barot Pink Garlic in the Mini Achaar Duo for just ₹499 with Free Shipping!"
      },
      "PF-HON-WF650": {
        upgradeSku: null,
        valueCallout: "Best Per-100g Value (₹84/100g · 21% Off MRP ₹699)",
        primaryCrossSell: "PF-GHEE-500",
        secondaryCrossSell: "PF-GHEE-1000",
        postPurchaseSku: "PF-ACH-AM200T",
        pairingReason: "Pair 650g Wild Honey with 500ml Ghee in the Ghee & Honey Wellness Duo (₹1,299) or 1L Ghee + 500g Mango in Mountain Pantry (₹2,399)!"
      },
      "PF-HON-WF250": {
        upgradeSku: "PF-HON-WF650",
        upgradePitch: "Upgrade to 650g Family Jar (+₹250) — get 2.6× more Raw Wildflower Honey & save ₹35/100g!",
        valueCallout: "Tasting Jar (₹120/100g)",
        primaryCrossSell: "PF-GHEE-250T",
        secondaryCrossSell: "PF-ACH-AM200T",
        postPurchaseSku: "PF-ACH-PG200T",
        pairingReason: "Get 250g Honey + 500g Mango Achaar together in the Starter Box: Honey & Achaar for ₹599 (Save ₹199 + Free Shipping)!"
      }
    };

    // STATE
    let currentView = "home";
    let reviewCategoryFilter = "all";
    let homeTabFilter = "all";
    let colCatFilter = "all";
    let colSearchQuery = "";
    let colSortBy = "featured";
    let colInStockOnly = false;
    let activePdpSku = (() => {
      const pfInit = window.PAHADAN_INITIAL_VIEW;
      const pfMatch = pfInit && pfInit.view === "pdp" ? PRODUCTS.find(p => p.officialSku === pfInit.officialSku) : null;
      return pfMatch ? pfMatch.sku : "PF-GHEE-1000";
    })();
    let activePdpGalleryIdx = 0;
    let pdpQty = 1;
    let pdpPackTier = 1; // 1 = Single Jar, 2 = 2-Jar Refill Pack (5% Off), 3 = 3-Jar Family Pack (10% Off)
    let fbtCheckedSkus = []; // Frequently Bought Together selected SKUs on PDP
    // Demo started with 2 sample jars; the bag now opens with the shopper's real Shopify cart.
    // Shopify: a combo line in the real cart opens in the bag as its jars plus the combo, the way the bag tracks combos.
    const pahadanLoadedBundleIds = [];
    let cart = [];
    (PAHADAN_SHOP.cartLines || []).forEach(line => {
      const b = pahadanBundleForVariant(line.variantId);
      if (b) {
        for (let n = 0; n < line.qty; n++) {
          pahadanLoadedBundleIds.push(b.id);
          b.items.forEach(s => {
            const row = cart.find(i => i.sku === s);
            if (row) row.qty += 1; else cart.push({ sku: s, qty: 1 });
          });
        }
        return;
      }
      const sku = pahadanSkuForVariant(line.variantId);
      if (!sku) return;
      const row = cart.find(i => i.sku === sku);
      if (row) row.qty += line.qty; else cart.push({ sku, qty: line.qty });
    });
    // Shopify: curated bundles in the bag are kept for this browser session, so a page load does not drop their savings.
    let cartBundles = (() => { try { return JSON.parse(sessionStorage.getItem("pahadanBundles") || "[]"); } catch (e) { return []; } })(); // Tracks added official bundles so exact bundle savings & free shipping apply!
    // Shopify: combos already in the real cart count even if this browser session lost its list (new tab, other device).
    (() => {
      const have = {};
      cartBundles.forEach(id => { have[id] = (have[id] || 0) + 1; });
      pahadanLoadedBundleIds.forEach(id => {
        if (have[id]) have[id] -= 1; else cartBundles.push(id);
      });
    })();
    // Shopify: the promo code is kept for this browser session, so a page load (product, cart page) does not drop it.
    let appliedCoupon = (() => { try { return sessionStorage.getItem("pahadanCoupon") || null; } catch (e) { return null; } })();
    let isMobileViewport = false;
    let isSpecOverlay = false;
    let headerLogoMode = "transparent"; // "transparent" | "symbol_text" | "legacy_black"
    let recentAddCount = 0;
    let isCartUpsellDismissed = false;
    let activeCartUpsellIdx = 0;
    let skippedUpsellSkus = [];
    let dismissedUpgradeSkus = [];
    let isCartDetailsExpanded = false;

    // Helper: Calculate how many instances of each official bundle are satisfied by current cart items
    function computeActiveCartBundles() {
      // If user explicitly added bundles, verify items are still present or auto-detect best bundle match
      const tempCounts = {};
      cart.forEach(i => { tempCounts[i.sku] = (tempCounts[i.sku] || 0) + i.qty; });
      const active = [];
      let totalBundleSavings = 0;

      cartBundles.forEach(bId => {
        const b = BUNDLES.find(x => x.id === bId);
        if (!b) return;
        const needed = {};
        b.items.forEach(s => { needed[s] = (needed[s] || 0) + 1; });
        const canFulfill = Object.keys(needed).every(s => (tempCounts[s] || 0) >= needed[s]);
        if (canFulfill) {
          Object.keys(needed).forEach(s => { tempCounts[s] -= needed[s]; });
          active.push(b);
          totalBundleSavings += (b.sellingTotal - b.bundlePrice);
        }
      });
      // Shopify: Build-Your-Own 3-Jar Boxes are tracked so their jars aren't counted toward a curated combo.
      const keptBoxes = [];
      pahadanCustomBoxes.forEach(skus => {
        const needed = {};
        skus.forEach(s => { needed[s] = (needed[s] || 0) + 1; });
        const canFulfill = Object.keys(needed).every(s => (tempCounts[s] || 0) >= needed[s]);
        if (canFulfill) {
          Object.keys(needed).forEach(s => { tempCounts[s] -= needed[s]; });
          const sumSelling = skus.reduce((acc, s) => acc + getProduct(s).price, 0);
          // Brief v3: no extra discount on self-built boxes (WELCOME100 is the only code), so no saving is added here.
          keptBoxes.push(skus);
        }
      });
      if (keptBoxes.length !== pahadanCustomBoxes.length) {
        pahadanCustomBoxes = keptBoxes;
        pahadanSaveCustomBoxes();
      }
      cartBundles = active.map(b => b.id);
      try { sessionStorage.setItem("pahadanBundles", JSON.stringify(cartBundles)); } catch (e) {}
      return { activeBundles: active, totalBundleSavings };
    }

    function getProduct(sku) {
      return PRODUCTS.find(p => p.sku === sku) || PRODUCTS[0];
    }

    function formatINR(num) {
      return "₹" + Number(num).toLocaleString("en-IN", { minimumFractionDigits: num % 1 !== 0 ? 2 : 0, maximumFractionDigits: 2 });
    }

    function showToast(msg) {
      const banner = document.getElementById("toast-banner");
      const text = document.getElementById("toast-text");
      if (!banner || !text) return;
      text.textContent = msg;
      banner.classList.remove("hidden");
      if (window._toastTimer) clearTimeout(window._toastTimer);
      window._toastTimer = setTimeout(() => {
        banner.classList.add("hidden");
      }, 2800);
    }

    function getSmartCartRecommendations(excludeSkus = []) {
      const cartSkus = new Set([...cart.map(i => i.sku), ...excludeSkus]);
      const candidates = [];
      // First collect primary & secondary cross-sells from items currently in cart
      cart.forEach(item => {
        const rec = RECOMMENDATION_MATRIX[item.sku];
        if (rec) {
          if (rec.primaryCrossSell && !cartSkus.has(rec.primaryCrossSell)) candidates.push(rec.primaryCrossSell);
          if (rec.secondaryCrossSell && !cartSkus.has(rec.secondaryCrossSell)) candidates.push(rec.secondaryCrossSell);
        }
      });
      // Fallback high-affinity priority order
      ["PF-ACH-PG200T", "PF-ACH-KM200T", "PF-ACH-AM200T", "PF-HON-WF250", "PF-GHEE-250T", "PF-GHEE-500", "PF-ACH-KM500", "PF-HON-WF650", "PF-ACH-PG500", "PF-ACH-AM500", "PF-GHEE-1000"].forEach(s => {
        if (!cartSkus.has(s)) candidates.push(s);
      });
      // Deduplicate & keep only in-stock
      const unique = [];
      const seen = new Set();
      candidates.forEach(sku => {
        const p = getProduct(sku);
        if (p && p.inStock && !seen.has(sku)) {
          seen.add(sku);
          unique.push(p);
        }
      });
      return unique.slice(0, 3);
    }

    function hideAtcConfirmationBar() {
      const bar = document.getElementById("atc-confirmation-bar");
      if (bar) bar.classList.add("hidden");
      recentAddCount = 0;
      if (window._atcBarTimer) clearTimeout(window._atcBarTimer);
    }

    function showAtcConfirmationBar(sku, qtyAdded = 1, customLabel = null) {
      const p = getProduct(sku);
      const bar = document.getElementById("atc-confirmation-bar");
      if (!bar || !p) return;

      recentAddCount += qtyAdded;
      const totalItems = cart.reduce((acc, i) => acc + i.qty, 0);
      const subtotal = cart.reduce((acc, i) => acc + getProduct(i.sku).price * i.qty, 0);

      document.getElementById("atc-bar-img").src = ASSETS[p.imageKey] || ASSETS.GHEE_1_HERO;
      document.getElementById("atc-bar-qty-badge").textContent = `+${recentAddCount}`;
      document.getElementById("atc-bar-title").textContent = customLabel || p.title;
      document.getElementById("atc-bar-cart-summary").textContent = `Bag: ${totalItems} ${totalItems === 1 ? 'jar' : 'jars'} (${formatINR(subtotal)})`;

      const { activeBundles, totalBundleSavings } = computeActiveCartBundles();
      const netAfterBundle = Math.max(0, subtotal - totalBundleSavings);
      const hasFreeShip = netAfterBundle >= PAHADAN_SHIP.freeFrom;
      const giftLive = pahadanGiftLive();
      const shipStatus = giftLive && netAfterBundle >= PAHADAN_GIFT.minOrder
        ? "🎉 FREE Shipping + FREE Wild Forest Honey 250g (₹299) Unlocked!"
        : hasFreeShip
          ? (giftLive
            ? `✓ FREE Pan-India Shipping Unlocked! (Add ${formatINR(PAHADAN_GIFT.minOrder - netAfterBundle)} for Free Honey 250g)`
            : "✓ FREE Pan-India Shipping Unlocked!")
          : `Add ${formatINR(PAHADAN_SHIP.freeFrom - netAfterBundle)} more (or any Combo) for FREE Shipping`;

      document.getElementById("atc-bar-meta").textContent = `${p.size} · ${formatINR(p.price * qtyAdded)} · ${shipStatus}`;
      document.getElementById("atc-btn-cart-count").textContent = totalItems;

      // Populate contextual 1-click pairing inside the confirmation bar
      const rec = RECOMMENDATION_MATRIX[sku];
      const smartRecs = getSmartCartRecommendations([sku]);
      let pairProduct = (rec && rec.primaryCrossSell && !cart.some(i => i.sku === rec.primaryCrossSell))
        ? getProduct(rec.primaryCrossSell)
        : smartRecs[0];

      const csBox = document.getElementById("atc-bar-cross-sell");
      if (pairProduct && pairProduct.inStock) {
        csBox.classList.remove("hidden");
        document.getElementById("atc-cross-sell-text").innerHTML = `Complete your Pahadi plate with <strong>${pairProduct.shortTitle}</strong> (${formatINR(pairProduct.price)})`;
        const csBtn = document.getElementById("atc-cross-sell-btn");
        csBtn.setAttribute("data-quick-add", pairProduct.sku);
        csBtn.textContent = `+ Pair ${formatINR(pairProduct.price)}`;
      } else {
        csBox.classList.add("hidden");
      }

      bar.classList.remove("hidden");
      bar.classList.remove("atc-bar-pulse");
      void bar.offsetWidth; // Reflow for pulse animation on rapid clicks
      bar.classList.add("atc-bar-pulse");

      if (window._atcBarTimer) clearTimeout(window._atcBarTimer);
      window._atcBarTimer = setTimeout(() => {
        hideAtcConfirmationBar();
      }, 8500);
    }

    function openModal(title, htmlContent) {
      document.getElementById("modal-title").textContent = title;
      document.getElementById("modal-body").innerHTML = htmlContent;
      document.getElementById("global-modal-backdrop").classList.remove("hidden");
    }

    function closeModal() {
      document.getElementById("global-modal-backdrop").classList.add("hidden");
    }

    function hydrateStaticAssets() {
      document.querySelectorAll("[data-asset-src]").forEach(img => {
        const key = img.getAttribute("data-asset-src");
        if (ASSETS[key]) img.src = ASSETS[key];
      });
    }

    // PRODUCT CARD RENDERER (Uncluttered Visual Hierarchy + Clear 'Add to Cart' & '⚡ Buy Now' CTAs)
    function renderProductCard(p) {
      const discountPct = Math.round(((p.mrp - p.price) / p.mrp) * 100);
      const unitPrice100 = ((p.price / p.netQty) * 100).toFixed(0);
      const unitLabel = `₹${unitPrice100} / 100${p.unit}`;
      const imgSrc = ASSETS[p.imageKey] || ASSETS.GHEE_1_HERO;
      const photoCount = p.gallery ? p.gallery.length : 1;

      const actionBtns = p.inStock
        ? `<div class="flex items-center gap-1.5 shrink-0">
             <button type="button" data-quick-add="${p.sku}" class="h-9 px-3 rounded-xl bg-[#1E2D24] hover:bg-[#2c4235] text-white font-bold text-xs transition shadow-2xs whitespace-nowrap inline-flex items-center justify-center">
               Add to Cart
             </button>
             <button type="button" data-buy-now="${p.sku}" class="h-9 px-3 rounded-xl bg-[#C88A2B] hover:bg-[#9E3B24] text-[#141F18] hover:text-white font-bold text-xs transition shadow-2xs whitespace-nowrap inline-flex items-center justify-center">
               ⚡ Buy Now
             </button>
           </div>`
        : `<button type="button" data-notify-sku="${p.sku}" class="h-9 px-3 rounded-xl bg-[#F3EDE2] hover:bg-[#C88A2B] text-[#1E2D24] font-bold text-xs border border-[#1E2D24]/30 transition whitespace-nowrap inline-flex items-center justify-center">
             🔔 Notify
           </button>`;

      return `
        <article class="bg-white rounded-2xl border border-[#E2D9C8] overflow-hidden shadow-2xs hover:shadow-md transition flex flex-col justify-between h-full">
          <!-- Top Image Stage -->
          <div class="relative aspect-square bg-[#F3EDE2] overflow-hidden cursor-pointer pdp-jump-btn shrink-0" data-open-pdp="${p.sku}">
            <img src="${imgSrc}" alt="${p.title}" class="w-full h-full object-cover hover:scale-105 transition duration-500" />
            <span class="absolute top-3 left-3 max-w-[calc(100%-4.75rem)] truncate px-2.5 py-1 rounded-full ${p.inStock ? 'bg-[#1E2D24]/90 text-[#C88A2B]' : 'bg-[#9E3B24] text-white'} font-mono-batch text-[10px] font-bold shadow-xs">
              ${p.badge}
            </span>
            <span class="absolute top-3 right-3 px-2 py-0.5 rounded-full bg-black/75 text-[#FBF8F3] font-mono-batch text-[10px] font-medium shrink-0">
              📷 ${photoCount}
            </span>
          </div>

          <!-- Clean, Uncluttered Card Body -->
          <div class="p-4 sm:p-5 flex-1 flex flex-col justify-between">
            <div>
              <div class="flex items-center justify-between gap-2 text-[11px] font-mono-batch text-[#5C645E] mb-1.5">
                <span class="truncate">${p.category.toUpperCase()} · ${p.size}</span>
                <span class="px-1.5 py-0.5 rounded bg-[#9E3B24]/10 text-[#9E3B24] font-bold shrink-0">Save ${discountPct}%</span>
              </div>
              <button type="button" data-open-pdp="${p.sku}" class="pdp-jump-btn text-left block w-full">
                <h3 class="prod-card-title font-serif-editorial text-xl font-bold text-[#1E2D24] hover:text-[#9E3B24] transition">${p.title}</h3>
              </button>
              <p class="prod-card-summary text-xs text-[#5C645E] mt-1.5">${p.summary}</p>
            </div>

            <div class="mt-auto pt-3">
              <div class="pt-2.5 border-t border-[#F3EDE2] flex items-center justify-between gap-2 text-[10px] font-mono-batch text-[#5C645E]">
                <span class="font-semibold text-[#1E2D24]">${unitLabel} · ${p.price >= PAHADAN_SHIP.freeFrom ? '🚚 Free Ship' : '📦 Drahal Batch'}</span>
                <button type="button" data-open-pdp="${p.sku}" class="pdp-jump-btn text-[#9E3B24] font-bold hover:underline shrink-0">
                  Details &amp; Gallery →
                </button>
              </div>
            </div>
          </div>

          <!-- Uniform Card Footer with Clear Price, Add to Cart & Buy Now -->
          <div class="px-4 sm:px-5 py-3.5 bg-[#FBF8F3] border-t border-[#E2D9C8] flex flex-wrap items-center justify-between gap-2 shrink-0">
            <div>
              <div class="flex items-baseline gap-1.5">
                <span class="text-lg font-bold text-[#1E2D24]">${formatINR(p.price)}</span>
                <span class="text-xs line-through text-[#5C645E]">${formatINR(p.mrp)}</span>
              </div>
              <span class="text-[10px] text-[#5C645E] block">Incl. of all taxes</span>
            </div>
            ${actionBtns}
          </div>
        </article>
      `;
    }

    function renderHomeProducts() {
      const container = document.getElementById("home-product-grid");
      const filtered = PRODUCTS.filter(p => {
        if (homeTabFilter === "all") return true;
        if (homeTabFilter === "Trial") return p.isTrial;
        return p.category === homeTabFilter;
      });
      container.innerHTML = filtered.map(renderProductCard).join("");
    }

    function renderHomeReviews() {
      const grid = document.getElementById("home-reviews-grid");
      if (!grid) return;
      const list = GOOGLE_REVIEWS.filter(r => {
        if (reviewCategoryFilter === "all") return true;
        return r.tags.includes(reviewCategoryFilter);
      });
      grid.innerHTML = list.map(r => `
        <article class="p-4 rounded-2xl bg-white border border-[#E2D9C8] shadow-2xs flex flex-col justify-between h-full">
          <div>
            <div class="flex items-center justify-between gap-2 mb-2">
              <span class="text-[#C88A2B] text-xs font-bold tracking-tight">★★★★★ 5.0</span>
              <span class="px-2 py-0.5 rounded-full bg-[#F3EDE2] text-[#1E2D24] font-mono-batch text-[10px] font-semibold">${r.badge}</span>
            </div>
            <blockquote class="text-xs text-[#1C241E] italic leading-relaxed">
              &ldquo;${r.quote}&rdquo;
            </blockquote>
          </div>
          <div class="pt-3 mt-3 border-t border-[#F3EDE2] flex items-center justify-between gap-2">
            <div class="min-w-0">
              <div class="text-xs font-bold text-[#1E2D24] truncate">— ${r.author}</div>
              <div class="text-[10px] text-[#5C645E] truncate">✓ ${r.productLabel}</div>
            </div>
            <button type="button" data-open-pdp="${r.productRef}" class="pdp-jump-btn px-2.5 py-1 rounded-lg bg-[#F3EDE2] hover:bg-[#C88A2B] text-[#1E2D24] font-mono-batch text-[10px] font-bold shrink-0 transition">
              Shop →
            </button>
          </div>
        </article>
      `).join("");
    }

    function renderCollectionProducts() {
      const container = document.getElementById("collection-product-grid");
      const emptyState = document.getElementById("collection-empty-state");
      // Keep the collection heading matched to the category being shown (search engines and shoppers read it as the page topic).
      const pfHeading = document.getElementById("collection-heading");
      if (pfHeading) {
        const pfNames = { all: "All Mountain Pantry Staples", Ghee: "Himachali Cow Desi Bilona Ghee", Honey: "Himalayan Wild Forest Honey", Aachar: "Homemade Pahadi Achaar", Trial: "Trial Packs" };
        const pfCount = PRODUCTS.filter(p => colCatFilter === "all" ? true : colCatFilter === "Trial" ? p.isTrial : p.category === colCatFilter).length;
        pfHeading.textContent = (pfNames[colCatFilter] || colCatFilter) + " (" + pfCount + (pfCount === 1 ? " jar)" : " jars)");
      }

      let list = PRODUCTS.filter(p => {
        if (colCatFilter === "Trial" && !p.isTrial) return false;
        if (colCatFilter !== "all" && colCatFilter !== "Trial" && p.category !== colCatFilter) return false;
        if (colInStockOnly && !p.inStock) return false;
        if (colSearchQuery.trim() !== "") {
          const q = colSearchQuery.toLowerCase();
          const match = p.title.toLowerCase().includes(q) || p.summary.toLowerCase().includes(q) || p.category.toLowerCase().includes(q) || p.ingredients.toLowerCase().includes(q);
          if (!match) return false;
        }
        return true;
      });

      if (colSortBy === "price-asc") list.sort((a, b) => a.price - b.price);
      else if (colSortBy === "price-desc") list.sort((a, b) => b.price - a.price);
      else if (colSortBy === "savings") list.sort((a, b) => ((b.mrp - b.price) / b.mrp) - ((a.mrp - a.price) / a.mrp));

      if (list.length === 0) {
        container.innerHTML = "";
        emptyState.classList.remove("hidden");
      } else {
        emptyState.classList.add("hidden");
        container.innerHTML = list.map(renderProductCard).join("");
      }
    }

    // MULTI-PHOTO PDP RENDERER — ABOVE-THE-FOLD 'ADD TO CART' & 'BUY NOW' FIRST, BUNDLES & TIERS BELOW!
    function renderPDP() {
      // Product title is the page H1 only on product pages; elsewhere the PDP view is hidden, so use H2.
      const pfPdpH = (window.PAHADAN_INITIAL_VIEW && window.PAHADAN_INITIAL_VIEW.view === "pdp") ? "h1" : "h2";
      const p = getProduct(activePdpSku);
      document.querySelectorAll("[data-pf-qf-handle]").forEach((box) => { box.hidden = !(p && box.dataset.pfQfHandle === p.handle); });
      const selector = document.getElementById("pdp-sku-selector");
      if (selector) selector.value = p.sku;
      const bcTitle = document.getElementById("pdp-breadcrumb-title");
      if (bcTitle) bcTitle.textContent = p.shortTitle || p.title;

      const gallery = p.gallery && p.gallery.length ? p.gallery : [{ key: p.imageKey, caption: p.title }];
      if (activePdpGalleryIdx >= gallery.length) activePdpGalleryIdx = 0;
      const activeSlide = gallery[activePdpGalleryIdx];
      const mainImgSrc = ASSETS[activeSlide.key] || ASSETS[p.imageKey];

      const discountPct = Math.round(((p.mrp - p.price) / p.mrp) * 100);
      const unitPrice100 = ((p.price / p.netQty) * 100).toFixed(0);

      // Thumbnails HTML
      const thumbsHtml = gallery.map((g, idx) => {
        const tSrc = ASSETS[g.key];
        const isActive = idx === activePdpGalleryIdx;
        return `
          <button type="button" data-pdp-thumb="${idx}" class="pdp-thumb-btn rounded-xl overflow-hidden border-2 transition ${isActive ? 'border-[#9E3B24] ring-2 ring-[#C88A2B]/50 scale-105' : 'border-[#E2D9C8] opacity-75 hover:opacity-100'} w-16 h-16 sm:w-20 sm:h-20 shrink-0 bg-white">
            <img src="${tSrc}" alt="${g.caption}" class="w-full h-full object-cover" />
          </button>
        `;
      }).join("");

      // Claims badges
      const claimsHtml = (p.claims || []).map(c => `
        <span class="px-2.5 py-1 rounded-full bg-[#D1E7DD] text-[#1E2D24] font-mono-batch text-[10px] font-bold">✓ ${c}</span>
      `).join("");

      // Nutrition Table HTML
      let nutritionHtml = "";
      if (p.nutritionPer100) {
        const nRows = p.nutritionPer100.rows.map(r => `
          <tr class="border-b border-[#E2D9C8]">
            <td class="py-1.5 px-2.5 font-medium text-[#1E2D24]">${r[0]}</td>
            <td class="py-1.5 px-2.5 font-mono-batch font-bold text-[#1E2D24]">${r[1]}</td>
            <td class="py-1.5 px-2.5 font-mono-batch text-[#5C645E] text-right">${r[2]}</td>
          </tr>
        `).join("");
        nutritionHtml = `
          <div class="bg-white rounded-xl border border-[#E2D9C8] overflow-hidden mt-2">
            <div class="px-3 py-2 bg-[#1E2D24] text-white flex flex-wrap items-center justify-between gap-1 text-[11px] font-mono-batch">
              <span>NUTRITIONAL INFORMATION (Per 100${p.unit})</span>
              <span class="text-[#C88A2B]">${p.nutritionPer100.servingSize}</span>
            </div>
            <div class="overflow-x-auto">
              <table class="w-full text-left text-xs">
                <thead>
                  <tr class="bg-[#F3EDE2] text-[#5C645E] text-[10px] font-mono-batch uppercase">
                    <th class="py-1.5 px-2.5">Nutrient</th>
                    <th class="py-1.5 px-2.5">Per 100${p.unit}</th>
                    <th class="py-1.5 px-2.5 text-right">% RDA / Serve</th>
                  </tr>
                </thead>
                <tbody>${nRows}</tbody>
              </table>
            </div>
          </div>
        `;
      }

      // Full-Name, Non-Truncated Pack-Size & Flavour Variant Selector (Above the Fold)
      const siblingSkus = PRODUCTS.filter(item => item.category === p.category);
      let variantSelectorHtml = "";
      if (p.category === "Aachar") {
        // Group pickles by flavour so size variants and flavour switches show 100% complete names without truncation
        const flavourKey = p.sku.includes("-PG") ? "-PG" : p.sku.includes("-AM") ? "-AM" : "-KM";
        const sameFlavourSizes = siblingSkus.filter(sib => sib.sku.includes(flavourKey));
        const sizeCards = sameFlavourSizes.map(sib => {
          const sibUnit100 = ((sib.price / sib.netQty) * 100).toFixed(0);
          const isSelected = sib.sku === p.sku;
          const sizeHeadline = sib.isTrial ? "200g Trial Glass Jar" : "500g Family Glass Jar";
          return `
            <button type="button" data-open-pdp="${sib.sku}" class="pdp-jump-btn p-3 rounded-xl border text-left transition flex flex-col justify-between ${isSelected ? 'border-2 border-[#1E2D24] bg-[#F3EDE2] shadow-2xs' : 'border-[#E2D9C8] bg-white hover:border-[#1E2D24]'}">
              <div class="flex flex-wrap items-center justify-between gap-1 mb-1">
                <span class="font-mono-batch text-[11px] font-bold text-[#9E3B24] uppercase">${sizeHeadline}</span>
                ${!sib.isTrial ? '<span class="px-1.5 py-0.5 rounded bg-[#C88A2B] text-[#141F18] font-mono-batch text-[9px] font-bold">Best Value</span>' : '<span class="px-1.5 py-0.5 rounded bg-[#1E2D24]/10 text-[#1E2D24] font-mono-batch text-[9px] font-bold">Starter Size</span>'}
              </div>
              <div class="font-bold text-xs text-[#1E2D24] leading-snug break-words">${sib.title}</div>
              <div class="flex items-baseline justify-between gap-2 mt-2 pt-1.5 border-t border-[#E2D9C8]/70">
                <div>
                  <span class="font-mono-batch text-sm font-bold text-[#1E2D24]">${formatINR(sib.price)}</span>
                  <span class="font-mono-batch text-[10px] line-through text-[#5C645E] ml-1">MRP ${formatINR(sib.mrp)}</span>
                </div>
                <span class="font-mono-batch text-[10px] text-[#5C645E]">₹${sibUnit100}/100g</span>
              </div>
            </button>
          `;
        }).join("");

        const flavourFamilies = [
          { key: "-PG", name: "🧄 Barot Special Pink Garlic Pickle", sku500: "PF-ACH-PG500", sku200: "PF-ACH-PG200T" },
          { key: "-AM", name: "🌿 Himalayan Forest Amla Pickle", sku500: "PF-ACH-AM500", sku200: "PF-ACH-AM200T" },
          { key: "-KM", name: "🥭 Desi Kaccha Mango Pickle", sku500: "PF-ACH-KM500", sku200: "PF-ACH-KM200T" }
        ];
        const flavourTabs = flavourFamilies.map(fam => {
          const isCurrentFam = flavourKey === fam.key;
          const targetSku = p.isTrial ? fam.sku200 : fam.sku500;
          const targetProd = getProduct(targetSku);
          return `
            <button type="button" data-open-pdp="${targetSku}" class="pdp-jump-btn p-2.5 rounded-xl border text-left transition ${isCurrentFam ? 'border-2 border-[#9E3B24] bg-[#FBF8F3] font-bold text-[#1E2D24]' : 'border-[#E2D9C8] bg-white text-[#5C645E] hover:border-[#1E2D24]'}">
              <div class="text-xs font-bold text-[#1E2D24] leading-snug break-words">${fam.name}</div>
              <div class="font-mono-batch text-[10px] text-[#9E3B24] mt-1">${targetProd.netQty}g · ${formatINR(targetProd.price)}</div>
            </button>
          `;
        }).join("");

        variantSelectorHtml = `
          <div class="space-y-3">
            <div>
              <div class="flex items-center justify-between mb-1.5">
                <span class="text-xs font-bold text-[#1E2D24]">1. Select Jar Size (${p.shortTitle.replace(/ 500g| 200g.*/, '')}):</span>
                <span class="font-mono-batch text-[10px] text-[#5C645E]">Full variant details</span>
              </div>
              <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5">${sizeCards}</div>
            </div>
            <div>
              <div class="text-[11px] font-bold text-[#5C645E] mb-1.5">2. Or Switch Homemade Pickle Flavour:</div>
              <div class="grid grid-cols-1 sm:grid-cols-3 gap-2">${flavourTabs}</div>
            </div>
          </div>
        `;
      } else {
        const gridClass = siblingSkus.length === 2 ? "grid-cols-1 sm:grid-cols-2" : "grid-cols-1 sm:grid-cols-3";
        const cards = siblingSkus.map(sib => {
          const sibUnit100 = ((sib.price / sib.netQty) * 100).toFixed(0);
          const isBestValue = !sib.isTrial && sib.netQty >= 650;
          const isSelected = sib.sku === p.sku;
          return `
            <button type="button" data-open-pdp="${sib.sku}" class="pdp-jump-btn p-3 rounded-xl border text-left transition flex flex-col justify-between ${isSelected ? 'border-2 border-[#1E2D24] bg-[#F3EDE2] shadow-2xs' : 'border-[#E2D9C8] bg-white hover:border-[#1E2D24]'}">
              <div class="flex flex-wrap items-center justify-between gap-1 mb-1">
                <span class="font-mono-batch text-[11px] font-bold text-[#9E3B24] uppercase">${sib.netQty}${sib.unit} ${sib.isTrial ? 'Trial Pack' : 'Glass Jar'}</span>
                ${isBestValue ? '<span class="px-1.5 py-0.5 rounded bg-[#C88A2B] text-[#141F18] font-mono-batch text-[9px] font-bold">Best Value</span>' : ''}
              </div>
              <div class="font-bold text-xs text-[#1E2D24] leading-snug break-words">${sib.title}</div>
              <div class="flex items-baseline justify-between gap-2 mt-2 pt-1.5 border-t border-[#E2D9C8]/70">
                <div>
                  <span class="font-mono-batch text-sm font-bold text-[#1E2D24]">${formatINR(sib.price)}</span>
                  <span class="font-mono-batch text-[10px] line-through text-[#5C645E] ml-1">MRP ${formatINR(sib.mrp)}</span>
                </div>
                <span class="font-mono-batch text-[10px] text-[#5C645E]">₹${sibUnit100}/100${sib.unit}</span>
              </div>
            </button>
          `;
        }).join("");
        variantSelectorHtml = `
          <div>
            <div class="flex items-center justify-between mb-1.5">
              <span class="text-xs font-bold text-[#1E2D24]">Select ${p.category} Pack Size / Variant:</span>
              <span class="font-mono-batch text-[10px] text-[#5C645E]">Tap to switch size</span>
            </div>
            <div class="grid ${gridClass} gap-2.5">${cards}</div>
          </div>
        `;
      }

      // Multi-Jar Quantity Tiers (brief v3: no multi-jar discount; WELCOME100 is the only code)
      const tier1Price = p.price;
      const tier2Price = p.price * 2;
      const tier2Save = (p.price * 2) - tier2Price;
      const tier3Price = p.price * 3;
      const tier3Save = (p.price * 3) - tier3Price;
      const activeTierTotal = pdpPackTier === 3 ? tier3Price : pdpPackTier === 2 ? tier2Price : p.price * pdpQty;

      // Recommendation Matrix & Frequently Bought Together Setup (Placed Below Primary CTA)
      const recMeta = RECOMMENDATION_MATRIX[p.sku] || RECOMMENDATION_MATRIX["PF-GHEE-1000"];
      const fbtItem1 = getProduct(recMeta.primaryCrossSell || "PF-ACH-PG200T");
      const fbtItem2 = getProduct(recMeta.secondaryCrossSell || "PF-HON-WF250");
      if (!fbtCheckedSkus || fbtCheckedSkus.length === 0 || fbtCheckedSkus[0] !== p.sku) {
        fbtCheckedSkus = [p.sku, fbtItem1.sku];
      }
      const fbtCandidates = [p, fbtItem1, fbtItem2].filter((v, idx, arr) => v && arr.findIndex(x => x.sku === v.sku) === idx);
      const fbtRawSum = fbtCandidates.filter(item => fbtCheckedSkus.includes(item.sku)).reduce((acc, item) => acc + item.price, 0);
      const fbtComboPrice = fbtRawSum;
      const fbtComboSave = fbtRawSum - fbtComboPrice;

      const container = document.getElementById("pdp-dynamic-container");
      container.innerHTML = `
        <div class="resp-grid-12 grid grid-cols-1 lg:grid-cols-12 gap-7 lg:gap-10 items-start">
          <!-- Left 6 Cols: Interactive Multi-Photo Gallery -->
          <div class="lg:col-span-6 resp-col-span space-y-3 min-w-0">
            <div class="rounded-3xl overflow-hidden border-2 border-[#E2D9C8] bg-white shadow-sm">
              <div class="relative aspect-square w-full bg-[#F3EDE2]">
                <img id="pdp-main-hero-img" src="${mainImgSrc}" alt="${activeSlide.caption}" class="w-full h-full object-cover" />
                <button type="button" id="pdp-slide-prev" class="absolute left-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-[#1E2D24]/85 hover:bg-[#9E3B24] text-white font-bold text-base flex items-center justify-center shadow-md transition" aria-label="Previous Image">‹</button>
                <button type="button" id="pdp-slide-next" class="absolute right-3 top-1/2 -translate-y-1/2 w-9 h-9 rounded-full bg-[#1E2D24]/85 hover:bg-[#9E3B24] text-white font-bold text-base flex items-center justify-center shadow-md transition" aria-label="Next Image">›</button>
                <span class="absolute top-3.5 left-3.5 px-3 py-1 rounded-full bg-[#1E2D24]/90 text-[#C88A2B] font-mono-batch text-[11px] font-bold">
                  Photo ${activePdpGalleryIdx + 1} of ${gallery.length}
                </span>
                <button type="button" id="btn-pdp-zoom" class="absolute top-3.5 right-3.5 px-2.5 py-1 rounded-full bg-black/75 hover:bg-black text-white font-mono-batch text-[10px] font-semibold transition">
                  🔍 Zoom
                </button>
              </div>
              <!-- Dedicated Caption & Batch Bar Below Image -->
              <div class="p-3 bg-[#141F18] text-white flex flex-col sm:flex-row sm:items-center justify-between gap-2">
                <span class="text-xs font-medium text-[#E2D9C8] leading-snug">${activeSlide.caption}</span>
                <button type="button" data-inspect-batch="${p.batchCode}" class="batch-modal-btn px-3 py-1 rounded-lg bg-[#C88A2B] text-[#141F18] font-mono-batch text-[11px] font-bold shrink-0 hover:bg-white transition text-center">
                  🔬 Batch #${p.batchCode}
                </button>
              </div>
            </div>

            <!-- Interactive Thumbnail Strip -->
            <div class="flex items-center gap-2 overflow-x-auto no-scrollbar py-0.5">
              ${thumbsHtml}
            </div>

            <!-- Compact 1-Row Origin & Spec Strip (3 Cols on all screens so it never pushes Mobile Buy Box down) -->
            <div class="grid grid-cols-1 sm:grid-cols-3 gap-2 text-center text-[11px]">
              <div class="p-2.5 rounded-xl bg-white border border-[#E2D9C8]">
                <div class="font-bold text-[#1E2D24]">📏 Dimensions</div>
                <div class="text-[11px] text-[#5C645E] mt-0.5 whitespace-normal break-words" title="${p.dimensions}">${p.size}</div>
              </div>
              <div class="p-2.5 rounded-xl bg-white border border-[#E2D9C8]">
                <div class="font-bold text-[#1E2D24]">⏳ Shelf Life</div>
                <div class="text-[11px] text-[#5C645E] mt-0.5 whitespace-normal break-words" title="${p.shelfLife}">${p.shelfLife.replace('Best Before ', '')}</div>
              </div>
              <div class="p-2.5 rounded-xl bg-white border border-[#E2D9C8]">
                <div class="font-bold text-[#1E2D24]">🛡️ FSSAI Lic.</div>
                <div class="text-[10px] font-mono-batch text-[#9E3B24] mt-0.5">#23326011006238</div>
              </div>
            </div>
          </div>

          <!-- Right 6 Cols: EFFORTLESS ABOVE-THE-FOLD BUY BOX FIRST, OPTIONAL BUNDLES BELOW -->
          <div class="lg:col-span-6 resp-col-span space-y-4 min-w-0">
            <!-- 1. Product Header, Verified Rating & Purity Badges -->
            <div>
              <div class="flex flex-wrap items-center justify-between gap-2 text-xs font-mono-batch text-[#9E3B24]">
                <div class="flex flex-wrap items-center gap-1.5 uppercase">
                  <span>${p.category}</span>
                  <span>·</span>
                  <span>SKU: ${p.officialSku || p.sku}</span>
                  <span>·</span>
                  <span class="text-[#1E2D24] font-bold">${p.inStock ? "✓ In Stock" : "⚠️ Sold Out"}</span>
                </div>
                <a href="https://share.google/AzDoExL79FQmgLeog" target="_blank" rel="noopener noreferrer" class="px-2 py-0.5 rounded-full bg-[#F3EDE2] text-[#1E2D24] font-bold text-[11px] hover:bg-[#C88A2B] transition">
                  ★★★★★ 5.0 (42 Reviews) ↗
                </a>
              </div>
              <${pfPdpH} class="font-serif-editorial text-2xl sm:text-4xl font-bold text-[#1E2D24] mt-1 leading-tight">${p.title}</${pfPdpH}>
              <p class="text-xs sm:text-sm text-[#5C645E] mt-1.5 leading-relaxed">${p.summary}</p>
              <div class="flex flex-wrap gap-1.5 mt-2.5">${claimsHtml}</div>
            </div>

            <!-- 2. Crystal-Clear Above-the-Fold Price, Pack Size & IMMEDIATE ADD TO CART / BUY NOW BOX -->
            <div class="p-4 sm:p-5 rounded-2xl bg-white border-2 border-[#1E2D24] shadow-md space-y-4">
              <!-- Price & Shipping Row -->
              <div class="flex flex-col sm:flex-row sm:items-baseline justify-between gap-2 pb-3 border-b border-[#F3EDE2]">
                <div>
                  <div class="flex flex-wrap items-baseline gap-2">
                    <span class="text-3xl sm:text-4xl font-bold text-[#1E2D24]">${formatINR(p.price)}</span>
                    <span class="text-sm line-through text-[#5C645E]">MRP ${formatINR(p.mrp)}</span>
                    <span class="px-2 py-0.5 rounded bg-[#9E3B24]/15 text-[#9E3B24] font-mono-batch text-xs font-bold">Save ${discountPct}% (${formatINR(p.mrp - p.price)})</span>
                  </div>
                  <div class="text-[11px] text-[#5C645E] mt-1">
                    Inclusive of all taxes · Net Qty: <strong>${p.netQty} ${p.unit}</strong> (<strong>₹${unitPrice100} / 100${p.unit}</strong>)
                  </div>
                </div>
                <div class="sm:text-right font-mono-batch text-[11px] font-bold ${p.price >= PAHADAN_SHIP.freeFrom ? 'text-[#1E2D24] bg-[#D1E7DD] px-2.5 py-1 rounded-lg' : 'text-[#9E3B24] bg-[#F3EDE2] px-2.5 py-1 rounded-lg'}">
                  ${p.price >= PAHADAN_SHIP.freeFrom ? '🚚 FREE Pan-India Shipping' : '🚚 Free Ship ≥ ₹499 (or with any Combo)'}
                </div>
              </div>

              <!-- Full-Name Pack Size & Variant Selector -->
              ${variantSelectorHtml}

              <!-- IMMEDIATE PRIMARY PURCHASE BUTTONS: QUANTITY + ADD TO CART + BUY NOW (ABOVE THE FOLD!) -->
              <div class="pt-1 space-y-2.5">
                <div class="flex flex-col sm:flex-row items-stretch sm:items-center gap-2.5">
                  <!-- Quantity Stepper -->
                  <div class="flex items-center justify-between sm:justify-start border-2 border-[#1E2D24] rounded-xl bg-[#FBF8F3] shrink-0">
                    <button type="button" id="pdp-qty-dec" class="px-3.5 py-2.5 text-sm font-bold text-[#1E2D24] hover:bg-[#E2D9C8] rounded-l-xl" aria-label="Decrease quantity">−</button>
                    <span id="pdp-qty-val" class="px-3.5 py-2.5 font-mono-batch text-xs font-bold text-[#1E2D24]">${pdpQty}</span>
                    <button type="button" id="pdp-qty-inc" class="px-3.5 py-2.5 text-sm font-bold text-[#1E2D24] hover:bg-[#E2D9C8] rounded-r-xl" aria-label="Increase quantity">+</button>
                  </div>

                  ${p.inStock
                    ? `<!-- Primary Button 1: Unmistakable ADD TO CART -->
                       <button type="button" id="pdp-add-btn" data-pdp-add="${p.sku}" class="flex-1 py-3.5 px-4 rounded-xl bg-[#1E2D24] hover:bg-[#2c4235] text-white font-bold text-xs sm:text-sm uppercase tracking-wide transition shadow-md inline-flex items-center justify-center gap-1.5">
                         <span>🛒 Add to Cart · ${formatINR(activeTierTotal)}</span>
                       </button>
                       <!-- Primary Button 2: Instant Express BUY NOW -->
                       <button type="button" id="pdp-buy-now-btn" data-pdp-buy="${p.sku}" class="flex-1 py-3.5 px-4 rounded-xl bg-[#C88A2B] hover:bg-[#9E3B24] text-[#141F18] hover:text-white font-bold text-xs sm:text-sm uppercase tracking-wide transition shadow-md inline-flex items-center justify-center gap-1.5">
                         <span>⚡ Buy Now · Express</span>
                       </button>`
                    : `<button type="button" data-notify-sku="${p.sku}" class="flex-1 py-3.5 px-6 rounded-xl bg-[#9E3B24] text-white font-bold text-xs uppercase tracking-wider transition">
                         🔔 Get WhatsApp Alert When Batch Restocks
                       </button>`
                  }
                </div>

                <!-- Instant Trust & Reassurance Microcopy Directly Under Buy Buttons (Prepaid Only, Pan-India Delivery) -->
                <div class="flex flex-wrap items-center justify-between gap-2 text-[11px] text-[#5C645E] pt-1">
                  <span>✓ <strong>100% Secure Prepaid</strong> (UPI / Cards / NetBanking)</span>
                  <span>✓ Carefully packed</span>
                  <span>✓ <strong>100% Glass-Breakage</strong> Cover</span>
                </div>
              </div>

              <!-- Pincode Delivery Estimator (Stacked Clean Layout — Zero Overlap on Any Viewport!) -->
              <div class="pt-3 border-t border-[#F3EDE2] space-y-2 text-xs">
                <div class="flex flex-wrap items-center justify-between gap-2">
                  <label for="pdp-pincode-input" class="font-bold text-[#1E2D24] flex items-center gap-1.5">
                    <span>📦 Check Estimated Delivery Date:</span>
                  </label>
                  <div class="flex items-center gap-2 flex-1 sm:flex-initial justify-end">
                    <input type="text" id="pdp-pincode-input" maxlength="6" placeholder="Enter 6-digit PIN" class="px-3 py-1.5 rounded-lg border border-[#E2D9C8] font-mono-batch text-xs w-40 bg-[#FBF8F3] focus:outline-none focus:border-[#1E2D24]" />
                    <button type="button" id="btn-check-pincode" class="px-3.5 py-1.5 rounded-lg bg-[#1E2D24] text-white font-bold text-xs hover:bg-[#9E3B24] transition shrink-0">Check</button>
                  </div>
                </div>
                <div id="pdp-pincode-result" class="w-full px-3 py-2 rounded-lg bg-[#F3EDE2]/70 border border-[#E2D9C8] text-[11px] font-medium text-[#1E2D24] leading-snug">
                  🚚 Prepared for dispatch within 1–3 business days (3–5 business days delivery across India).
                </div>
              </div>
            </div>

            <!-- ===================================================================== -->
            <!-- 3. BELOW THE PRIMARY CTA: OPTIONAL VALUE UPGRADES & BUNDLES           -->
            <!-- Never blocks single-item checkout; rewards shoppers who scroll/bundle -->
            <!-- ===================================================================== -->
            <div class="pt-2 space-y-4">
              <div class="flex items-center gap-2">
                <span class="px-2.5 py-0.5 rounded-full bg-[#C88A2B]/20 text-[#9E3B24] font-mono-batch text-[10px] font-bold uppercase tracking-wider">Stock Up or Pair</span>
                <span class="text-xs font-semibold text-[#5C645E]">Want to stock up or pair with a meal?</span>
              </div>

              <!-- Optional Upgrade A: Multi-Jar Pantry Refill Tier Selector (Buy More, Save More) -->
              <div class="p-3.5 rounded-2xl bg-[#F3EDE2]/80 border border-[#E2D9C8] space-y-2.5">
                <div class="flex items-center justify-between">
                  <span class="text-xs font-bold text-[#1E2D24]">Option 1 · Multi-Jar Refill Pack (Same SKU):</span>
                  <span class="font-mono-batch text-[10px] text-[#9E3B24] font-semibold">Tap to update quantity above</span>
                </div>
                <div class="resp-grid-3 grid grid-cols-1 sm:grid-cols-3 gap-2 items-stretch">
                  <button type="button" data-pdp-tier="1" class="pdp-tier-btn p-2.5 rounded-xl border text-left transition ${pdpPackTier === 1 ? 'border-2 border-[#1E2D24] bg-white shadow-2xs' : 'border-[#E2D9C8] bg-[#FBF8F3] hover:bg-white'}">
                    <div class="font-bold text-xs text-[#1E2D24]">1 Jar (Single)</div>
                    <div class="font-mono-batch text-xs font-bold text-[#9E3B24] mt-0.5">${formatINR(tier1Price)}</div>
                    <div class="text-[10px] text-[#5C645E]">Standard single jar</div>
                  </button>
                  <button type="button" data-pdp-tier="2" class="pdp-tier-btn p-2.5 rounded-xl border text-left transition relative ${pdpPackTier === 2 ? 'border-2 border-[#1E2D24] bg-white shadow-2xs' : 'border-[#E2D9C8] bg-[#FBF8F3] hover:bg-white'}">
                    <div class="font-bold text-xs text-[#1E2D24]">2 Jars (Refill Duo)</div>
                    <div class="font-mono-batch text-xs font-bold text-[#1E2D24]">${formatINR(tier2Price)}</div>
                    <div class="text-[10px] text-[#5C645E]">${tier2Price >= PAHADAN_SHIP.freeFrom ? 'Ships FREE' : 'Stock-up size'}</div>
                  </button>
                  <button type="button" data-pdp-tier="3" class="pdp-tier-btn p-2.5 rounded-xl border text-left transition relative ${pdpPackTier === 3 ? 'border-2 border-[#1E2D24] bg-white shadow-2xs' : 'border-[#E2D9C8] bg-[#FBF8F3] hover:bg-white'}">
                    <div class="font-bold text-xs text-[#1E2D24]">3 Jars (Family Pack)</div>
                    <div class="font-mono-batch text-xs font-bold text-[#1E2D24]">${formatINR(tier3Price)}</div>
                    <div class="text-[10px] text-[#5C645E]">${tier3Price >= PAHADAN_SHIP.freeFrom ? 'Ships FREE' : 'Family size'}</div>
                  </button>
                </div>
                ${recMeta.upgradeSku ? `
                  <button type="button" data-open-pdp="${recMeta.upgradeSku}" class="pdp-jump-btn w-full p-2.5 rounded-xl bg-[#C88A2B]/15 hover:bg-[#C88A2B]/30 border border-[#C88A2B] flex items-center justify-between gap-2 text-xs text-[#1E2D24] transition">
                    <span>💡 <strong>Bigger Jar Value:</strong> ${recMeta.upgradePitch}</span>
                    <span class="font-mono-batch font-bold text-[#9E3B24] shrink-0">View Larger Size →</span>
                  </button>
                ` : ''}
              </div>

              <!-- Optional Upgrade B: 'Frequently Bought Together / Complete Your Pahadi Meal' -->
              <div class="p-4 rounded-2xl bg-[#FBF8F3] border-2 border-[#C88A2B] space-y-3">
                <div class="flex flex-wrap items-center justify-between gap-2">
                  <div>
                    <span class="font-mono-batch text-[10px] uppercase text-[#9E3B24] font-bold block">🍽️ Option 2 · Complete Your Pahadi Plate</span>
                    <h2 class="font-serif-editorial text-xl font-bold text-[#1E2D24]">Frequently Enjoyed Together in Indian Homes</h2>
                  </div>
                  <span class="px-2.5 py-1 rounded-full bg-[#C88A2B]/20 text-[#1E2D24] font-mono-batch text-[10px] font-bold">
                    ${fbtCheckedSkus.length >= 2 ? '✓ Pairing Selected' : 'Select 2+ items to pair'}
                  </span>
                </div>
                <p class="text-[11px] text-[#5C645E] leading-relaxed">${recMeta.pairingReason}</p>
                <div class="space-y-2">
                  ${fbtCandidates.map((item, idx) => {
                    const isChecked = fbtCheckedSkus.includes(item.sku);
                    return `
                      <label class="flex items-center justify-between gap-3 p-2.5 rounded-xl border cursor-pointer transition ${isChecked ? 'bg-white border-[#1E2D24]' : 'bg-[#F3EDE2]/50 border-[#E2D9C8] opacity-75'}">
                        <div class="flex items-center gap-2.5 min-w-0">
                          <input type="checkbox" data-fbt-sku="${item.sku}" class="fbt-checkbox w-4 h-4 accent-[#1E2D24] rounded shrink-0" ${isChecked ? 'checked' : ''} />
                          <img src="${ASSETS[item.imageKey]}" alt="${item.shortTitle}" class="w-10 h-10 rounded-lg object-cover border border-[#E2D9C8] shrink-0" />
                          <div class="text-xs min-w-0">
                            <div class="font-bold text-[#1E2D24] truncate">${idx === 0 ? 'This Item: ' : '+ Pair With: '}${item.shortTitle}</div>
                            <div class="text-[10px] text-[#5C645E] truncate">${item.size} · MRP ${formatINR(item.mrp)}</div>
                          </div>
                        </div>
                        <div class="font-mono-batch text-xs font-bold text-[#1E2D24] shrink-0">${formatINR(item.price)}</div>
                      </label>
                    `;
                  }).join("")}
                </div>
                <div class="resp-flex-col pt-2 border-t border-[#E2D9C8] flex flex-col sm:flex-row sm:items-center justify-between gap-3">
                  <div>
                    <div class="text-[10px] font-mono-batch uppercase text-[#5C645E]">Combined Pairing Price (${fbtCheckedSkus.length} ${fbtCheckedSkus.length === 1 ? 'Jar' : 'Jars'})</div>
                    <div class="flex items-baseline gap-2">
                      <span class="text-xl font-bold text-[#1E2D24]">${formatINR(fbtComboPrice)}</span>
                      ${fbtComboSave > 0 ? `<span class="text-xs line-through text-[#5C645E]">${formatINR(fbtRawSum)}</span><span class="text-xs font-bold text-[#9E3B24]">Save Extra ${formatINR(fbtComboSave)}</span>` : ''}
                    </div>
                  </div>
                  <button type="button" id="btn-add-fbt-combo" class="px-4 py-2.5 rounded-xl bg-[#C88A2B] hover:bg-[#1E2D24] text-[#141F18] hover:text-white font-bold text-xs transition whitespace-nowrap shadow-xs">
                    + Add Selected (${fbtCheckedSkus.length}) to Bag
                  </button>
                </div>
              </div>
            </div>

            <!-- 4. Accordions: Back-Label Nutrition, Ingredients & Legal Metrology with FSSAI QR -->
            <div class="divide-y divide-[#E2D9C8] border-t border-b border-[#E2D9C8] text-xs">
              <details class="py-3 group" open>
                <summary class="font-bold text-[#1E2D24] cursor-pointer flex justify-between items-center">
                  <span>1. Back-Label Ingredients, Allergen Info &amp; Nutritional Facts</span>
                  <span class="text-[#9E3B24]">▾</span>
                </summary>
                <div class="pt-2 text-[#5C645E] space-y-2 leading-relaxed">
                  <p><strong>Ingredients:</strong> ${p.ingredients}</p>
                  <p><strong>Allergen / Storage Info:</strong> ${p.allergenNote}</p>
                  ${nutritionHtml}
                </div>
              </details>
              <details class="py-3 group">
                <summary class="font-bold text-[#1E2D24] cursor-pointer flex justify-between items-center">
                  <span>2. Best Practices, Storage &amp; Culinary Pairing</span>
                  <span class="text-[#9E3B24]">▾</span>
                </summary>
                <div class="pt-2 text-[#5C645E] space-y-1.5 leading-relaxed">
                  <p><strong>Best Practices:</strong> ${p.storage}</p>
                  <p><strong>Shelf Life:</strong> ${p.shelfLife}</p>
                  <p><strong>How to Enjoy:</strong> ${p.pairings}</p>
                </div>
              </details>
              <details class="py-3 group" open>
                <summary class="font-bold text-[#1E2D24] cursor-pointer flex justify-between items-center">
                  <span>3. Packed &amp; Marketed By + Official FSSAI QR (#23326011006238)</span>
                  <span class="text-[#9E3B24]">▾</span>
                </summary>
                <div class="pt-3 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 bg-[#F3EDE2]/60 p-3.5 rounded-xl border border-[#E2D9C8]">
                  <div class="text-[#1C241E] space-y-1 font-mono-batch text-[11px] break-words">
                    <div>• <strong>Packed &amp; Marketed By:</strong> The Pahadan's Farm, Village Drahal, District Mandi, Himachal Pradesh, India — 175015</div>
                    <div>• <strong>FSSAI Lic. No.:</strong> <strong class="text-[#9E3B24]">23326011006238</strong></div>
                    <div>• <strong>Contact Us:</strong> +91 92172 24336 | pahadansfarm@gmail.com | @pahadansfarm</div>
                  </div>
                  <img src="${ASSETS.FSSAI_QR}" alt="FSSAI QR 23326011006238" class="w-16 h-16 rounded-lg border border-[#1E2D24]/20 bg-white p-1 shrink-0 object-contain" />
                </div>
              </details>
            </div>

            <!-- 5. Verified Google Reviews Strip on PDP -->
            <div class="p-4 rounded-2xl bg-white border border-[#E2D9C8] space-y-3">
              <div class="flex flex-wrap items-center justify-between gap-2 border-b border-[#F3EDE2] pb-2.5">
                <div class="flex items-center gap-2">
                  <span class="inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#1E2D24] text-[#C88A2B] font-mono-batch text-[10px] font-bold">G</span>
                  <span class="font-bold text-xs text-[#1E2D24]">Verified Google Reviews (5.0 ★ · 42 Reviews)</span>
                </div>
                <a href="https://share.google/AzDoExL79FQmgLeog" target="_blank" rel="noopener noreferrer" class="text-[11px] font-bold text-[#9E3B24] hover:underline">Read all on Google ↗</a>
              </div>
              <div class="resp-grid-2 grid grid-cols-1 sm:grid-cols-2 gap-2.5 text-xs">
                ${GOOGLE_REVIEWS.filter(r => r.tags.includes(p.category)).slice(0, 2).map(r => `
                  <div class="p-3 rounded-xl bg-[#FBF8F3] border border-[#E2D9C8]">
                    <div class="text-[#C88A2B] text-xs">★★★★★ <span class="text-[10px] font-mono-batch text-[#5C645E] ml-1">${r.badge}</span></div>
                    <p class="text-[11px] text-[#1C241E] italic mt-1 leading-relaxed">&ldquo;${r.quote}&rdquo;</p>
                    <div class="text-[10px] font-bold text-[#1E2D24] mt-1.5">— ${r.author}</div>
                  </div>
                `).join("")}
              </div>
            </div>
          </div>
        </div>
      `;

      // Sync Mobile Sticky Bar with active PDP product
      const stickyTitle = document.getElementById("sticky-bar-title");
      const stickyAdd = document.getElementById("sticky-bar-add-btn");
      const stickyBuy = document.getElementById("sticky-bar-buy-btn");
      const stickyTag = document.getElementById("sticky-bar-tag");
      if (stickyTitle && stickyAdd && stickyTag) {
        stickyTitle.textContent = `${p.shortTitle} · ${formatINR(p.price)}`;
        stickyTag.textContent = p.inStock ? `Save ${discountPct}% · V.P.O. Drahal` : "Sold Out · Tap for Alert";
        if (p.inStock) {
          stickyAdd.setAttribute("data-quick-add", p.sku);
          stickyAdd.removeAttribute("data-notify-sku");
          stickyAdd.textContent = pdpQty > 1 ? `+ Add ${pdpQty} · ${formatINR(p.price * pdpQty)}` : `+ Add ${formatINR(p.price)}`;
          if (stickyBuy) {
            stickyBuy.setAttribute("data-buy-now", p.sku);
            stickyBuy.classList.remove("hidden");
          }
        } else {
          stickyAdd.removeAttribute("data-quick-add");
          stickyAdd.setAttribute("data-notify-sku", p.sku);
          stickyAdd.textContent = `🔔 Notify Me`;
          if (stickyBuy) stickyBuy.classList.add("hidden");
        }
      }

      // Attach PDP inner listeners
      document.getElementById("pdp-qty-dec").addEventListener("click", () => {
        if (pdpQty > 1) {
          pdpQty--;
          pdpPackTier = pdpQty <= 3 ? pdpQty : 1;
          renderPDP();
        }
      });
      document.getElementById("pdp-qty-inc").addEventListener("click", () => {
        pdpQty++;
        pdpPackTier = pdpQty <= 3 ? pdpQty : 1;
        renderPDP();
      });
      document.querySelectorAll(".pdp-tier-btn").forEach(btn => {
        btn.addEventListener("click", () => {
          const tier = Number(btn.getAttribute("data-pdp-tier"));
          pdpPackTier = tier;
          pdpQty = tier;
          // Brief v3: multi-jar packs no longer apply a code (WELCOME100 is the only one).
          renderPDP();
          showToast(`Selected ${tier}-Jar Pack — click Add to Cart or Buy Now above!`);
        });
      });
      document.querySelectorAll(".fbt-checkbox").forEach(cb => {
        cb.addEventListener("change", () => {
          const s = cb.getAttribute("data-fbt-sku");
          if (cb.checked) {
            if (!fbtCheckedSkus.includes(s)) fbtCheckedSkus.push(s);
          } else {
            if (fbtCheckedSkus.length > 1) fbtCheckedSkus = fbtCheckedSkus.filter(x => x !== s);
            else cb.checked = true;
          }
          renderPDP();
        });
      });
      const fbtAddBtn = document.getElementById("btn-add-fbt-combo");
      if (fbtAddBtn) {
        fbtAddBtn.addEventListener("click", () => {
          fbtCheckedSkus.forEach(s => {
            const prod = getProduct(s);
            if (prod && prod.inStock) {
              const ex = cart.find(i => i.sku === s);
              if (ex) ex.qty += 1;
              else cart.push({ sku: s, qty: 1 });
            }
          });
          // Brief v3: pairings no longer apply a code (WELCOME100 is the only one).
          renderCart();
          showAtcConfirmationBar(p.sku, fbtCheckedSkus.length, `${fbtCheckedSkus.length}-Jar Pahadi Meal Pairing`);
        });
      }
      const pdpAddBtn = document.getElementById("pdp-add-btn");
      if (pdpAddBtn) {
        pdpAddBtn.addEventListener("click", () => {
          addToCart(p.sku, pdpQty);
        });
      }
      const pdpBuyNowBtn = document.getElementById("pdp-buy-now-btn");
      if (pdpBuyNowBtn) {
        pdpBuyNowBtn.addEventListener("click", () => {
          buyNow(p.sku, pdpQty);
        });
      }
      document.getElementById("pdp-slide-prev").addEventListener("click", () => {
        activePdpGalleryIdx = (activePdpGalleryIdx - 1 + gallery.length) % gallery.length;
        renderPDP();
      });
      document.getElementById("pdp-slide-next").addEventListener("click", () => {
        activePdpGalleryIdx = (activePdpGalleryIdx + 1) % gallery.length;
        renderPDP();
      });
      document.getElementById("btn-pdp-zoom").addEventListener("click", () => {
        openModal(p.shortTitle + " — Studio View", `
          <img src="${mainImgSrc}" alt="${activeSlide.caption}" class="w-full h-auto rounded-xl border border-[#E2D9C8]" />
          <p class="text-xs text-[#1E2D24] font-medium pt-2">${activeSlide.caption}</p>
        `);
      });
      document.getElementById("btn-check-pincode").addEventListener("click", () => {
        const pin = document.getElementById("pdp-pincode-input").value.trim();
        const res = document.getElementById("pdp-pincode-result");
        if (/^[1-9][0-9]{5}$/.test(pin)) {
          const estDays = "3–5 business days";
          res.innerHTML = `<span class="text-[#1E2D24] font-semibold">✓ Deliverable to PIN ${pin}:</span> Estimated arrival in <strong>${estDays}</strong>.`;
        } else {
          res.innerHTML = `<span class="text-[#9E3B24] font-semibold">⚠️ Please enter a valid 6-digit Indian PIN code (e.g. 400001).</span>`;
        }
      });
      document.querySelectorAll(".pdp-thumb-btn").forEach(btn => {
        btn.addEventListener("click", () => {
          activePdpGalleryIdx = Number(btn.getAttribute("data-pdp-thumb"));
          renderPDP();
        });
      });
    }

    // BUNDLE BUILDER
    function initBundleBuilder() {
      const s1 = document.getElementById("bundle-slot-1");
      const s2 = document.getElementById("bundle-slot-2");
      const s3 = document.getElementById("bundle-slot-3");

      const inStockProducts = PRODUCTS.filter(p => p.inStock);
      const optionsHtml = inStockProducts.map(p => `<option value="${p.sku}">${p.shortTitle} — ${formatINR(p.price)} (MRP ${formatINR(p.mrp)})</option>`).join("");

      s1.innerHTML = optionsHtml;
      s2.innerHTML = optionsHtml;
      s3.innerHTML = optionsHtml;

      s1.value = "PF-GHEE-500";
      s2.value = "PF-ACH-PG500";
      s3.value = "PF-ACH-AM500";

      updateCustomBundleMath();

      const grid = document.getElementById("curated-bundles-grid");
      grid.innerHTML = BUNDLES.map(b => {
        const extraSave = b.sellingTotal - b.bundlePrice;
        const totalSaveMrp = b.mrpTotal - b.bundlePrice;
        const isHero = b.tag === "MOST LOVED" || b.tag === "BEST VALUE" || b.tag === "GIFT HAMPER";
        const badgeStyle = b.tag === "GIFT HAMPER"
          ? "bg-[#9E3B24] text-white"
          : isHero
            ? "bg-[#C88A2B] text-[#141F18]"
            : "bg-[#F3EDE2] text-[#9E3B24]";

        return `
          <div class="bg-white rounded-2xl ${isHero ? 'border-2 border-[#C88A2B] shadow-md' : 'border border-[#E2D9C8] shadow-2xs'} p-5 sm:p-6 flex flex-col justify-between hover:shadow-lg transition h-full">
            <div>
              <div class="flex items-center justify-between gap-2 mb-2.5">
                <span class="px-2.5 py-0.5 rounded-full ${badgeStyle} font-mono-batch text-[10px] font-bold uppercase">#${b.num}${b.tag ? ' · ' + b.tag : ''}</span>
                <span class="px-2 py-0.5 rounded bg-[#D1E7DD] text-[#1E2D24] font-mono-batch text-[10px] font-bold">🚚 Ships FREE</span>
              </div>
              <h3 class="font-serif-editorial text-2xl font-bold text-[#1E2D24]">${b.title}</h3>
              <p class="text-xs font-semibold italic text-[#9E3B24] mt-0.5">&ldquo;${b.hookLine}&rdquo;</p>
              <p class="text-xs text-[#5C645E] mt-2 leading-relaxed">${b.itemsText}</p>
              <div class="mt-2.5 text-[11px] font-mono-batch text-[#1E2D24]/80 bg-[#FBF8F3] px-2.5 py-1.5 rounded-lg border border-[#E2D9C8]">
                ✨ Ideal For: ${b.subtitle}
              </div>
              ${pahadanGiftLive() && b.bundlePrice >= PAHADAN_GIFT.minOrder ? `
                <div class="mt-2 px-2.5 py-1 rounded-lg bg-[#D1E7DD]/70 border border-[#1E2D24]/20 text-[10px] font-mono-batch font-bold text-[#1E2D24]">
                  🎁 Diwali gift till 10 Nov: Includes FREE Wild Forest Honey 250g (worth ₹299)!
                </div>
              ` : ''}

            </div>
            <div class="pt-4 mt-4 border-t border-[#F3EDE2] space-y-2.5">
              <div class="flex items-baseline justify-between gap-2">
                <div>
                  <span class="text-2xl font-bold text-[#1E2D24]">${formatINR(b.bundlePrice)}</span>
                  <span class="text-xs line-through text-[#5C645E] ml-1">Singles ${formatINR(b.sellingTotal)}</span>
                </div>
                <span class="px-2 py-0.5 rounded bg-[#9E3B24]/15 text-[#9E3B24] font-mono-batch text-[11px] font-bold">Save ₹${extraSave} (${b.savesPct.toFixed(0)}%)</span>
              </div>
              <div class="text-[11px] text-[#5C645E]">Combined MRP: <span class="line-through">${formatINR(b.mrpTotal)}</span> · Total Save vs MRP: <strong>${formatINR(totalSaveMrp)}</strong></div>
              <div class="grid grid-cols-2 gap-2 pt-0.5">
                <button type="button" data-add-bundle="${b.id}" class="py-2.5 px-3 rounded-xl bg-[#1E2D24] hover:bg-[#2c4235] text-white font-bold text-xs transition shadow-2xs">
                  🛒 Add to Cart
                </button>
                <button type="button" data-buy-bundle="${b.id}" class="py-2.5 px-3 rounded-xl bg-[#C88A2B] hover:bg-[#9E3B24] text-[#141F18] hover:text-white font-bold text-xs transition shadow-2xs">
                  ⚡ Buy Now · ${formatINR(b.bundlePrice)}
                </button>
              </div>
            </div>
          </div>
        `;
      }).join("");
    }

    function updateCustomBundleMath() {
      const sku1 = document.getElementById("bundle-slot-1").value;
      const sku2 = document.getElementById("bundle-slot-2").value;
      const sku3 = document.getElementById("bundle-slot-3").value;
      const p1 = getProduct(sku1);
      const p2 = getProduct(sku2);
      const p3 = getProduct(sku3);

      const sumSelling = p1.price + p2.price + p3.price;
      // Brief v3: self-built boxes are charged at single-jar prices (no extra discount); they ship free at ₹499+ like every order.
      document.getElementById("custom-bundle-price").textContent = formatINR(sumSelling);
      document.getElementById("custom-bundle-regular").textContent = "";
      document.getElementById("custom-bundle-save").textContent = sumSelling >= PAHADAN_SHIP.freeFrom ? "Ships FREE" : `Add ${formatINR(PAHADAN_SHIP.freeFrom - sumSelling)} for Free Shipping`;
    }

    // LAB REPORT & SUPPORT
    function renderBatchReport(code) {
      const norm = code.trim().toUpperCase();
      const report = BATCH_REPORTS[norm] || BATCH_REPORTS["DRH-2610-GH"];
      const rowsHtml = report.metrics.map(m => `
        <tr class="border-b border-[#E2D9C8]">
          <td class="py-2.5 px-3 font-semibold text-[#1E2D24]">${m[0]}</td>
          <td class="py-2.5 px-3 font-mono-batch font-bold text-[#1E2D24]">${m[1]}</td>
          <td class="py-2.5 px-3 text-[#5C645E]">${m[2]}</td>
          <td class="py-2.5 px-3"><span class="px-2 py-0.5 rounded bg-[#D1E7DD] text-[#1E2D24] font-mono-batch font-bold text-[10px]">✓ ${m[3]}</span></td>
        </tr>
      `).join("");

      document.getElementById("batch-report-output").innerHTML = `
        <div class="flex flex-col sm:flex-row sm:items-center justify-between gap-2 pb-4 border-b border-[#E2D9C8]">
          <div>
            <span class="font-mono-batch text-xs text-[#9E3B24] font-bold">BATCH CERTIFICATE #${report.code}</span>
            <h3 class="font-serif-editorial text-2xl font-bold text-[#1E2D24]">${report.product}</h3>
            <p class="text-xs text-[#5C645E]">Origin: ${report.origin} · Method: ${report.method}</p>
          </div>
          <span class="px-3 py-1 rounded-full bg-[#D1E7DD] text-[#1E2D24] font-mono-batch text-xs font-bold self-start sm:self-auto shrink-0">${report.status}</span>
        </div>
        <div class="overflow-x-auto mt-4">
          <table class="w-full min-w-[520px] text-left text-xs">
            <thead>
              <tr class="bg-[#F3EDE2] text-[#1E2D24]">
                <th class="py-2 px-3">Parameter Tested</th>
                <th class="py-2 px-3">Observed Batch Value</th>
                <th class="py-2 px-3">Benchmark / Back-Label Spec</th>
                <th class="py-2 px-3">Result</th>
              </tr>
            </thead>
            <tbody>${rowsHtml}</tbody>
          </table>
        </div>
      `;
    }

    function renderFaqList() {
      const faqList = document.getElementById("faq-accordion-list");
      if (!faqList) return;
      const filtered = FAQS.filter(f => activeFaqCat === "all" || f.cat === activeFaqCat);
      faqList.innerHTML = filtered.map((f, i) => `
        <details class="bg-white rounded-xl border border-[#E2D9C8] p-4 shadow-2xs" ${i === 0 ? 'open' : ''}>
          <summary class="font-bold text-xs sm:text-sm text-[#1E2D24] cursor-pointer flex justify-between items-center gap-2">
            <span><span class="px-2 py-0.5 rounded bg-[#F3EDE2] text-[#9E3B24] font-mono-batch text-[10px] uppercase mr-1.5">${f.cat}</span>${f.q}</span>
            <span class="text-[#9E3B24] shrink-0">▾</span>
          </summary>
          <p class="text-xs text-[#5C645E] mt-2.5 leading-relaxed">${f.a}</p>
        </details>
      `).join("");
    }

    function renderSupportView() {
      renderFaqList();
      const polContent = document.getElementById("policy-tab-content");
      if (polContent && !polContent.innerHTML.trim()) {
        polContent.innerHTML = POLICIES.refund;
      }
    }

    // EXPRESS 1-CLICK BUY NOW (ADDS TO BAG & IMMEDIATELY LAUNCHES EXPRESS CHECKOUT)
    let _expressCheckoutLauncher = null;
    function buyNow(sku, qty = 1) {
      const p = getProduct(sku);
      if (!p || !p.inStock) {
        addToCart(sku, qty);
        return;
      }
      const existing = cart.find(item => item.sku === sku);
      if (existing) existing.qty += qty;
      else cart.push({ sku, qty });
      renderCart();
      if (typeof _expressCheckoutLauncher === "function") {
        _expressCheckoutLauncher();
      }
    }

    function buyBundleNow(bundleId) {
      const b = BUNDLES.find(x => x.id === bundleId);
      if (!b) return;
      b.items.forEach(sku => {
        const p = getProduct(sku);
        if (p && p.inStock) {
          const ex = cart.find(i => i.sku === sku);
          if (ex) ex.qty += 1;
          else cart.push({ sku, qty: 1 });
        }
      });
      cartBundles.push(b.id);
      renderCart();
      if (typeof _expressCheckoutLauncher === "function") {
        _expressCheckoutLauncher();
      }
    }

    // CART DRAWER & BOTTOM-CENTRED ADD-TO-CART CONFIRMATION
    function addToCart(sku, qty = 1) {
      const p = getProduct(sku);
      if (!p.inStock) {
        const rec = RECOMMENDATION_MATRIX[sku] || {};
        const altProduct = rec.upgradeSku ? getProduct(rec.upgradeSku) : getProduct("PF-GHEE-500");
        openModal("Batch Restock Alert & In-Stock Alternative", `
          <p><strong>${p.title}</strong> is handcrafted in small mountain batches in Village Drahal and is currently restocking.</p>
          <div class="p-3 rounded-xl bg-[#F3EDE2] border border-[#C88A2B] my-2">
            <div class="font-mono-batch text-[10px] uppercase text-[#9E3B24] font-bold">In-Stock Alternative Available Today</div>
            <div class="font-bold text-xs text-[#1E2D24] mt-0.5">${altProduct.title} — ${formatINR(altProduct.price)}</div>
            <button type="button" onclick="closeModal();" data-quick-add="${altProduct.sku}" class="mt-2 px-3.5 py-2 rounded-lg bg-[#1E2D24] text-white font-bold text-xs">+ Add ${altProduct.shortTitle} (${formatINR(altProduct.price)})</button>
          </div>
          <p class="text-xs text-[#5C645E]">Or enter your WhatsApp number below for a priority restock alert:</p>
          <div class="flex gap-2 pt-1">
            <input type="tel" placeholder="+91 Your WhatsApp Number" class="flex-1 px-3 py-2 rounded-lg border border-[#E2D9C8] text-xs" />
            <button type="button" onclick="pahadanNotifyRestock('${p.shortTitle}', this);" class="px-4 py-2 rounded-lg bg-[#9E3B24] text-white font-bold text-xs">Notify Me</button>
          </div>
        `);
        return;
      }
      const existing = cart.find(item => item.sku === sku);
      if (existing) existing.qty += qty;
      else cart.push({ sku, qty });

      renderCart();
      // If Cart Drawer is currently closed, show the Bottom-Centred Add-to-Cart Confirmation Bar!
      const drawerOpen = !document.getElementById("cart-drawer-backdrop").classList.contains("hidden");
      if (!drawerOpen) {
        showAtcConfirmationBar(sku, qty);
      } else {
        showToast(`Added ${qty}× ${p.shortTitle} to your Pantry Bag`);
      }
    }

    function renderCart() {
      try { if (appliedCoupon) sessionStorage.setItem("pahadanCoupon", appliedCoupon); else sessionStorage.removeItem("pahadanCoupon"); } catch (e) {}
      pahadanScheduleCartSync();
      const badge = document.getElementById("cart-count-badge");
      const totalItems = cart.reduce((acc, item) => acc + item.qty, 0);
      badge.textContent = totalItems;

      let mrpTotal = 0;
      let subtotal = 0;
      cart.forEach(item => {
        const p = getProduct(item.sku);
        mrpTotal += p.mrp * item.qty;
        subtotal += p.price * item.qty;
      });

      const { activeBundles, totalBundleSavings } = computeActiveCartBundles();
      const netAfterBundles = Math.max(0, subtotal - totalBundleSavings);

      // Codes saved before the brief-v3 switch are dropped; WELCOME100 is the store's only code.
      if (appliedCoupon === "FOUNDER100" || appliedCoupon === "PAHADAN10" || appliedCoupon === "PREPAID5") appliedCoupon = null;
      let promoDiscount = 0;
      if (appliedCoupon === PAHADAN_WELCOME.code && netAfterBundles >= PAHADAN_WELCOME.minOrder) promoDiscount = PAHADAN_WELCOME.amount; // checkout confirms it's a first order
      

      const discount = totalBundleSavings + promoDiscount;
      const afterDiscount = Math.max(0, subtotal - discount);
      const hasBundleFreeShip = activeBundles.length > 0;
      // Shopify: matches the store's Standard rate (₹49 below ₹499, free from ₹499), checked on the total after discounts.
      const shipping = (afterDiscount === 0 || afterDiscount >= PAHADAN_SHIP.freeFrom) ? 0 : PAHADAN_SHIP.fee;
      const grandTotal = afterDiscount + shipping;
      // Diwali gift: product discounts are checked before order codes, so the ₹2,000 test uses the total before WELCOME100.
      const giftLive = pahadanGiftLive();
      const qualifiesFreeGift = giftLive && netAfterBundles >= PAHADAN_GIFT.minOrder;
      window._pahadanGiftQualified = qualifiesFreeGift; // Shopify: tells the cart sync to add the free Honey 250g gift line
      const giftLabel = document.getElementById("cart-threshold-gift-label");
      if (giftLabel) giftLabel.style.display = giftLive ? "" : "none";

      const headerPill = document.getElementById("cart-header-item-pill");
      if (headerPill) {
        headerPill.textContent = `${totalItems} ${totalItems === 1 ? 'Jar' : 'Jars'}`;
      }

      const container = document.getElementById("cart-items-container");
      if (cart.length === 0) {
        container.innerHTML = `
          <div class="text-center py-8 space-y-2.5">
            <div class="text-3xl">🧺</div>
            <div class="font-serif-editorial text-2xl font-bold text-[#1E2D24]">Your Pahadi Pantry Bag is Empty</div>
            <p class="text-xs text-[#5C645E]">Start with our 1L Bilona Ghee (₹1,749), Barot Special Pink Garlic Pickle, or ₹259–₹319 Starter Jars.</p>
          </div>
        `;
      } else {
        const itemsHtml = cart.map((item, idx) => {
          const p = getProduct(item.sku);
          const imgSrc = ASSETS[p.imageKey] || ASSETS.GHEE_1_HERO;
          const rec = RECOMMENDATION_MATRIX[p.sku] || {};
          const upgProduct = rec.upgradeSku ? getProduct(rec.upgradeSku) : null;
          const diffPrice = upgProduct ? (upgProduct.price - p.price) : 0;
          const showUpgrade = upgProduct && upgProduct.inStock && !dismissedUpgradeSkus.includes(p.sku);

          const upgradeBtnHtml = showUpgrade
            ? `<div class="mt-1.5 flex items-center gap-1">
                 <button type="button" data-cart-upgrade-from="${p.sku}" data-cart-upgrade-to="${upgProduct.sku}" class="flex-1 min-w-0 px-2 py-1 rounded-lg bg-[#F3EDE2] hover:bg-[#C88A2B] text-[#1E2D24] font-mono-batch text-[10px] font-bold flex items-center justify-between gap-1 transition">
                   <span class="truncate">⬆️ Upgrade to ${upgProduct.shortTitle} (+${formatINR(diffPrice)})</span>
                   <span class="text-[#9E3B24] shrink-0">Save/100${p.unit} →</span>
                 </button>
                 <button type="button" data-dismiss-upgrade="${p.sku}" title="Dismiss size upgrade" aria-label="Dismiss size upgrade" class="w-6 h-6 rounded-lg bg-[#F3EDE2] hover:bg-[#E2D9C8] text-[#5C645E] text-[10px] font-bold flex items-center justify-center shrink-0">✕</button>
               </div>`
            : "";

          return `
            <div class="p-2.5 sm:p-3 rounded-xl bg-white border border-[#E2D9C8] shadow-2xs">
              <div class="flex items-center justify-between gap-2.5">
                <img src="${imgSrc}" alt="${p.shortTitle}" class="w-12 h-12 sm:w-14 sm:h-14 rounded-lg object-cover border border-[#E2D9C8] shrink-0" />
                <div class="flex-1 min-w-0">
                  <div class="flex items-center gap-1.5">
                    <span class="px-1.5 py-0.2 rounded bg-[#F3EDE2] text-[#1E2D24] font-mono-batch text-[9px] font-bold">#${idx + 1}</span>
                    <div class="font-bold text-xs text-[#1E2D24] truncate">${p.title}</div>
                  </div>
                  <div class="text-[11px] text-[#5C645E] mt-0.5">${formatINR(p.price)} each <span class="line-through text-[10px]">${formatINR(p.mrp)}</span></div>
                  <div class="flex items-center gap-2 mt-1">
                    <button type="button" data-cart-dec="${p.sku}" class="w-6 h-6 rounded bg-[#F3EDE2] hover:bg-[#E2D9C8] font-bold text-xs">−</button>
                    <span class="font-mono-batch text-xs font-bold">${item.qty}</span>
                    <button type="button" data-cart-inc="${p.sku}" class="w-6 h-6 rounded bg-[#F3EDE2] hover:bg-[#E2D9C8] font-bold text-xs">+</button>
                    <button type="button" data-cart-rem="${p.sku}" class="text-[10px] text-[#9E3B24] underline ml-1.5">Remove</button>
                  </div>
                </div>
                <div class="font-mono-batch font-bold text-xs text-[#1E2D24] shrink-0">${formatINR(p.price * item.qty)}</div>
              </div>
              ${upgradeBtnHtml}
            </div>
          `;
        }).join("");

        const freeGiftHtml = qualifiesFreeGift
          ? `<div class="p-2.5 rounded-xl bg-[#D1E7DD]/70 border-2 border-[#1E2D24] flex items-center justify-between gap-2.5">
               <img src="${ASSETS[(getProduct("PF-HON-WF250") || {}).imageKey] || ASSETS.GHEE_1_HERO}" alt="Free Wild Forest Honey 250g Gift" class="w-11 h-11 rounded-lg object-cover border border-[#1E2D24]/30 shrink-0" />
               <div class="flex-1 min-w-0">
                 <span class="px-1.5 py-0.5 rounded bg-[#1E2D24] text-[#C88A2B] font-mono-batch text-[9px] font-bold uppercase">🎁 Diwali Gift Unlocked</span>
                 <div class="font-bold text-xs text-[#1E2D24] truncate mt-0.5">Wild Forest Honey — 250g</div>
               </div>
               <div class="font-mono-batch font-bold text-xs text-[#1E2D24] shrink-0">FREE <span class="line-through text-[10px] text-[#5C645E]">₹299</span></div>
             </div>`
          : "";

        container.innerHTML = itemsHtml + freeGiftHtml;
      }

      document.getElementById("cart-mrp-total").textContent = formatINR(mrpTotal + (qualifiesFreeGift ? 349 : 0));
      document.getElementById("cart-subtotal").textContent = formatINR(subtotal);
      document.getElementById("cart-discount").textContent = discount > 0
        ? `-${formatINR(discount)}${activeBundles.length > 0 ? ' (Bundle' + (promoDiscount > 0 ? '+' + appliedCoupon : '') + ')' : ''}`
        : "-₹0";
      document.getElementById("cart-shipping").textContent = shipping === 0
        ? (hasBundleFreeShip ? "FREE (Combo)" : "FREE")
        : formatINR(shipping);
      document.getElementById("cart-grand-total").textContent = formatINR(grandTotal);
      const detailTotalEl = document.getElementById("cart-grand-total-detail");
      if (detailTotalEl) detailTotalEl.textContent = formatINR(grandTotal);

      const checkoutLabelEl = document.getElementById("btn-checkout-label");
      if (checkoutLabelEl) {
        checkoutLabelEl.textContent = grandTotal > 0
          ? `Proceed to Secure Checkout · ${formatINR(grandTotal)} (UPI / Cards) →`
          : "Proceed to Secure Checkout (UPI / Cards / NetBanking) →";
      }

      const compactSavingsPill = document.getElementById("cart-compact-savings-pill");
      if (compactSavingsPill) {
        const totalSavedVsMrp = Math.max(0, (mrpTotal - afterDiscount) + (qualifiesFreeGift ? PAHADAN_GIFT.worth : 0));
        if (totalSavedVsMrp > 0) {
          compactSavingsPill.textContent = `Save ${formatINR(totalSavedVsMrp)}${shipping === 0 ? ' · Free Ship ✓' : ''}`;
        } else {
          compactSavingsPill.textContent = shipping === 0 ? "Free Ship ✓" : `+${formatINR(PAHADAN_SHIP.fee)} Ship`;
        }
      }

      const barGoal = giftLive ? PAHADAN_GIFT.minOrder : PAHADAN_SHIP.freeFrom;
      const barValue = giftLive ? netAfterBundles : afterDiscount;
      const pct = Math.min(100, Math.round((barValue / barGoal) * 100));
      document.getElementById("cart-threshold-bar").style.width = pct + "%";
      const threshText = document.getElementById("cart-threshold-text");
      if (afterDiscount === 0) {
        threshText.textContent = giftLive
          ? "Combos always ship FREE · Every order free ≥ ₹499 · Diwali gift: Free Honey 250g ≥ ₹2,000"
          : "Combos always ship FREE · Every order ships free ≥ ₹499";
      } else if (afterDiscount < PAHADAN_SHIP.freeFrom) {
        threshText.textContent = `Add ${formatINR(PAHADAN_SHIP.freeFrom - afterDiscount)} more (or choose any Combo) for FREE Pan-India Shipping!`;
      } else if (giftLive && netAfterBundles < PAHADAN_GIFT.minOrder) {
        threshText.textContent = `✓ FREE Shipping Unlocked! Add ${formatINR(PAHADAN_GIFT.minOrder - netAfterBundles)} for a FREE Wild Forest Honey 250g (₹299)!`;
      } else if (giftLive) {
        threshText.textContent = "🎉 Both Unlocked: FREE Shipping + FREE Wild Forest Honey 250g (worth ₹299)!";
      } else {
        threshText.textContent = "✓ FREE Pan-India Shipping Unlocked!";
      }

      // Render Single-Card Slidable / Sequential Cart Upsell (1 Option at a Time + Close/Skip Controls)
      const upsellBox = document.getElementById("cart-upsell-box");
      const reopenBar = document.getElementById("cart-upsell-reopen-bar");
      const reopenLabel = document.getElementById("cart-upsell-reopen-label");
      const upsellList = document.getElementById("cart-upsell-list");
      const upsellHeading = document.getElementById("cart-upsell-heading");
      const upsellCounter = document.getElementById("cart-upsell-counter");

      const allRecs = getSmartCartRecommendations(skippedUpsellSkus);
      // If user skipped all candidates, fallback to full smart recommendations so they can still cycle if they reopen
      const recs = allRecs.length > 0 ? allRecs : getSmartCartRecommendations();

      if (recs.length === 0 || cart.length === 0) {
        if (upsellBox) upsellBox.classList.add("hidden");
        if (reopenBar) reopenBar.classList.add("hidden");
      } else if (isCartUpsellDismissed) {
        if (upsellBox) upsellBox.classList.add("hidden");
        if (reopenBar) {
          reopenBar.classList.remove("hidden");
          if (reopenLabel) {
            reopenLabel.textContent = `✨ ${recs.length} Recommended Pahadi ${recs.length === 1 ? 'Pairing' : 'Pairings'} Hidden`;
          }
        }
      } else {
        if (upsellBox) upsellBox.classList.remove("hidden");
        if (reopenBar) reopenBar.classList.add("hidden");

        if (activeCartUpsellIdx >= recs.length) activeCartUpsellIdx = 0;
        if (activeCartUpsellIdx < 0) activeCartUpsellIdx = recs.length - 1;

        const r = recs[activeCartUpsellIdx];
        const nextRec = recs[(activeCartUpsellIdx + 1) % recs.length];

        if (upsellCounter) {
          upsellCounter.textContent = `${activeCartUpsellIdx + 1}/${recs.length}`;
        }

        if (afterDiscount > 0 && afterDiscount < PAHADAN_SHIP.freeFrom && upsellHeading) {
          upsellHeading.textContent = `Add ${formatINR(PAHADAN_SHIP.freeFrom - afterDiscount)} for FREE Ship · Option ${activeCartUpsellIdx + 1}`;
        } else if (giftLive && netAfterBundles < PAHADAN_GIFT.minOrder && upsellHeading) {
          upsellHeading.textContent = `Unlock Free ₹299 Honey · Option ${activeCartUpsellIdx + 1} of ${recs.length}`;
        } else if (upsellHeading) {
          upsellHeading.textContent = `Pairs With Your Bag · Option ${activeCartUpsellIdx + 1} of ${recs.length}`;
        }

        if (upsellList && r) {
          const dotsHtml = recs.length > 1
            ? `<div class="flex items-center justify-center gap-1.5 pt-1">
                 ${recs.map((itemRec, dIdx) => `
                   <button type="button" data-upsell-dot="${dIdx}" class="h-1.5 rounded-full transition-all ${dIdx === activeCartUpsellIdx ? 'w-4 bg-[#9E3B24]' : 'w-1.5 bg-[#1E2D24]/25'}" aria-label="Show upsell option ${dIdx + 1}"></button>
                 `).join("")}
                 <span class="text-[9px] font-mono-batch text-[#5C645E] ml-1">${recs.length > 1 && nextRec ? 'Swipe or tap Next › for ' + nextRec.shortTitle : ''}</span>
               </div>`
            : "";

          upsellList.innerHTML = `
            <div id="cart-upsell-slide-card" class="p-2 rounded-lg bg-white border border-[#E2D9C8] flex items-center justify-between gap-2 transition-all">
              <div class="flex items-center gap-2 min-w-0">
                <img src="${ASSETS[r.imageKey]}" alt="${r.shortTitle}" class="w-9 h-9 rounded-lg object-cover border border-[#E2D9C8] shrink-0" />
                <div class="text-xs min-w-0">
                  <div class="font-bold text-[#1E2D24] truncate">${r.shortTitle}</div>
                  <div class="text-[10px] text-[#5C645E] truncate">${r.size} · <strong class="text-[#1E2D24]">${formatINR(r.price)}</strong> <span class="line-through">${formatINR(r.mrp)}</span></div>
                </div>
              </div>
              <div class="flex items-center gap-1 shrink-0">
                <button type="button" data-upsell-add="${r.sku}" class="px-2.5 py-1.5 rounded-lg bg-[#1E2D24] hover:bg-[#9E3B24] text-white font-semibold text-[11px] whitespace-nowrap transition">
                  + Add ${formatINR(r.price)}
                </button>
                ${recs.length > 1 ? `<button type="button" data-upsell-skip="${r.sku}" title="Skip this option and show next" class="px-1.5 py-1.5 rounded-lg bg-[#F3EDE2] hover:bg-[#E2D9C8] text-[#5C645E] font-mono-batch text-[10px] font-bold transition" aria-label="Skip to next option">Skip ›</button>` : ''}
              </div>
            </div>
            ${dotsHtml}
          `;
        }
      }
    }

    function switchView(viewName) {
      const _pahadanPrevView = currentView;
      currentView = viewName;
      document.querySelectorAll(".store-view").forEach(el => el.classList.add("hidden"));
      const target = document.getElementById("view-" + viewName);
      if (target) target.classList.remove("hidden");

      document.querySelectorAll(".store-nav-link").forEach(btn => {
        const isTarget = btn.getAttribute("data-nav-view") === viewName;
        if (btn.getAttribute("data-nav-view") === "bundles") {
          btn.className = isTarget
            ? "store-nav-link h-9 px-3 rounded-full bg-[#C88A2B] text-[#141F18] font-bold inline-flex items-center gap-1 transition whitespace-nowrap shadow-xs"
            : "store-nav-link h-9 px-3 rounded-full bg-[#F3EDE2] border border-[#C88A2B]/50 text-[#9E3B24] font-semibold hover:bg-[#C88A2B] hover:text-[#141F18] inline-flex items-center gap-1 transition whitespace-nowrap shadow-2xs";
        } else {
          btn.className = isTarget
            ? "store-nav-link h-9 px-2.5 rounded-full bg-[#1E2D24] text-white font-semibold inline-flex items-center transition whitespace-nowrap"
            : "store-nav-link h-9 px-2.5 rounded-full hover:bg-[#F3EDE2] text-[#1C241E] inline-flex items-center hover:text-[#9E3B24] transition whitespace-nowrap";
        }
      });

      document.getElementById("mega-menu-panel").classList.add("hidden");
      document.getElementById("mobile-nav-drawer").classList.add("hidden");
      // Journal pages are for reading, so the product buy bar stays out of the way there.
      const pahadanBuyBar = document.getElementById("mobile-sticky-buy-bar");
      if (pahadanBuyBar) pahadanBuyBar.classList.toggle("hidden", viewName === "journal");
      window.scrollTo({ top: 0, behavior: "smooth" });
      pahadanSetUrl(viewName, _pahadanPrevView); // Shopify: real web address for this view
    }

    window.addEventListener("DOMContentLoaded", () => {
      hydrateStaticAssets();

      const pdpSelect = document.getElementById("pdp-sku-selector");
      pdpSelect.innerHTML = PRODUCTS.map(p => `<option value="${p.sku}">${p.title}</option>`).join("");
      pdpSelect.addEventListener("change", (e) => {
        activePdpSku = e.target.value;
        activePdpGalleryIdx = 0;
        pdpQty = 1;
        renderPDP();
      });

      renderHomeProducts();
      renderHomeReviews();
      renderCollectionProducts();
      renderPDP();
      initBundleBuilder();
      renderBatchReport("DRH-2610-GH");
      renderSupportView();
      renderCart();

      // =========================================================================
      // AUTOMATED 5-SLIDE OFFER HERO BANNER CAROUSEL (COMBOS, SINGLE UNITS & OFFERS)
      // Built on Baymard Institute & NN/g Carousel UX Guidelines:
      // - 6-second auto-advance interval with live progress bar
      // - Instant pause on mouse hover/touch + permanent pause on manual tab selection
      // - Direct 1-click Add-to-Cart for both Combos (data-add-bundle) & Single Units (data-quick-add)
      // =========================================================================
      const HERO_OFFER_SLIDES = [
        {
          id: "slide-festive-offers",
          kicker: "🎀 OFFER 1 OF 5 · GIFT HAMPER & SITEWIDE OFFERS",
          heading: "Give Them the Mountains — Our Fullest Gift Hamper, or ₹100 Off Your First Order.",
          subcopy: "See every live offer right here: <strong>All 7 Curated Combos Ship FREE</strong>, code <strong>WELCOME100 takes ₹100 off your first order of ₹599+</strong>, and our <strong>5-Jar Pahadan Gift Hamper</strong> saves <strong>₹496 off Singles (₹1,196 off MRP)</strong>.",
          img: ASSETS.GHEE_1_HERO,
          pillLeft: "🎁 GIFT HAMPER · SHIPS FREE",
          pillRight: "MRP ₹4,595 · Save ₹496",
          overlaySubtitle: "5 Full-Size Jars + Gift Box + Greeting Card",
          overlayContents: "1L Ghee + 650g Honey + 500g Amla + 500g Mango + 500g Garlic",
          overlayMrp: "Singles ₹3,895",
          overlayPrice: "₹3,399",
          cardTag: "Gift-Ready Box + Greeting Card · Ships FREE",
          cardTitle: "Pahadan Gift Hamper (5 Jars)",
          inspectSku: "PF-GHEE-1000",
          cardBtnAttr: "data-add-bundle",
          cardBtnVal: "BND-07-HAMPER",
          cardBtnText: "+ Add ₹3,399",
          primaryCta: { text: "+ Add Gift Hamper · ₹3,399", attr: "data-add-bundle", val: "BND-07-HAMPER" },
          secondaryCta: { text: "Explore All 7 Combos →", attr: "data-nav-view", val: "bundles" },
          tertiaryCta: { text: "All 11 Singles →", attr: "data-nav-view", val: "collection" },
          offerCards: [
            {
              badge: "GIFT HAMPER · SAVE ₹496",
              title: "Pahadan Gift Hamper (5 Jars)",
              desc: "1L Ghee + 650g Honey + 3×500g Pickles + Gift Box & Card",
              price: "₹3,399",
              strike: "₹3,895",
              actionAttr: "data-add-bundle",
              actionVal: "BND-07-HAMPER",
              actionLabel: "+ Add ₹3,399"
            },
            {
              badge: "BEST VALUE · SAVE ₹398",
              title: "Mountain Pantry (3 Jars)",
              desc: "1L Bilona Ghee + 650g Wild Honey + 500g Mango Achaar",
              price: "₹2,399",
              strike: "₹2,797",
              actionAttr: "data-add-bundle",
              actionVal: "BND-06-PANTRY",
              actionLabel: "+ Add ₹2,399"
            },
            {
              badge: "FIRST ORDER · CODE WELCOME100",
              title: "₹100 Off Your First Order",
              desc: "On orders of ₹599+ · Apply in your bag or at checkout",
              price: "−₹100",
              strike: "Min ₹599",
              actionAttr: "data-nav-view",
              actionVal: "bundles",
              actionLabel: "View Combos →"
            }
          ]
        },
        {
          id: "slide-thali-combo",
          kicker: "🍱 OFFER 2 OF 5 · MOST-LOVED PAHADI THALI COMBO",
          heading: "“Poori Thali, Ek Box Mein” — 500ml Ghee + Two 500g Achaars at ₹1,699.",
          subcopy: "Our #1 family combo pairs <strong>500ml Hand-Churned Cow Desi Bilona Ghee</strong> with <strong>500g Desi Kaccha Mango</strong> and <strong>500g Barot Special Pink Garlic Pickle</strong>. Save <strong>₹348 off Singles (₹698 off MRP ₹2,397)</strong> with <strong>FREE Shipping</strong>.",
          img: ASSETS.PARATHA_THALI,
          pillLeft: "⭐ MOST LOVED · SHIPS FREE",
          pillRight: "MRP ₹2,397 · Save ₹348",
          overlaySubtitle: "Pahadi Thali Box — Complete Daily Meal Trio",
          overlayContents: "500ml Bilona Ghee + 500g Kaccha Mango + 500g Barot Pink Garlic",
          overlayMrp: "Singles ₹2,047",
          overlayPrice: "₹1,699",
          cardTag: "Saves ₹348 (17% Off Singles) + Free Pan-India Delivery",
          cardTitle: "Pahadi Thali Box (3 Full-Size Jars)",
          inspectSku: "PF-GHEE-500",
          cardBtnAttr: "data-add-bundle",
          cardBtnVal: "BND-05-THALI",
          cardBtnText: "+ Add ₹1,699",
          primaryCta: { text: "+ Add Pahadi Thali Box · ₹1,699", attr: "data-add-bundle", val: "BND-05-THALI" },
          secondaryCta: { text: "+ Add Pantry Box · ₹2,399", attr: "data-add-bundle", val: "BND-06-PANTRY" },
          tertiaryCta: { text: "Compare 7 Combos →", attr: "data-nav-view", val: "bundles" },
          offerCards: [
            {
              badge: "MOST LOVED · SAVE ₹348",
              title: "Pahadi Thali Box (3 Jars)",
              desc: "500ml Ghee + 500g Mango + 500g Garlic · Ships Free",
              price: "₹1,699",
              strike: "₹2,047",
              actionAttr: "data-add-bundle",
              actionVal: "BND-05-THALI",
              actionLabel: "+ Add ₹1,699"
            },
            {
              badge: "MONTHLY STOCK · SAVE ₹398",
              title: "Mountain Pantry (1L Trio)",
              desc: "1L Ghee + 650g Honey + 500g Mango · Free Shipping",
              price: "₹2,399",
              strike: "₹2,797",
              actionAttr: "data-add-bundle",
              actionVal: "BND-06-PANTRY",
              actionLabel: "+ Add ₹2,399"
            },
            {
              badge: "STARTER PICK · SAVE ₹199",
              title: "Starter Box: Honey & Achaar",
              desc: "250g Wild Honey + 500g Mango Achaar · Ships Free",
              price: "₹599",
              strike: "₹798",
              actionAttr: "data-add-bundle",
              actionVal: "BND-02-STARTER",
              actionLabel: "+ Add ₹599"
            }
          ]
        },
        {
          id: "slide-flagship-ghee",
          kicker: "🧈 OFFER 3 OF 5 · BILONA GHEE SINGLES & WELLNESS DUO",
          heading: "100% Pure Himachali Bilona Ghee — Single Jars ₹549+ or Ghee & Honey Duo at ₹1,299.",
          subcopy: "Handcrafted in Village Drahal from free-grazing Pahadi cow A2 milk set into clay-pot curd and wooden <em>bilona</em> churned: <strong>250ml Trial (₹549)</strong>, <strong>500ml (₹949)</strong>, <strong>1L Jar (₹1,749 · Free Ship)</strong>, or the <strong>Ghee & Honey Wellness Duo (₹1,299)</strong>.",
          img: ASSETS.GHEE_1_HERO,
          pillLeft: "🧈 FLAGSHIP 1L · SHIPS FREE",
          pillRight: "MRP ₹1,999 · Save ₹250",
          overlaySubtitle: "TPFGHEE01000 · 1000ml (1L) Family Glass Jar",
          overlayContents: "4-Step Clay-Pot Curd & Slow Firewood Bilona Craft · Lab Tested",
          overlayMrp: "MRP ₹1,999",
          overlayPrice: "₹1,749",
          cardTag: "Ships FREE Pan-India · Or Pair It in the Wellness Duo @ ₹1,299",
          cardTitle: "Himachali Cow Desi Bilona Ghee — 1L",
          inspectSku: "PF-GHEE-1000",
          cardBtnAttr: "data-quick-add",
          cardBtnVal: "PF-GHEE-1000",
          cardBtnText: "+ Add ₹1,749",
          primaryCta: { text: "+ Add 1L Bilona Ghee · ₹1,749", attr: "data-quick-add", val: "PF-GHEE-1000" },
          secondaryCta: { text: "+ Add Wellness Duo · ₹1,299", attr: "data-add-bundle", val: "BND-04-WELLNESS" },
          tertiaryCta: { text: "1L Ghee Details →", attr: "data-open-pdp", val: "PF-GHEE-1000", isPdp: true },
          offerCards: [
            {
              badge: "TRIAL SINGLE · 15% OFF",
              title: "250ml Bilona Ghee (Trial)",
              desc: "MRP ₹649 · Save ₹100 · Ideal first taste of Drahal craft",
              price: "₹549",
              strike: "MRP ₹649",
              actionAttr: "data-quick-add",
              actionVal: "PF-GHEE-250T",
              actionLabel: "+ Add ₹549"
            },
            {
              badge: "POPULAR SINGLE · 14% OFF",
              title: "500ml Bilona Ghee Glass Jar",
              desc: "MRP ₹1,099 · Save ₹150 · ₹189.80/100ml · Cultured A2",
              price: "₹949",
              strike: "MRP ₹1,099",
              actionAttr: "data-quick-add",
              actionVal: "PF-GHEE-500",
              actionLabel: "+ Add ₹949"
            },
            {
              badge: "WELLNESS DUO · SAVE ₹199",
              title: "Ghee & Honey Wellness Duo",
              desc: "500ml Bilona Ghee + 650g Wildflower Honey · Ships Free",
              price: "₹1,299",
              strike: "₹1,498",
              actionAttr: "data-add-bundle",
              actionVal: "BND-04-WELLNESS",
              actionLabel: "+ Add ₹1,299"
            }
          ]
        },
        {
          id: "slide-pickle-wellness-combos",
          kicker: "🌶️ OFFER 4 OF 5 · MANGO FAMILY PACK & MINI DUO",
          heading: "1.5 kg of Homemade Mango Achaar — Save 27% With Our 500g × 3 Family Pack.",
          subcopy: "Stock up on <strong>Desi Kaccha Mango (₹499)</strong> in our <strong>Mango Pickle Family Pack at ₹1,099 (Save ₹398 + Free Ship)</strong>, or try <strong>200g Mango + 200g Barot Pink Garlic</strong> in the <strong>Mini Achaar Duo at ₹499</strong>.",
          img: ASSETS.MANGO_AACHAR,
          pillLeft: "🌶️ 3×500G PACK · SHIPS FREE",
          pillRight: "MRP ₹1,797 · Save ₹398",
          overlaySubtitle: "Mango Pickle Family Pack (500g × 3 · 1.5 kg Total)",
          overlayContents: "3 × 500g Desi Kaccha Mango Homemade Pickle",
          overlayMrp: "Singles ₹1,497",
          overlayPrice: "₹1,099",
          cardTag: "Save ₹398 Off Singles (₹698 Off MRP) + Free Delivery",
          cardTitle: "Mango Pickle Family Pack (500g × 3)",
          inspectSku: "PF-ACH-KM500",
          cardBtnAttr: "data-add-bundle",
          cardBtnVal: "BND-03-MANGO3",
          cardBtnText: "+ Add ₹1,099",
          primaryCta: { text: "+ Add Mango Family Pack · ₹1,099", attr: "data-add-bundle", val: "BND-03-MANGO3" },
          secondaryCta: { text: "+ Add Mini Duo · ₹499", attr: "data-add-bundle", val: "BND-01-MINIDUO" },
          tertiaryCta: { text: "Shop 6 Pickles →", attr: "data-filter-cat", val: "Aachar", isCat: true },
          offerCards: [
            {
              badge: "3×500G PACK · SAVE ₹398",
              title: "Mango Pickle Family Pack",
              desc: "3 × 500g Desi Kaccha Mango (1.5 kg) · Free Ship",
              price: "₹1,099",
              strike: "₹1,497",
              actionAttr: "data-add-bundle",
              actionVal: "BND-03-MANGO3",
              actionLabel: "+ Add ₹1,099"
            },
            {
              badge: "UNDER ₹500 · SAVE ₹79",
              title: "Mini Achaar Duo (200g × 2)",
              desc: "200g Mango + 200g Barot Pink Garlic · Free Ship",
              price: "₹499",
              strike: "₹578",
              actionAttr: "data-add-bundle",
              actionVal: "BND-01-MINIDUO",
              actionLabel: "+ Add ₹499"
            },
            {
              badge: "SINGLE UNIT · 14% OFF",
              title: "Barot Pink Garlic (500g Jar)",
              desc: "Single Unit: MRP ₹699 · Save ₹100 · Rare Himachal Cloves",
              price: "₹599",
              strike: "MRP ₹699",
              actionAttr: "data-quick-add",
              actionVal: "PF-ACH-PG500",
              actionLabel: "+ Add ₹599"
            }
          ]
        },
        {
          id: "slide-singles-and-tasters",
          kicker: "✨ OFFER 5 OF 5 · STARTER JARS & ₹599 STARTER BOX",
          heading: "First Order? Try Single Jars From ₹259 — Or the Starter Box at ₹599.",
          subcopy: "Try a single starter jar first—<strong>200g Mango (₹259)</strong>, <strong>200g Forest Amla (₹275)</strong>, <strong>250g Honey (₹299)</strong>, or <strong>200g Pink Garlic (₹319)</strong>—or take our <strong>Starter Box: Honey & Achaar (₹599 · Free Ship)</strong>, just ₹499 on your first order with WELCOME100.",
          img: ASSETS.AM500_1_HERO,
          pillLeft: "✨ STARTER PICK · SHIPS FREE",
          pillRight: "Singles ₹798 → ₹599 Free Ship",
          overlaySubtitle: "Starter Box: Honey & Achaar",
          overlayContents: "250g Wild Forest Honey (₹299) + 500g Desi Kaccha Mango (₹499)",
          overlayMrp: "Singles ₹798",
          overlayPrice: "₹599",
          cardTag: "Saves ₹199 Off Singles · ₹499 With WELCOME100 on Your First Order",
          cardTitle: "Starter Box: Honey & Achaar",
          inspectSku: "PF-HON-WF250",
          cardBtnAttr: "data-add-bundle",
          cardBtnVal: "BND-02-STARTER",
          cardBtnText: "+ Add ₹599",
          primaryCta: { text: "+ Add Starter Box · ₹599", attr: "data-add-bundle", val: "BND-02-STARTER" },
          secondaryCta: { text: "+ Add Mini Duo · ₹499", attr: "data-add-bundle", val: "BND-01-MINIDUO" },
          tertiaryCta: { text: "5 Starter Jars →", attr: "data-filter-cat", val: "Trial", isCat: true },
          offerCards: [
            {
              badge: "SINGLE UNIT · 16% OFF",
              title: "Forest Amla Pickle (200g)",
              desc: "MRP ₹329 · 0%-Pesticide Wild Amla · Or 500g @ ₹499",
              price: "₹275",
              strike: "MRP ₹329",
              actionAttr: "data-quick-add",
              actionVal: "PF-ACH-AM200T",
              actionLabel: "+ Add ₹275"
            },
            {
              badge: "SINGLE UNIT · 16% OFF",
              title: "Barot Pink Garlic (200g)",
              desc: "MRP ₹379 · Rare Himachal Cloves · Or 500g @ ₹599",
              price: "₹319",
              strike: "MRP ₹379",
              actionAttr: "data-quick-add",
              actionVal: "PF-ACH-PG200T",
              actionLabel: "+ Add ₹319"
            },
            {
              badge: "SINGLE UNIT · 14% OFF",
              title: "Wild Forest Honey (250g)",
              desc: "MRP ₹349 · Raw Unheated · Or 200g Mango @ ₹259",
              price: "₹299",
              strike: "MRP ₹349",
              actionAttr: "data-quick-add",
              actionVal: "PF-HON-WF250",
              actionLabel: "+ Add ₹299"
            }
          ]
        }
      ];

      let activeHeroSlideIdx = 0;
      let heroCarouselAutoPlay = true;
      let heroCarouselHoverPaused = false;
      let heroSlideProgressMs = 0;
      const HERO_SLIDE_DURATION_MS = 8000;
      const HERO_TICK_MS = 100;

      function applyCtaAttributes(btnEl, ctaCfg) {
        if (!btnEl || !ctaCfg) return;
        btnEl.removeAttribute("data-add-bundle");
        btnEl.removeAttribute("data-quick-add");
        btnEl.removeAttribute("data-nav-view");
        btnEl.removeAttribute("data-open-pdp");
        btnEl.removeAttribute("data-filter-cat");
        btnEl.classList.remove("pdp-jump-btn", "cat-jump-btn");
        btnEl.setAttribute(ctaCfg.attr, ctaCfg.val);
        if (ctaCfg.isPdp) btnEl.classList.add("pdp-jump-btn");
        if (ctaCfg.isCat) btnEl.classList.add("cat-jump-btn");
        btnEl.textContent = ctaCfg.text;
      }

      function renderHeroOfferSlide(idx) {
        activeHeroSlideIdx = (idx + HERO_OFFER_SLIDES.length) % HERO_OFFER_SLIDES.length;
        heroSlideProgressMs = 0;
        const s = HERO_OFFER_SLIDES[activeHeroSlideIdx];

        const kickerEl = document.getElementById("hero-slide-kicker");
        const headingEl = document.getElementById("hero-slide-heading");
        const subcopyEl = document.getElementById("hero-slide-subcopy");
        const cardsContainer = document.getElementById("hero-slide-offer-cards");

        if (kickerEl) kickerEl.textContent = s.kicker;
        if (headingEl) headingEl.innerHTML = s.heading;
        if (subcopyEl) subcopyEl.innerHTML = s.subcopy;

        if (cardsContainer) {
          cardsContainer.innerHTML = s.offerCards.map(c => `
            <div class="hero-offer-mini-card p-3 rounded-xl bg-[#141F18]/90 border border-[#C88A2B]/35 flex flex-col justify-between shadow-xs">
              <div>
                <div class="h-5 flex items-center justify-between gap-1">
                  <span class="font-mono-batch text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded bg-[#C88A2B]/20 text-[#C88A2B] truncate">${c.badge}</span>
                  <span class="font-mono-batch text-[10px] text-[#E2D9C8]/65 line-through shrink-0 whitespace-nowrap">${c.strike}</span>
                </div>
                <div class="font-bold text-white text-xs sm:text-[13px] mt-1 leading-snug line-clamp-1 h-5" title="${c.title}">${c.title}</div>
                <div class="text-[11px] text-[#E2D9C8]/80 mt-0.5 leading-snug line-clamp-2 h-8 overflow-hidden">${c.desc}</div>
              </div>
              <div class="pt-1.5 border-t border-white/10 flex items-center justify-between gap-2 h-8 shrink-0">
                <span class="font-serif-editorial text-lg font-bold text-[#C88A2B] leading-none whitespace-nowrap">${c.price}</span>
                <button type="button" ${c.actionAttr}="${c.actionVal}" class="h-7 px-2.5 rounded-lg bg-[#C88A2B] hover:bg-white text-[#141F18] font-bold text-[11px] inline-flex items-center justify-center transition whitespace-nowrap shrink-0">
                  ${c.actionLabel}
                </button>
              </div>
            </div>
          `).join("");
        }

        applyCtaAttributes(document.getElementById("hero-primary-cta"), s.primaryCta);
        applyCtaAttributes(document.getElementById("hero-secondary-cta"), s.secondaryCta);
        applyCtaAttributes(document.getElementById("hero-tertiary-cta"), s.tertiaryCta);

        const imgEl = document.getElementById("hero-spotlight-img");
        if (imgEl) imgEl.src = s.img;
        const pillL = document.getElementById("hero-card-pill-left");
        const pillR = document.getElementById("hero-card-pill-right");
        if (pillL) pillL.textContent = s.pillLeft;
        if (pillR) pillR.textContent = s.pillRight;

        const ovSub = document.getElementById("hero-overlay-subtitle");
        const ovCon = document.getElementById("hero-overlay-contents");
        const ovMrp = document.getElementById("hero-overlay-mrp");
        const ovPrc = document.getElementById("hero-overlay-price");
        if (ovSub) ovSub.textContent = s.overlaySubtitle;
        if (ovCon) ovCon.textContent = s.overlayContents;
        if (ovMrp) ovMrp.textContent = s.overlayMrp;
        if (ovPrc) ovPrc.textContent = s.overlayPrice;

        const spotTag = document.getElementById("hero-spotlight-tag");
        const spotTitle = document.getElementById("hero-spotlight-title");
        const spotPdp = document.getElementById("hero-spotlight-pdp");
        const spotAdd = document.getElementById("hero-spotlight-add");
        const spotBuy = document.getElementById("hero-spotlight-buy");
        if (spotTag) spotTag.textContent = s.cardTag;
        if (spotTitle) spotTitle.textContent = s.cardTitle;
        if (spotPdp) spotPdp.setAttribute("data-open-pdp", s.inspectSku);
        if (spotAdd) {
          spotAdd.removeAttribute("data-add-bundle");
          spotAdd.removeAttribute("data-quick-add");
          spotAdd.setAttribute(s.cardBtnAttr, s.cardBtnVal);
          spotAdd.textContent = s.cardBtnText;
        }
        if (spotBuy) {
          spotBuy.removeAttribute("data-buy-bundle");
          spotBuy.removeAttribute("data-buy-now");
          if (s.cardBtnAttr === "data-add-bundle") {
            spotBuy.setAttribute("data-buy-bundle", s.cardBtnVal);
          } else {
            spotBuy.setAttribute("data-buy-now", s.cardBtnVal);
          }
        }

        // Update TOC tabs (including inner label contrast)
        document.querySelectorAll(".hero-toc-tab").forEach((tab, i) => {
          const isAct = i === activeHeroSlideIdx;
          tab.setAttribute("aria-selected", isAct ? "true" : "false");
          tab.className = isAct
            ? "hero-toc-tab relative overflow-hidden shrink-0 w-[172px] lg:w-auto lg:flex-1 px-3 py-2 rounded-xl bg-[#C88A2B] text-[#141F18] text-left transition shadow-xs"
            : "hero-toc-tab relative overflow-hidden shrink-0 w-[172px] lg:w-auto lg:flex-1 px-3 py-2 rounded-xl bg-white/5 hover:bg-white/10 text-white border border-white/10 text-left transition";
          const topRowSpans = tab.querySelectorAll("div:first-child > span");
          if (topRowSpans.length >= 1) {
            topRowSpans[0].className = isAct
              ? "font-mono-batch text-[10px] uppercase font-bold tracking-wider text-[#141F18] opacity-85"
              : "font-mono-batch text-[10px] uppercase font-bold tracking-wider text-[#C88A2B]";
          }
          const prog = tab.querySelector(".hero-tab-progress");
          if (prog) {
            prog.style.width = "0%";
            prog.className = isAct
              ? "hero-tab-progress absolute bottom-0 left-0 h-1 bg-[#141F18]/60 transition-all duration-100"
              : "hero-tab-progress absolute bottom-0 left-0 h-1 bg-[#C88A2B] transition-all duration-100";
          }
        });

        // Update Quick Jump Pills inside right card
        document.querySelectorAll(".hero-quick-pill").forEach((pill, i) => {
          const isAct = i === activeHeroSlideIdx;
          pill.className = isAct
            ? "hero-quick-pill h-6 px-2 rounded text-[10px] font-bold bg-[#C88A2B] text-[#141F18] inline-flex items-center justify-center transition whitespace-nowrap"
            : "hero-quick-pill h-6 px-2 rounded text-[10px] font-bold bg-white/5 text-white hover:bg-white/15 inline-flex items-center justify-center transition whitespace-nowrap";
        });

        updateHeroSlideStatusLabel();
      }

      function updateHeroSlideStatusLabel() {
        const statusEl = document.getElementById("hero-slide-status");
        const iconEl = document.getElementById("hero-carousel-toggle-icon");
        const textEl = document.getElementById("hero-carousel-toggle-text");
        if (statusEl) {
          const stateLabel = !heroCarouselAutoPlay
            ? "Paused"
            : heroCarouselHoverPaused
              ? "Hover Paused"
              : "Auto (8s)";
          statusEl.textContent = `Slide ${activeHeroSlideIdx + 1} / ${HERO_OFFER_SLIDES.length} · ${stateLabel}`;
        }
        if (iconEl && textEl) {
          iconEl.textContent = heroCarouselAutoPlay ? "⏸" : "▶";
          textEl.textContent = heroCarouselAutoPlay ? "Pause" : "Auto";
        }
      }

      // Bind TOC tabs & Quick Jump Pills
      document.querySelectorAll("[data-hero-slide]").forEach(btn => {
        btn.addEventListener("click", () => {
          const idx = parseInt(btn.getAttribute("data-hero-slide"), 10);
          if (isNaN(idx)) return;
          // Per Baymard UX guideline: pause auto-rotation when user manually selects a slide
          heroCarouselAutoPlay = false;
          renderHeroOfferSlide(idx);
        });
      });

      const prevHeroBtn = document.getElementById("hero-carousel-prev");
      const nextHeroBtn = document.getElementById("hero-carousel-next");
      const toggleHeroBtn = document.getElementById("hero-carousel-toggle");
      if (prevHeroBtn) {
        prevHeroBtn.addEventListener("click", () => {
          heroCarouselAutoPlay = false;
          renderHeroOfferSlide(activeHeroSlideIdx - 1);
        });
      }
      if (nextHeroBtn) {
        nextHeroBtn.addEventListener("click", () => {
          heroCarouselAutoPlay = false;
          renderHeroOfferSlide(activeHeroSlideIdx + 1);
        });
      }
      if (toggleHeroBtn) {
        toggleHeroBtn.addEventListener("click", () => {
          heroCarouselAutoPlay = !heroCarouselAutoPlay;
          heroSlideProgressMs = 0;
          updateHeroSlideStatusLabel();
        });
      }

      const heroSectionEl = document.getElementById("hero-offer-carousel");
      if (heroSectionEl) {
        heroSectionEl.addEventListener("mouseenter", () => {
          heroCarouselHoverPaused = true;
          updateHeroSlideStatusLabel();
        });
        heroSectionEl.addEventListener("mouseleave", () => {
          heroCarouselHoverPaused = false;
          updateHeroSlideStatusLabel();
        });
      }

      // Initialize Slide 0 and start 6-second automated slideshow timer
      renderHeroOfferSlide(0);
      setInterval(() => {
        if (!heroCarouselAutoPlay || heroCarouselHoverPaused) return;
        const homeView = document.getElementById("view-home");
        if (homeView && homeView.classList.contains("hidden")) return;
        heroSlideProgressMs += HERO_TICK_MS;
        const pct = Math.min(100, Math.round((heroSlideProgressMs / HERO_SLIDE_DURATION_MS) * 100));
        const activeTab = document.querySelectorAll(".hero-toc-tab")[activeHeroSlideIdx];
        if (activeTab) {
          const prog = activeTab.querySelector(".hero-tab-progress");
          if (prog) prog.style.width = `${pct}%`;
        }
        if (heroSlideProgressMs >= HERO_SLIDE_DURATION_MS) {
          renderHeroOfferSlide(activeHeroSlideIdx + 1);
        }
      }, HERO_TICK_MS);

      // Global Click Delegation
      document.body.addEventListener("click", (e) => {
        // Menu, footer and product links are real links for search engines; plain clicks still switch views in place, while new-tab clicks open the real page.
        const pahadanLink = e.target.closest("a[data-nav-view], a[data-filter-cat], a[data-open-pdp]");
        if (pahadanLink && (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0)) return;
        if (pahadanLink) e.preventDefault();
        const stripCouponBtn = e.target.closest("[data-apply-strip-coupon]");
        if (stripCouponBtn) {
          const code = stripCouponBtn.getAttribute("data-apply-strip-coupon");
          appliedCoupon = code;
          const couponInput = document.getElementById("cart-coupon-input");
          if (couponInput) couponInput.value = code;
          renderCart();
          showToast(`Applied ${code} to your Pahadi Pantry Bag! Extra savings active.`);
          return;
        }

        const navBtn = e.target.closest("[data-nav-view]");
        if (navBtn) {
          switchView(navBtn.getAttribute("data-nav-view"));
          return;
        }

        const catJump = e.target.closest(".cat-jump-btn");
        if (catJump) {
          colCatFilter = catJump.getAttribute("data-filter-cat") || "all";
          document.querySelectorAll(".col-cat-btn").forEach(b => {
            b.className = b.getAttribute("data-col-cat") === colCatFilter
              ? "col-cat-btn px-3 py-1.5 rounded-lg text-xs font-semibold bg-[#1E2D24] text-white shrink-0"
              : "col-cat-btn px-3 py-1.5 rounded-lg text-xs font-semibold bg-white text-[#1E2D24] shrink-0";
          });
          renderCollectionProducts();
          switchView("collection");
          return;
        }

        const homeTab = e.target.closest(".home-tab-btn");
        if (homeTab) {
          homeTabFilter = homeTab.getAttribute("data-home-tab");
          document.querySelectorAll(".home-tab-btn").forEach(b => {
            b.className = b.getAttribute("data-home-tab") === homeTabFilter
              ? "home-tab-btn px-3.5 py-2 rounded-full text-xs font-semibold bg-[#1E2D24] text-white transition whitespace-nowrap shrink-0"
              : "home-tab-btn px-3.5 py-2 rounded-full text-xs font-semibold bg-white text-[#1E2D24] hover:bg-[#E2D9C8] transition whitespace-nowrap shrink-0";
          });
          renderHomeProducts();
          return;
        }

        const colCat = e.target.closest(".col-cat-btn");
        if (colCat) {
          colCatFilter = colCat.getAttribute("data-col-cat");
          document.querySelectorAll(".col-cat-btn").forEach(b => {
            b.className = b.getAttribute("data-col-cat") === colCatFilter
              ? "col-cat-btn px-3 py-1.5 rounded-lg text-xs font-semibold bg-[#1E2D24] text-white shrink-0"
              : "col-cat-btn px-3 py-1.5 rounded-lg text-xs font-semibold bg-white text-[#1E2D24] shrink-0";
          });
          renderCollectionProducts();
          return;
        }

        const openPdp = e.target.closest(".pdp-jump-btn");
        if (openPdp) {
          activePdpSku = openPdp.getAttribute("data-open-pdp");
          activePdpGalleryIdx = 0;
          pdpQty = 1;
          renderPDP();
          switchView("pdp");
          return;
        }

        const quickAdd = e.target.closest("[data-quick-add]");
        if (quickAdd) {
          // Mobile bottom bar on a product page: use the quantity chosen on the page.
          const quickQty = quickAdd.id === "sticky-bar-add-btn" && currentView === "pdp" ? pdpQty : 1;
          addToCart(quickAdd.getAttribute("data-quick-add"), quickQty);
          return;
        }

        const buyNowBtn = e.target.closest("[data-buy-now]");
        if (buyNowBtn) {
          const buyQty = buyNowBtn.id === "sticky-bar-buy-btn" && currentView === "pdp" ? pdpQty : 1;
          buyNow(buyNowBtn.getAttribute("data-buy-now"), buyQty);
          return;
        }

        const buyBundleBtn = e.target.closest("[data-buy-bundle]");
        if (buyBundleBtn) {
          buyBundleNow(buyBundleBtn.getAttribute("data-buy-bundle"));
          return;
        }

        const notifyBtn = e.target.closest("[data-notify-sku]");
        if (notifyBtn) {
          addToCart(notifyBtn.getAttribute("data-notify-sku"), 1);
          return;
        }

        const addBundleBtn = e.target.closest("[data-add-bundle]");
        if (addBundleBtn) {
          const bId = addBundleBtn.getAttribute("data-add-bundle");
          const b = BUNDLES.find(x => x.id === bId);
          if (b) {
            b.items.forEach(sku => {
              const p = getProduct(sku);
              if (p.inStock) {
                const ex = cart.find(i => i.sku === sku);
                if (ex) ex.qty += 1;
                else cart.push({ sku, qty: 1 });
              }
            });
            cartBundles.push(b.id);
            renderCart();
            showAtcConfirmationBar(b.items[0], b.items.length, `${b.title} — ${formatINR(b.bundlePrice)} (Saved ₹${b.savesAmount} + Free Shipping)`);
          }
          return;
        }

        

        const inspectBatch = e.target.closest(".batch-modal-btn");
        if (inspectBatch) {
          const code = inspectBatch.getAttribute("data-inspect-batch");
          document.getElementById("batch-code-input").value = code;
          renderBatchReport(code);
          switchView("lab");
          return;
        }

        const sampleBatch = e.target.closest(".sample-batch-btn");
        if (sampleBatch) {
          const code = sampleBatch.getAttribute("data-sample-batch");
          document.getElementById("batch-code-input").value = code;
          renderBatchReport(code);
          return;
        }

        const faqCatBtn = e.target.closest(".faq-cat-btn");
        if (faqCatBtn) {
          activeFaqCat = faqCatBtn.getAttribute("data-faq-cat") || "all";
          document.querySelectorAll(".faq-cat-btn").forEach(b => {
            b.className = b.getAttribute("data-faq-cat") === activeFaqCat
              ? "faq-cat-btn px-3 py-1.5 rounded-full text-xs font-bold bg-[#1E2D24] text-white transition whitespace-nowrap"
              : "faq-cat-btn px-3 py-1.5 rounded-full text-xs font-bold bg-white border border-[#E2D9C8] text-[#1E2D24] hover:bg-[#F3EDE2] transition whitespace-nowrap";
          });
          renderFaqList();
          return;
        }

        const policyBtn = e.target.closest(".policy-tab-btn");
        if (policyBtn) {
          const key = policyBtn.getAttribute("data-policy-tab");
          document.querySelectorAll(".policy-tab-btn").forEach(b => {
            b.className = b.getAttribute("data-policy-tab") === key
              ? "policy-tab-btn px-3 py-1.5 rounded-lg text-xs font-bold bg-[#1E2D24] text-white"
              : "policy-tab-btn px-3 py-1.5 rounded-lg text-xs font-bold bg-[#F3EDE2] text-[#1E2D24]";
          });
          document.getElementById("policy-tab-content").innerHTML = POLICIES[key] || POLICIES.refund;
          return;
        }

        const cDec = e.target.closest("[data-cart-dec]");
        if (cDec) {
          const sku = cDec.getAttribute("data-cart-dec");
          const item = cart.find(x => x.sku === sku);
          if (item) {
            item.qty -= 1;
            if (item.qty <= 0) cart = cart.filter(x => x.sku !== sku);
            renderCart();
          }
          return;
        }
        const cInc = e.target.closest("[data-cart-inc]");
        if (cInc) {
          const sku = cInc.getAttribute("data-cart-inc");
          const item = cart.find(x => x.sku === sku);
          if (item) { item.qty += 1; renderCart(); }
          return;
        }
        const cRem = e.target.closest("[data-cart-rem]");
        if (cRem) {
          const sku = cRem.getAttribute("data-cart-rem");
          cart = cart.filter(x => x.sku !== sku);
          renderCart();
          return;
        }

        const cUpg = e.target.closest("[data-cart-upgrade-from]");
        if (cUpg) {
          const fromSku = cUpg.getAttribute("data-cart-upgrade-from");
          const toSku = cUpg.getAttribute("data-cart-upgrade-to");
          const item = cart.find(x => x.sku === fromSku);
          if (item && toSku) {
            const qty = item.qty;
            cart = cart.filter(x => x.sku !== fromSku);
            const existingTarget = cart.find(x => x.sku === toSku);
            if (existingTarget) existingTarget.qty += qty;
            else cart.push({ sku: toSku, qty });
            renderCart();
            showToast(`Upgraded to ${getProduct(toSku).shortTitle} for better per-unit value!`);
          }
          return;
        }

        const disUpg = e.target.closest("[data-dismiss-upgrade]");
        if (disUpg) {
          const sku = disUpg.getAttribute("data-dismiss-upgrade");
          if (sku && !dismissedUpgradeSkus.includes(sku)) {
            dismissedUpgradeSkus.push(sku);
            renderCart();
          }
          return;
        }

        const upsellAddBtn = e.target.closest("[data-upsell-add]");
        if (upsellAddBtn) {
          const sku = upsellAddBtn.getAttribute("data-upsell-add");
          if (sku) {
            addToCart(sku, 1);
            // Automatically pop up the next available upsell option!
            activeCartUpsellIdx = 0;
            renderCart();
          }
          return;
        }

        const upsellSkipBtn = e.target.closest("[data-upsell-skip]");
        if (upsellSkipBtn) {
          const recs = getSmartCartRecommendations(skippedUpsellSkus);
          if (recs.length > 1) {
            activeCartUpsellIdx = (activeCartUpsellIdx + 1) % recs.length;
          } else {
            isCartUpsellDismissed = true;
          }
          renderCart();
          return;
        }

        const upsellDotBtn = e.target.closest("[data-upsell-dot]");
        if (upsellDotBtn) {
          activeCartUpsellIdx = Number(upsellDotBtn.getAttribute("data-upsell-dot")) || 0;
          renderCart();
          return;
        }

        const ritualBtn = e.target.closest("[data-add-ritual]");
        if (ritualBtn) {
          const skus = ritualBtn.getAttribute("data-add-ritual").split(",");
          const rName = ritualBtn.getAttribute("data-ritual-name") || "Pahadi Meal Pairing";
          skus.forEach(s => {
            const ex = cart.find(i => i.sku === s);
            if (ex) ex.qty += 1;
            else cart.push({ sku: s, qty: 1 });
          });
          renderCart();
          showAtcConfirmationBar(skus[0], skus.length, rName);
          return;
        }

        const revFilterBtn = e.target.closest(".review-filter-btn");
        if (revFilterBtn) {
          reviewCategoryFilter = revFilterBtn.getAttribute("data-review-filter") || "all";
          document.querySelectorAll(".review-filter-btn").forEach(b => {
            b.className = b.getAttribute("data-review-filter") === reviewCategoryFilter
              ? "review-filter-btn px-3.5 py-1.5 rounded-full text-xs font-bold bg-[#1E2D24] text-white transition whitespace-nowrap"
              : "review-filter-btn px-3.5 py-1.5 rounded-full text-xs font-bold bg-white border border-[#E2D9C8] text-[#1E2D24] hover:bg-[#F3EDE2] transition whitespace-nowrap";
          });
          renderHomeReviews();
          return;
        }

        const reelBtn = e.target.closest(".reel-story-btn");
        if (reelBtn) {
          const storyKey = reelBtn.getAttribute("data-reel-story");
          if (storyKey === "trials") {
            colCatFilter = "Trial";
            renderCollectionProducts();
            switchView("collection");
            return;
          }
          if (storyKey === "reviews") {
            switchView("home");
            const revSec = document.getElementById("home-google-reviews");
            if (revSec) revSec.scrollIntoView({ behavior: "smooth" });
            return;
          }
          const reelMap = {
            bilona: {
              title: "🎬 Reel Highlight: Dadi Ji's 4-Step Wooden Bilona Ghee",
              img: ASSETS.GHEE_5_PROCESS,
              body: "1. Free-grazing Pahadi cow A2 milk boiled slowly on firewood in Village Drahal.<br>2. Set overnight into rich curd (dahi) in earthen clay matkas.<br>3. Hand-churned clockwise &amp; counter-clockwise with a wooden bilona.<br>4. Fresh makkhan clarified on slow flame into granular, aromatic Bilona Ghee.",
              sku: "PF-GHEE-1000",
              cta: "+ Add 1L Bilona Ghee (₹1,749)"
            },
            garlic: {
              title: "🧄 Reel Highlight: Rare Barot Valley Pink Garlic Pickle",
              img: ASSETS.GP200_3_BATCHES,
              body: "Harvested from high-altitude farms in Barot Valley and slow sun-cured by Pahadan women in cold-pressed mustard oil, jaggery, kalonji, black sesame, and whole spices. Zero commercial premixes or preservatives.",
              sku: "PF-ACH-PG200T",
              cta: "+ Add 200g Starter Jar (₹319)"
            },
            amla: {
              title: "🌿 Reel Highlight: 100% Wild Himalayan Forest Amla",
              img: ASSETS.AM500_5_MOTTO,
              body: "Foraged from unpolluted Himalayan forests with 0% pesticides and no premixes added. Rich in natural Vitamin C and sun-cured by our Drahal women's collective.",
              sku: "PF-ACH-AM200T",
              cta: "+ Add 200g Forest Amla Trial (₹275)"
            }
          };
          const st = reelMap[storyKey];
          if (st) {
            openModal(st.title, `
              <img src="${st.img}" alt="${st.title}" class="w-full aspect-square object-cover rounded-xl border border-[#E2D9C8]" />
              <p class="text-xs text-[#1C241E] leading-relaxed pt-2">${st.body}</p>
              <div class="flex flex-col sm:flex-row gap-2 pt-2">
                <button type="button" onclick="closeModal();" data-quick-add="${st.sku}" class="flex-1 py-3 rounded-xl bg-[#1E2D24] hover:bg-[#9E3B24] text-white font-bold text-xs">${st.cta}</button>
                <button type="button" onclick="closeModal();" data-open-pdp="${st.sku}" class="pdp-jump-btn px-4 py-3 rounded-xl border border-[#1E2D24] text-[#1E2D24] font-bold text-xs">View Full Gallery</button>
              </div>
            `);
          }
          return;
        }
      });

      // Footer Mural Peek Toggle
      const peekBtn = document.getElementById("btn-peek-footer-mural");
      const siteFooter = document.getElementById("site-footer");
      if (peekBtn && siteFooter) {
        peekBtn.addEventListener("click", () => {
          siteFooter.classList.toggle("mural-peek-active");
          const isPeek = siteFooter.classList.contains("mural-peek-active");
          peekBtn.textContent = isPeek ? "🖼️ Show Footer Info Panels" : "🖼️ View Full Village Artwork";
        });
      }

      document.getElementById("btn-mega-menu-toggle").addEventListener("click", () => {
        document.getElementById("mega-menu-panel").classList.toggle("hidden");
      });
      document.getElementById("btn-mobile-menu").addEventListener("click", () => {
        document.getElementById("mobile-nav-drawer").classList.toggle("hidden");
      });
      document.getElementById("btn-header-search").addEventListener("click", () => {
        switchView("collection");
        document.getElementById("collection-search-input").focus();
      });

      document.getElementById("collection-search-input").addEventListener("input", (e) => {
        colSearchQuery = e.target.value;
        renderCollectionProducts();
      });
      document.getElementById("collection-sort-select").addEventListener("change", (e) => {
        colSortBy = e.target.value;
        renderCollectionProducts();
      });
      document.getElementById("filter-instock-only").addEventListener("change", (e) => {
        colInStockOnly = e.target.checked;
        renderCollectionProducts();
      });
      const resetAllFilters = () => {
        colCatFilter = "all";
        colSearchQuery = "";
        colSortBy = "featured";
        colInStockOnly = false;
        document.getElementById("collection-search-input").value = "";
        document.getElementById("collection-sort-select").value = "featured";
        document.getElementById("filter-instock-only").checked = false;
        renderCollectionProducts();
      };
      document.getElementById("btn-reset-filters").addEventListener("click", resetAllFilters);
      document.getElementById("btn-empty-reset").addEventListener("click", resetAllFilters);

      document.querySelectorAll(".bundle-slot-select").forEach(sel => {
        sel.addEventListener("change", updateCustomBundleMath);
      });
      document.getElementById("btn-add-custom-bundle").addEventListener("click", () => {
        const skus = [
          document.getElementById("bundle-slot-1").value,
          document.getElementById("bundle-slot-2").value,
          document.getElementById("bundle-slot-3").value
        ];
        skus.forEach(sku => {
          const ex = cart.find(i => i.sku === sku);
          if (ex) ex.qty += 1;
          else cart.push({ sku, qty: 1 });
        });
        // Shopify: record the box so its jars aren't counted toward a curated combo (brief v3: no extra discount).
        pahadanCustomBoxes.push(skus.slice());
        pahadanSaveCustomBoxes();
        renderCart();
        document.getElementById("cart-drawer-backdrop").classList.remove("hidden");
        showToast("Added your custom 3-Jar Box to the bag!");
      });

      document.getElementById("btn-lookup-batch").addEventListener("click", () => {
        renderBatchReport(document.getElementById("batch-code-input").value);
      });

      // Shopify: partners earn ₹75 per eligible jar (1L/500ml ghee, 650g honey, 500g pickles); ₹0 on 200g/250g/250ml packs. Matches BixGrow.
      document.getElementById("partner-jars-range").addEventListener("input", (e) => {
        const jars = Number(e.target.value);
        document.getElementById("partner-jars-label").textContent = `${jars} Eligible Jars / Month`;
        document.getElementById("partner-earning-output").textContent = formatINR(jars * 75) + " / mo";
      });
      // Shopify: partners sign up on the BixGrow partner portal, which gives them their referral link and coupon code.
      document.getElementById("btn-submit-partner").addEventListener("click", () => {
        const signupUrl = "https://uzppeb-b3.bixgrow.com/register";
        const fb = document.getElementById("partner-form-feedback");
        const win = window.open(signupUrl, "_blank");
        if (win) {
          win.opener = null;
          fb.textContent = "✓ Our partner sign-up page opened in a new tab. Complete it there to get your referral link and coupon code.";
          fb.classList.remove("hidden");
        } else {
          window.location.href = signupUrl;
        }
      });

      document.getElementById("btn-footer-subscribe").addEventListener("click", () => {
        const val = document.getElementById("footer-newsletter-input").value.trim();
        const msg = document.getElementById("footer-sub-msg");
        // Shopify: emails are saved as subscribed customers; phone numbers go to WhatsApp.
        if (val.includes("@")) {
          const nlForm = document.getElementById("pahadan-newsletter-form");
          if (nlForm) {
            document.getElementById("pahadan-newsletter-email").value = val;
            nlForm.submit();
            return;
          }
        } else if (val) {
          pahadanOpenWhatsApp(`Please add me to Drahal Fresh Batch Alerts.\nMy WhatsApp: ${val}`);
        }
        msg.textContent = val ? "✓ WhatsApp opened. Press Send there to join Drahal Fresh Batch Alerts." : "Please enter your email or WhatsApp number.";
        msg.classList.remove("hidden");
      });

      document.getElementById("btn-open-cart").addEventListener("click", () => {
        document.getElementById("cart-drawer-backdrop").classList.remove("hidden");
      });
      document.getElementById("btn-close-cart").addEventListener("click", () => {
        document.getElementById("cart-drawer-backdrop").classList.add("hidden");
      });
      document.getElementById("cart-drawer-backdrop").addEventListener("click", (e) => {
        if (e.target.id === "cart-drawer-backdrop") {
          document.getElementById("cart-drawer-backdrop").classList.add("hidden");
        }
      });

      // Single-Option Slidable & Dismissible Cart Upsell Controls
      const btnCloseUpsell = document.getElementById("btn-close-cart-upsell");
      if (btnCloseUpsell) {
        btnCloseUpsell.addEventListener("click", () => {
          isCartUpsellDismissed = true;
          renderCart();
        });
      }
      const btnReopenUpsell = document.getElementById("btn-reopen-cart-upsell");
      if (btnReopenUpsell) {
        btnReopenUpsell.addEventListener("click", () => {
          isCartUpsellDismissed = false;
          renderCart();
        });
      }
      const btnUpsellPrev = document.getElementById("btn-upsell-prev");
      if (btnUpsellPrev) {
        btnUpsellPrev.addEventListener("click", () => {
          const recs = getSmartCartRecommendations(skippedUpsellSkus);
          const count = recs.length || 1;
          activeCartUpsellIdx = (activeCartUpsellIdx - 1 + count) % count;
          renderCart();
        });
      }
      const btnUpsellNext = document.getElementById("btn-upsell-next");
      if (btnUpsellNext) {
        btnUpsellNext.addEventListener("click", () => {
          const recs = getSmartCartRecommendations(skippedUpsellSkus);
          const count = recs.length || 1;
          activeCartUpsellIdx = (activeCartUpsellIdx + 1) % count;
          renderCart();
        });
      }

      // Horizontal Touch Swipe Gesture on Cart Upsell Slider
      const upsellListEl = document.getElementById("cart-upsell-list");
      if (upsellListEl) {
        let touchStartX = 0;
        upsellListEl.addEventListener("touchstart", (e) => {
          if (e.touches && e.touches[0]) touchStartX = e.touches[0].clientX;
        }, { passive: true });
        upsellListEl.addEventListener("touchend", (e) => {
          if (!e.changedTouches || !e.changedTouches[0]) return;
          const diffX = e.changedTouches[0].clientX - touchStartX;
          if (Math.abs(diffX) > 35) {
            const recs = getSmartCartRecommendations(skippedUpsellSkus);
            const count = recs.length || 1;
            if (diffX < 0) activeCartUpsellIdx = (activeCartUpsellIdx + 1) % count;
            else activeCartUpsellIdx = (activeCartUpsellIdx - 1 + count) % count;
            renderCart();
          }
        }, { passive: true });
      }

      // Collapsible Promo & Bill Breakdown Toggle in Cart Footer
      const btnToggleCartDetails = document.getElementById("btn-toggle-cart-details");
      if (btnToggleCartDetails) {
        btnToggleCartDetails.addEventListener("click", () => {
          isCartDetailsExpanded = !isCartDetailsExpanded;
          const detailsEl = document.getElementById("cart-collapsible-details");
          const chevEl = document.getElementById("cart-details-chevron");
          if (detailsEl) detailsEl.classList.toggle("hidden", !isCartDetailsExpanded);
          if (chevEl) chevEl.textContent = isCartDetailsExpanded ? "▾" : "▸";
        });
      }

      // Dismiss Cross-Sell Strip inside ATC Confirmation Bar
      const btnCloseAtcCs = document.getElementById("atc-cross-sell-close");
      if (btnCloseAtcCs) {
        btnCloseAtcCs.addEventListener("click", () => {
          const csBox = document.getElementById("atc-bar-cross-sell");
          if (csBox) csBox.classList.add("hidden");
        });
      }
      document.getElementById("btn-apply-coupon").addEventListener("click", () => {
        const code = document.getElementById("cart-coupon-input").value.trim().toUpperCase();
        const msg = document.getElementById("cart-coupon-msg");
        msg.classList.remove("hidden");
        if (code === PAHADAN_WELCOME.code) {
          appliedCoupon = PAHADAN_WELCOME.code;
          msg.textContent = "✓ Applied WELCOME100 (₹100 off your first order of ₹599+, confirmed at checkout)";
        } else if (!code) {
          msg.textContent = "Please enter a promo code.";
        } else {
          // Other codes are sent to Shopify checkout, which checks and applies them there.
          appliedCoupon = code;
          msg.textContent = `✓ ${code} saved — it will be checked and applied at checkout.`;
        }
        renderCart();
      });

      window.triggerPostPurchaseOffer = function() {
        const smartAddOn = getSmartCartRecommendations()[0] || getProduct("PF-HON-WF250");
        const postPrice = Math.round(smartAddOn.price * 0.85);
        openModal("🎉 Order #PF-26108 Confirmed! One-Time Post-Purchase Offer", `
          <div class="p-3.5 rounded-xl bg-[#D1E7DD] border border-[#1E2D24]/25 text-xs text-[#1E2D24]">
            <strong>✓ Thank you! Your Village Drahal shipment is queued for glass-safe packing.</strong>
            <div class="text-[11px] mt-0.5">FSSAI Lic. #23326011006238 · Confirmation sent via WhatsApp (+91 92172 24336).</div>
          </div>
          <div class="p-4 rounded-2xl bg-[#F3EDE2] border-2 border-[#C88A2B] space-y-3 mt-2">
            <div class="flex items-center justify-between">
              <span class="px-2 py-0.5 rounded bg-[#9E3B24] text-white font-mono-batch text-[10px] font-bold uppercase">Post-Purchase 1-Click Add-On · Save 15%</span>
              <span class="font-mono-batch text-[10px] font-bold text-[#1E2D24]">₹0 Extra Shipping</span>
            </div>
            <div class="flex items-center gap-3">
              <img src="${ASSETS[smartAddOn.imageKey]}" alt="${smartAddOn.shortTitle}" class="w-16 h-16 rounded-xl object-cover border border-[#C88A2B] shrink-0" />
              <div class="text-xs">
                <div class="font-serif-editorial text-lg font-bold text-[#1E2D24]">Add ${smartAddOn.title} to Your Same Box?</div>
                <p class="text-[11px] text-[#5C645E] mt-0.5">Since your corrugated box is already being packed in Drahal, add this jar with <strong>zero extra shipping</strong> and <strong>15% VIP savings</strong>:</p>
                <div class="mt-1 flex items-baseline gap-2">
                  <span class="text-base font-bold text-[#9E3B24]">${formatINR(postPrice)}</span>
                  <span class="text-xs line-through text-[#5C645E]">${formatINR(smartAddOn.price)} (MRP ${formatINR(smartAddOn.mrp)})</span>
                </div>
              </div>
            </div>
            <div class="flex flex-col sm:flex-row gap-2 pt-1">
              <button type="button" onclick="closeModal(); showToast('Added ' + '${smartAddOn.shortTitle}' + ' to Order #PF-26108 at ' + '${formatINR(postPrice)}' + '!');" class="flex-1 py-2.5 px-4 rounded-xl bg-[#1E2D24] hover:bg-[#9E3B24] text-white font-bold text-xs transition">
                + Yes, Add to My Shipment (${formatINR(postPrice)})
              </button>
              <button type="button" onclick="closeModal(); showToast('Order #PF-26108 receipt finalized.');" class="px-4 py-2.5 rounded-xl border border-[#1E2D24]/30 text-[#1E2D24] font-semibold text-xs">
                No Thanks, View Receipt
              </button>
            </div>
          </div>
        `);
      };

      const openExpressCheckoutModal = () => {
        hideAtcConfirmationBar();
        document.getElementById("cart-drawer-backdrop").classList.add("hidden");
        // Shopify checkout replaces the demo's simulated checkout form (kept below, unused).
        pahadanGoToCheckout();
        return;
        const subtotal = cart.reduce((acc, i) => acc + getProduct(i.sku).price * i.qty, 0);
        const { activeBundles, totalBundleSavings } = computeActiveCartBundles();
        const promoDisc = appliedCoupon === "FOUNDER100" ? 100 : appliedCoupon === "PAHADAN10" ? Math.round(Math.max(0, subtotal - totalBundleSavings) * 0.10) : 0;
        const netAfterDiscounts = Math.max(0, subtotal - totalBundleSavings - promoDisc);
        const hasFreeShip = netAfterDiscounts >= PAHADAN_SHIP.freeFrom;
        const finalPayable = netAfterDiscounts + (hasFreeShip ? 0 : PAHADAN_SHIP.fee);
        openModal("Express Secure Prepaid Checkout — The Pahadan's Farm", `
          <div class="p-3 rounded-xl bg-[#F3EDE2] border border-[#C88A2B] flex flex-wrap items-center justify-between gap-2 text-[11px]">
            <span><strong>FSSAI #23326011006238</strong></span>
            <span class="font-mono-batch font-bold text-[#9E3B24]">🛡️ 100% Glass-Breakage Cover</span>
          </div>
          <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5 pt-1">
            <input type="text" placeholder="Full Name" value="Ananya Sharma" class="px-3 py-2 rounded-lg border border-[#E2D9C8] bg-white text-xs" />
            <input type="tel" placeholder="WhatsApp Mobile (+91)" value="+91 98110 45210" class="px-3 py-2 rounded-lg border border-[#E2D9C8] bg-white text-xs" />
            <input type="text" placeholder="Delivery Address & PIN Code" value="Hauz Khas Enclave, New Delhi — 110016" class="sm:col-span-2 px-3 py-2 rounded-lg border border-[#E2D9C8] bg-white text-xs" />
          </div>
          <div class="space-y-2 pt-1">
            <label class="flex items-center justify-between p-3 rounded-xl border-2 border-[#1E2D24] bg-white cursor-pointer">
              <div class="flex items-center gap-2">
                <input type="radio" name="checkout_pay_mode" checked class="accent-[#1E2D24]" />
                <div>
                  <div class="font-bold text-xs text-[#1E2D24]">1. Instant UPI (GPay, PhonePe, Paytm, BHIM)</div>
                  <div class="text-[10px] text-[#5C645E]">Zero gateway fee · Instant SMS &amp; Email confirmation · Careful Packaging</div>
                </div>
              </div>
              <span class="font-mono-batch font-bold text-sm text-[#1E2D24]">${formatINR(finalPayable)}</span>
            </label>
            <label class="flex items-center justify-between p-3 rounded-xl border border-[#E2D9C8] bg-white cursor-pointer">
              <div class="flex items-center gap-2">
                <input type="radio" name="checkout_pay_mode" class="accent-[#1E2D24]" />
                <div>
                  <div class="font-bold text-xs text-[#1E2D24]">2. Debit / Credit Cards, NetBanking &amp; Wallets</div>
                  <div class="text-[10px] text-[#5C645E]">100% encrypted payment gateway (Visa, Mastercard, RuPay, All Indian Banks)</div>
                </div>
              </div>
              <span class="font-mono-batch font-bold text-sm text-[#1E2D24]">${formatINR(finalPayable)}</span>
            </label>
          </div>
          <button type="button" onclick="window.triggerPostPurchaseOffer();" class="w-full py-3.5 rounded-xl bg-[#1E2D24] hover:bg-[#9E3B24] text-white font-bold text-xs uppercase tracking-wider mt-2 shadow-md transition">
            Pay ${formatINR(finalPayable)} &amp; Complete Order →
          </button>
        `);
      };

      _expressCheckoutLauncher = openExpressCheckoutModal;
      document.getElementById("btn-proceed-checkout").addEventListener("click", openExpressCheckoutModal);

      // Bottom-Centred Add-to-Cart Confirmation Bar Controls
      document.getElementById("atc-btn-continue").addEventListener("click", hideAtcConfirmationBar);
      document.getElementById("atc-btn-view-cart").addEventListener("click", () => {
        hideAtcConfirmationBar();
        document.getElementById("cart-drawer-backdrop").classList.remove("hidden");
      });
      document.getElementById("atc-btn-checkout").addEventListener("click", openExpressCheckoutModal);
      const atcBarEl = document.getElementById("atc-confirmation-bar");
      if (atcBarEl) {
        atcBarEl.addEventListener("mouseenter", () => {
          if (window._atcBarTimer) clearTimeout(window._atcBarTimer);
        });
        atcBarEl.addEventListener("mouseleave", () => {
          window._atcBarTimer = setTimeout(hideAtcConfirmationBar, 5000);
        });
      }
      document.addEventListener("keydown", (e) => {
        if (e.key === "Escape") {
          hideAtcConfirmationBar();
          closeModal();
          document.getElementById("cart-drawer-backdrop").classList.add("hidden");
        }
      });

      const openWhatsAppModal = () => {
        openModal("WhatsApp Pantry Concierge (+91 92172 24336)", `
          <p>Connect directly with our team at <strong>Village Drahal, Joginder Nagar, Distt. Mandi (H.P. 175015)</strong>:</p>
          <ul class="list-disc pl-5 space-y-1 text-[#5C645E]">
            <li>Request batch-specific lab reports for Bilona Ghee, Barot Pink Garlic, or Forest Amla</li>
            <li>Ask about custom family gifting boxes</li>
            <li>Report transit damage within 48 hours of delivery with photo/video proof</li>
          </ul>
          <div class="p-3 rounded-xl bg-[#D1E7DD] text-[#1E2D24] font-mono-batch text-xs mt-2">
            WhatsApp: +91 92172 24336 · Email: pahadansfarm@gmail.com / contact@pahadansfarm.com
          </div>
        `);
      };
      document.getElementById("btn-open-whatsapp-top").addEventListener("click", openWhatsAppModal);
      document.getElementById("btn-support-whatsapp").addEventListener("click", openWhatsAppModal);
      document.getElementById("btn-close-modal").addEventListener("click", closeModal);

      // Top Continuous Offer Marquee Strip Pause/Play Toggle
      let isMarqueePaused = false;
      const btnToggleMarquee = document.getElementById("btn-toggle-marquee");
      const marqueeTrack = document.getElementById("top-marquee-track");
      if (btnToggleMarquee && marqueeTrack) {
        btnToggleMarquee.addEventListener("click", () => {
          isMarqueePaused = !isMarqueePaused;
          marqueeTrack.classList.toggle("marquee-paused", isMarqueePaused);
          const iconEl = document.getElementById("marquee-toggle-icon");
          const labelEl = document.getElementById("marquee-toggle-label");
          if (iconEl) iconEl.textContent = isMarqueePaused ? "▶" : "⏸";
          if (labelEl) labelEl.textContent = isMarqueePaused ? "Play" : "Pause";
        });
      }
    });

    // ============================================================================
    // SHOPIFY BRIDGE: open the demo view that matches the Shopify URL
    // (/products/... -> PDP for that jar, /collections/... -> Shop All filtered).
    // Registered after the demo's own start-up listener, so it runs once that finishes.
    // ============================================================================
    window.addEventListener("DOMContentLoaded", () => {
      const initial = window.PAHADAN_INITIAL_VIEW;
      if (!initial) return;
      if (initial.view === "cart") {
        // Shopify /cart page: open the demo's bag over the home view.
        document.getElementById("cart-drawer-backdrop").classList.remove("hidden");
        return;
      }
      if (initial.view === "pdp") {
        const match = PRODUCTS.find(p => p.officialSku === initial.officialSku);
        if (!match) return;
        activePdpSku = match.sku;
        activePdpGalleryIdx = 0;
        pdpQty = 1;
        renderPDP();
        const pfPdpBox = document.getElementById("pdp-dynamic-container");
        if (pfPdpBox) pfPdpBox.classList.add("pf-pdp-ready");
        switchView("pdp");
      } else if (initial.view === "collection") {
        colCatFilter = initial.cat || "all";
        document.querySelectorAll(".col-cat-btn").forEach(b => {
          b.className = b.getAttribute("data-col-cat") === colCatFilter
            ? "col-cat-btn px-3 py-1.5 rounded-lg text-xs font-semibold bg-[#1E2D24] text-white shrink-0"
            : "col-cat-btn px-3 py-1.5 rounded-lg text-xs font-semibold bg-white text-[#1E2D24] shrink-0";
        });
        renderCollectionProducts();
        switchView("collection");
      }
    });

    // ============================================================================
    // Shopify: real web addresses for the demo's views, so each can be shared,
    // found on Google, and reloaded. Switching views stays instant as in the demo;
    // opening a product from another view loads its real product page so Shopify
    // (and Meta) count it as a product view. Back/forward buttons follow the views.
    // ============================================================================
    let _pahadanRouting = true; // true while the page sets its first view or follows Back/Forward
    function pahadanUrlFor(view) {
      const root = (PAHADAN_SHOP.rootUrl || "/").replace(/\/$/, "");
      if (view === "pdp") {
        const p = getProduct(activePdpSku);
        return p && p.handle ? root + "/products/" + p.handle : null;
      }
      if (view === "collection") {
        const map = { Ghee: "ghee", Honey: "honey", Aachar: "aachar" };
        return root + "/collections/" + (map[colCatFilter] || "all");
      }
      if (view === "story") return root + "/pages/our-story";
      if (view === "support") return root + "/pages/faq";
      if (view === "lab") return root + "/pages/lab-report";
      if (view === "bundles") return root + "/pages/bundles";
      if (view === "partner") return root + "/pages/affiliate";
      return root + "/";
    }
    function pahadanViewState() {
      return { pahadanView: currentView, sku: activePdpSku, cat: colCatFilter };
    }
    // Search title and description for a view, from the store data in the layout.
    function pahadanMetaFor(view) {
      const vm = PAHADAN_SHOP.viewMeta || {};
      if (view === "pdp") {
        const p = getProduct(activePdpSku);
        const live = p && PAHADAN_SHOP.variants[p.officialSku];
        return live ? live.meta : null;
      }
      if (view === "collection") {
        const map = { Ghee: "ghee", Honey: "honey", Aachar: "aachar" };
        return vm["collection-" + (map[colCatFilter] || "all")];
      }
      if (view === "partner") return vm.partner || vm.home;
      if (view === "home") return vm.home;
      return vm[view];
    }
    // Keeps the tab title, description, canonical and sharing tags in step with the address.
    function pahadanApplyViewMeta(view) {
      const m = pahadanMetaFor(view);
      if (!m) return false;
      const pageUrl = location.origin + location.pathname;
      const set = (selector, attr, value) => {
        const el = document.querySelector(selector);
        if (el && value) el.setAttribute(attr, value);
      };
      if (m.title) document.title = m.title;
      set('meta[name="description"]', "content", m.description);
      set('link[rel="canonical"]', "href", pageUrl);
      set('meta[property="og:url"]', "content", pageUrl);
      set('meta[property="og:title"]', "content", m.title);
      set('meta[property="og:description"]', "content", m.description);
      set('meta[name="twitter:title"]', "content", m.title);
      set('meta[name="twitter:description"]', "content", m.description);
      return true;
    }
    // Real page load after the bag has finished saving to the real cart.
    function pahadanNavigate(url) {
      if (_pahadanSyncTimer) { clearTimeout(_pahadanSyncTimer); _pahadanSyncTimer = null; }
      pahadanSyncCartNow().then((ok) => {
        if (!ok) { showToast("We couldn't save your bag. Please try again."); return; }
        window.location.href = url;
      });
    }
    function pahadanSetUrl(view, prevView) {
      if (_pahadanRouting) return;
      const url = pahadanUrlFor(view);
      if (!url) return;
      const target = new URL(url, location.origin);
      if (target.pathname + target.hash === location.pathname + location.hash) return;
      // Opening a product from another view, or going Home from another page, loads the real page
      // so Shopify counts the visit and the page has its own title from your store settings.
      const leavesPage = target.pathname !== location.pathname;
      if ((view === "pdp" && prevView !== "pdp") || (view === "home" && leavesPage)) {
        pahadanNavigate(url);
        return;
      }
      if (view === "pdp") history.replaceState(pahadanViewState(), "", url);
      else history.pushState(pahadanViewState(), "", url);
      pahadanApplyViewMeta(view);
    }
    function pahadanApplyCollectionCat(cat) {
      colCatFilter = cat || "all";
      document.querySelectorAll(".col-cat-btn").forEach(b => {
        b.className = b.getAttribute("data-col-cat") === colCatFilter
          ? "col-cat-btn px-3 py-1.5 rounded-lg text-xs font-semibold bg-[#1E2D24] text-white shrink-0"
          : "col-cat-btn px-3 py-1.5 rounded-lg text-xs font-semibold bg-white text-[#1E2D24] shrink-0";
      });
      renderCollectionProducts();
    }
    window.addEventListener("DOMContentLoaded", () => {
      // Pages opened directly: /#bundles and /#partner, and the Story / FAQ / Lab / Bundles page templates.
      const hashView = (location.hash || "").replace("#", "");
      const initial = window.PAHADAN_INITIAL_VIEW;
      if (!initial && (hashView === "bundles" || hashView === "partner")) switchView(hashView); // old /#bundles links still work
      if (initial && ["story", "support", "lab", "bundles", "partner", "journal"].includes(initial.view)) switchView(initial.view);
      // Search page: show Shop All filtered by the shopper's words.
      if (initial && initial.view === "collection" && initial.q) {
        const searchInput = document.getElementById("collection-search-input");
        colSearchQuery = initial.q;
        if (searchInput) searchInput.value = initial.q;
        renderCollectionProducts();
      }
      // Page not found: stay on the home view and say so.
      if (initial && initial.view === "notfound") showToast("Sorry, we couldn't find that page. Here's our home page instead.");
      // The homepage's own title and description (only the homepage itself knows them).
      const root = (PAHADAN_SHOP.rootUrl || "/").replace(/\/$/, "") + "/";
      if (location.pathname === root && !initial) {
        const desc = document.querySelector('meta[name="description"]');
        PAHADAN_SHOP.viewMeta = PAHADAN_SHOP.viewMeta || {};
        PAHADAN_SHOP.viewMeta.home = { title: document.title, description: desc ? desc.getAttribute("content") : "" };
      }
      history.replaceState(pahadanViewState(), "", location.href);
      _pahadanRouting = false;
    });
    window.addEventListener("popstate", (e) => {
      const s = e.state;
      if (!s || !s.pahadanView) { window.location.reload(); return; }
      _pahadanRouting = true;
      try {
        if (s.pahadanView === "pdp" && s.sku) {
          activePdpSku = s.sku;
          activePdpGalleryIdx = 0;
          pdpQty = 1;
          renderPDP();
        }
        if (s.pahadanView === "collection") pahadanApplyCollectionCat(s.cat);
        switchView(s.pahadanView);
      } finally {
        _pahadanRouting = false;
      }
      // If this view's title isn't known here, reload so the page shows its real title and tags.
      if (!pahadanApplyViewMeta(s.pahadanView)) window.location.reload();
    });
    // Shop All category buttons update the address too (e.g. /collections/ghee).
    document.addEventListener("click", (e) => {
      if (!e.target.closest(".col-cat-btn") || currentView !== "collection") return;
      setTimeout(() => {
        const url = pahadanUrlFor("collection");
        const target = new URL(url, location.origin);
        if (target.pathname !== location.pathname) {
          history.replaceState(pahadanViewState(), "", url);
          pahadanApplyViewMeta("collection");
        }
      }, 0);
    });
    // The product page's size dropdown also updates the address.
    document.addEventListener("change", (e) => {
      if (e.target && e.target.id === "pdp-sku-selector") pahadanSetUrl("pdp", "pdp");
    });
